var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitalMarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#b695e5;}.cls-5{opacity:0.5;}.cls-6{fill:#9c79d3;}.cls-7{clip-path:url(#clip-path-2);}.cls-8{fill:#4a3866;}.cls-9{fill:#6a6a89;}.cls-10{fill:#babaf4;}.cls-11{fill:#f5fcfc;}.cls-12{fill:#abc1d3;}.cls-13{fill:#697c87;}.cls-14,.cls-20{fill:#677e93;}.cls-14{opacity:0.47;}.cls-15{fill:#2a2635;}.cls-16{fill:#8599c6;}.cls-17{fill:#98a8b7;}.cls-18{fill:#f96277;}.cls-19{fill:#56566d;}.cls-21{fill:#445866;}.cls-22,.cls-23{fill:#6c7e8e;}.cls-22{opacity:0.34;}.cls-23{opacity:0.55;}.cls-24{fill:#3f3f51;}.cls-25{fill:#c6d7e5;}.cls-26{fill:#fffbf8;}.cls-27{fill:#aea3c6;}.cls-28{fill:#e5d873;}.cls-29{fill:#d3af54;}.cls-30{fill:#b28c39;}.cls-31{fill:#9b948f;}.cls-32{fill:#f9caa7;}.cls-33{fill:#fff5cc;}.cls-34{fill:#cc926a;}.cls-35{fill:#442e37;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.25,190.67c22.28-17.2,50.51-19.48,95.82-8.2,34.06,10.59,25.14,26.12,65.22,42.53,25.51,10.45,42.23,28.78,37.69,54.7-4.59,26.18-17.65,24.82-25.12,72C377,401.25,308.69,412.8,266,400.05,191.87,379,156.25,240.84,211.25,190.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.19,341.57c18.8-58.19,11.4-122-21.17-173.74-13.33-21.18-28.12-45.44-47.53-42.66C169,129.4,168.88,168,144.62,193.38S79.89,229.11,72.69,282.1C61.16,367,160,424.7,219.42,404.45,243.16,396.35,258,370.13,267.19,341.57Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 500,
    height: 500
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M211.25,190.67c22.28-17.2,50.51-19.48,95.82-8.2,34.06,10.59,25.14,26.12,65.22,42.53,25.51,10.45,42.23,28.78,37.69,54.7-4.59,26.18-17.65,24.82-25.12,72C377,401.25,308.69,412.8,266,400.05,191.87,379,156.25,240.84,211.25,190.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M292,178.73c-3.36.91-4.72-4.37-1.34-5.19S295.34,177.91,292,178.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.2,176.47c-2.87.78-4-3.74-1.14-4.44S302.09,175.77,299.2,176.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.63,174.37c-2.33.64-3.28-3-.93-3.61S308,173.81,305.63,174.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311.42,172.6a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,311.42,172.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.66,171a1.3,1.3,0,0,1-.64-2.51A1.3,1.3,0,0,1,316.66,171Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M321.29,169.42a1,1,0,0,1-.48-1.87A1,1,0,0,1,321.29,169.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M324.9,168.24a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,324.9,168.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.13,167.23a.55.55,0,0,1-.27-1.07A.55.55,0,0,1,328.13,167.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M331.05,166.32a.4.4,0,0,1-.19-.77A.4.4,0,0,1,331.05,166.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M333.71,165.51a.27.27,0,0,1-.14-.52A.27.27,0,0,1,333.71,165.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336.15,164.78a.17.17,0,1,1-.08-.34A.17.17,0,0,1,336.15,164.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M338.46,164.13c-.14,0-.2-.19-.06-.23A.12.12,0,0,1,338.46,164.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M293.89,186.21c-3.35.92-4.71-4.37-1.33-5.18S297.27,185.4,293.89,186.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M301.12,184c-2.87.78-4-3.75-1.14-4.44S304,183.26,301.12,184Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.56,181.86c-2.34.64-3.28-3-.93-3.61S309.91,181.29,307.56,181.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M313.35,180.09a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,313.35,180.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M318.59,178.44a1.3,1.3,0,0,1-.65-2.51A1.3,1.3,0,0,1,318.59,178.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M323.21,176.91a1,1,0,0,1-.48-1.87A1,1,0,0,1,323.21,176.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.83,175.73a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,326.83,175.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.06,174.72a.55.55,0,0,1-.28-1.07A.55.55,0,0,1,330.06,174.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M333,173.81a.4.4,0,0,1-.2-.77A.4.4,0,0,1,333,173.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M335.63,173c-.33.1-.47-.43-.13-.52A.27.27,0,0,1,335.63,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M338.08,172.27a.18.18,0,0,1-.09-.34A.18.18,0,0,1,338.08,172.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M340.39,171.61c-.15,0-.21-.19-.06-.22S340.53,171.58,340.39,171.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M295.82,193.7c-3.36.92-4.72-4.37-1.34-5.19S299.19,192.89,295.82,193.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.05,191.44c-2.87.78-4-3.74-1.14-4.44S305.94,190.74,303.05,191.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M309.48,189.35c-2.33.63-3.28-3-.93-3.61S311.83,188.78,309.48,189.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M315.27,187.57a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,315.27,187.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M320.51,185.93a1.3,1.3,0,0,1-.64-2.52A1.3,1.3,0,0,1,320.51,185.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M325.14,184.39a1,1,0,0,1-.48-1.87A1,1,0,0,1,325.14,184.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.75,183.21a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,328.75,183.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332,182.21a.55.55,0,0,1-.27-1.07A.55.55,0,0,1,332,182.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M334.9,181.29a.39.39,0,0,1-.19-.76A.39.39,0,0,1,334.9,181.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M337.56,180.48a.27.27,0,0,1-.14-.52A.27.27,0,0,1,337.56,180.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M340,179.76a.18.18,0,0,1-.08-.35A.18.18,0,0,1,340,179.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.31,179.1c-.14,0-.2-.19-.06-.22A.11.11,0,1,1,342.31,179.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.74,201.19c-3.35.91-4.71-4.37-1.33-5.19S301.12,200.37,297.74,201.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305,198.93c-2.87.78-4-3.74-1.14-4.44S307.86,198.23,305,198.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311.41,196.83c-2.34.64-3.28-3-.93-3.61S313.76,196.26,311.41,196.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M317.2,195.06a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,317.2,195.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M322.44,193.41a1.3,1.3,0,0,1-.65-2.51A1.3,1.3,0,0,1,322.44,193.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M327.06,191.88a1,1,0,0,1-.48-1.87A1,1,0,0,1,327.06,191.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.68,190.7a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,330.68,190.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M333.91,189.69a.55.55,0,0,1-.28-1.07A.55.55,0,0,1,333.91,189.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336.83,188.78a.4.4,0,0,1-.2-.77A.4.4,0,0,1,336.83,188.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.48,188a.27.27,0,0,1-.13-.52A.27.27,0,0,1,339.48,188Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M341.93,187.24a.18.18,0,0,1-.09-.34A.18.18,0,0,1,341.93,187.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M344.24,186.59a.12.12,0,0,1-.06-.23C344.32,186.32,344.38,186.55,344.24,186.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.67,208.67c-3.36.92-4.72-4.37-1.34-5.18S303,207.86,299.67,208.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M306.9,206.41c-2.87.79-4-3.74-1.14-4.43S309.79,205.72,306.9,206.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M313.33,204.32c-2.33.63-3.28-3-.93-3.61S315.68,203.75,313.33,204.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M319.12,202.55a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,319.12,202.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M324.36,200.9a1.3,1.3,0,0,1-.64-2.52A1.3,1.3,0,0,1,324.36,200.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329,199.37a1,1,0,0,1-.48-1.87A1,1,0,0,1,329,199.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.6,198.18a.72.72,0,0,1-.36-1.39A.72.72,0,0,1,332.6,198.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M335.83,197.18a.55.55,0,0,1-.27-1.07A.55.55,0,0,1,335.83,197.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M338.75,196.27a.4.4,0,0,1-.19-.77A.4.4,0,0,1,338.75,196.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M341.41,195.45a.27.27,0,0,1-.14-.52A.27.27,0,0,1,341.41,195.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M343.85,194.73a.17.17,0,0,1-.08-.34A.17.17,0,0,1,343.85,194.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M346.16,194.07c-.14,0-.2-.19-.06-.22S346.31,194,346.16,194.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M301.59,216.16c-3.35.91-4.71-4.37-1.33-5.19S305,215.34,301.59,216.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M308.82,213.9c-2.87.78-4-3.74-1.14-4.44S311.71,213.2,308.82,213.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M315.26,211.8c-2.34.64-3.28-3-.93-3.6S317.6,211.24,315.26,211.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M321.05,210a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,321.05,210Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.29,208.39a1.3,1.3,0,0,1-.65-2.52A1.3,1.3,0,0,1,326.29,208.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.91,206.85a1,1,0,0,1-.48-1.87A1,1,0,0,1,330.91,206.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M334.53,205.67a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,334.53,205.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M337.76,204.67a.55.55,0,0,1-.28-1.07A.55.55,0,0,1,337.76,204.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M340.68,203.75a.39.39,0,0,1-.2-.76A.39.39,0,0,1,340.68,203.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M343.33,202.94a.27.27,0,0,1-.13-.52A.27.27,0,0,1,343.33,202.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M345.78,202.22a.18.18,0,0,1-.09-.35A.18.18,0,0,1,345.78,202.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.09,201.56c-.15,0-.21-.19-.06-.22A.11.11,0,0,1,348.09,201.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.52,223.65c-3.36.91-4.72-4.38-1.34-5.19S306.89,222.83,303.52,223.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M310.75,221.39c-2.87.78-4-3.74-1.14-4.44S313.64,220.69,310.75,221.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M317.18,219.29c-2.33.64-3.28-3-.93-3.61S319.53,218.72,317.18,219.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M323,217.52a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,323,217.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.21,215.87a1.3,1.3,0,0,1-.64-2.51A1.3,1.3,0,0,1,328.21,215.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.84,214.34a1,1,0,0,1-.48-1.87A1,1,0,0,1,332.84,214.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336.45,213.16a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,336.45,213.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.68,212.15a.55.55,0,0,1-.27-1.07A.55.55,0,0,1,339.68,212.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.6,211.24a.4.4,0,0,1-.19-.77A.4.4,0,0,1,342.6,211.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M345.26,210.43a.27.27,0,0,1-.14-.52A.27.27,0,0,1,345.26,210.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M347.7,209.7a.17.17,0,0,1-.08-.34A.17.17,0,0,1,347.7,209.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M350,209.05a.12.12,0,0,1-.06-.23A.12.12,0,0,1,350,209.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.44,231.13c-3.35.92-4.71-4.37-1.33-5.18S308.82,230.32,305.44,231.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M312.67,228.87c-2.87.79-4-3.74-1.14-4.43S315.56,228.18,312.67,228.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M319.1,226.78c-2.33.63-3.27-3-.92-3.61S321.45,226.21,319.1,226.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M324.9,225a1.59,1.59,0,0,1-.8-3.08A1.59,1.59,0,0,1,324.9,225Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.14,223.36a1.3,1.3,0,0,1-.65-2.52A1.3,1.3,0,0,1,330.14,223.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M334.76,221.83a1,1,0,0,1-.48-1.88A1,1,0,0,1,334.76,221.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M338.38,220.64a.72.72,0,0,1-.36-1.39A.72.72,0,0,1,338.38,220.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M341.61,219.64a.55.55,0,0,1-.28-1.07A.55.55,0,0,1,341.61,219.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M344.53,218.73a.4.4,0,0,1-.2-.77A.4.4,0,0,1,344.53,218.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M347.18,217.91a.27.27,0,0,1-.13-.52A.27.27,0,0,1,347.18,217.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M349.63,217.19a.18.18,0,0,1-.09-.34A.18.18,0,0,1,349.63,217.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M351.94,216.53c-.15,0-.21-.19-.06-.22S352.08,216.5,351.94,216.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.37,238.62c-3.36.91-4.72-4.37-1.34-5.19S310.74,237.8,307.37,238.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M314.6,236.36c-2.87.78-4-3.74-1.14-4.44S317.49,235.66,314.6,236.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M321,234.26c-2.33.64-3.28-3-.93-3.6S323.38,233.7,321,234.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.82,232.49a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,326.82,232.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.06,230.84a1.3,1.3,0,0,1-.65-2.51A1.3,1.3,0,0,1,332.06,230.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336.69,229.31a1,1,0,0,1-.48-1.87A1,1,0,0,1,336.69,229.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M340.3,228.13a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,340.3,228.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M343.53,227.13a.56.56,0,0,1-.27-1.08A.56.56,0,0,1,343.53,227.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M346.45,226.21a.39.39,0,0,1-.19-.76A.39.39,0,0,1,346.45,226.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M349.1,225.4a.27.27,0,0,1-.13-.52A.27.27,0,0,1,349.1,225.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M351.55,224.67a.17.17,0,1,1-.08-.34A.17.17,0,0,1,351.55,224.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M353.86,224c-.14,0-.2-.19-.06-.23A.12.12,0,0,1,353.86,224Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M309.29,246.11c-3.35.91-4.71-4.38-1.33-5.19S312.67,245.29,309.29,246.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.52,243.85c-2.87.78-4-3.74-1.14-4.44S319.41,243.15,316.52,243.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M323,241.75c-2.33.64-3.27-3-.92-3.61S325.3,241.18,323,241.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.75,240a1.59,1.59,0,0,1-.8-3.08A1.59,1.59,0,0,1,328.75,240Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M334,238.33a1.3,1.3,0,0,1-.65-2.51A1.3,1.3,0,0,1,334,238.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M338.61,236.8a1,1,0,0,1-.48-1.87A1,1,0,0,1,338.61,236.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.23,235.62a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,342.23,235.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M345.46,234.61a.55.55,0,0,1-.28-1.07A.55.55,0,0,1,345.46,234.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.38,233.7a.4.4,0,0,1-.2-.77A.4.4,0,0,1,348.38,233.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M351,232.89a.27.27,0,0,1-.13-.52C351.23,232.27,351.37,232.8,351,232.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M353.48,232.16a.18.18,0,0,1-.09-.34A.18.18,0,0,1,353.48,232.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M355.79,231.5a.11.11,0,1,1-.06-.22C355.87,231.24,355.93,231.47,355.79,231.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311.22,253.59c-3.36.92-4.72-4.37-1.34-5.19S314.59,252.78,311.22,253.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M318.45,251.33c-2.87.79-4-3.74-1.14-4.44S321.34,250.64,318.45,251.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M324.88,249.24c-2.33.63-3.28-3-.93-3.61S327.23,248.67,324.88,249.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.67,247.47a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,330.67,247.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M335.91,245.82a1.3,1.3,0,0,1-.65-2.52A1.3,1.3,0,0,1,335.91,245.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M340.54,244.29a1,1,0,0,1-.48-1.88A1,1,0,0,1,340.54,244.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M344.15,243.1a.72.72,0,0,1-.36-1.39A.72.72,0,0,1,344.15,243.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M347.38,242.1a.55.55,0,0,1-.27-1.07A.55.55,0,0,1,347.38,242.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M350.3,241.18a.39.39,0,0,1-.19-.76A.39.39,0,0,1,350.3,241.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M353,240.37a.27.27,0,0,1-.13-.52A.27.27,0,0,1,353,240.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M355.4,239.65a.17.17,0,0,1-.08-.34A.17.17,0,1,1,355.4,239.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M357.71,239c-.14,0-.2-.19-.06-.22S357.86,239,357.71,239Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M313.14,261.08c-3.35.91-4.71-4.37-1.33-5.19S316.52,260.26,313.14,261.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M320.37,258.82c-2.87.78-4-3.74-1.14-4.44S323.26,258.12,320.37,258.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.8,256.72c-2.33.64-3.27-3-.92-3.61S329.15,256.16,326.8,256.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.6,255a1.59,1.59,0,0,1-.8-3.08A1.59,1.59,0,0,1,332.6,255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M337.84,253.3a1.3,1.3,0,0,1-.65-2.51A1.3,1.3,0,0,1,337.84,253.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.46,251.77a1,1,0,0,1-.48-1.87A1,1,0,0,1,342.46,251.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M346.08,250.59a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,346.08,250.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M349.31,249.58a.55.55,0,0,1-.28-1.07A.55.55,0,0,1,349.31,249.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M352.23,248.67a.39.39,0,0,1-.2-.76A.39.39,0,0,1,352.23,248.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M354.88,247.86a.27.27,0,0,1-.13-.52A.27.27,0,0,1,354.88,247.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M357.33,247.13a.18.18,0,0,1-.09-.34A.18.18,0,0,1,357.33,247.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M359.64,246.48a.12.12,0,0,1-.06-.23C359.72,246.21,359.78,246.44,359.64,246.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M315.06,268.57c-3.35.91-4.71-4.38-1.33-5.19S318.44,267.75,315.06,268.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M322.3,266.31c-2.87.78-4-3.74-1.14-4.44S325.19,265.61,322.3,266.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.73,264.21c-2.33.64-3.28-3-.93-3.61S331.08,263.64,328.73,264.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M334.52,262.44a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,334.52,262.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.76,260.79a1.3,1.3,0,0,1-.65-2.51A1.3,1.3,0,0,1,339.76,260.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M344.39,259.26a1,1,0,0,1-.48-1.87A1,1,0,0,1,344.39,259.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348,258.08a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,348,258.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M351.23,257.07A.55.55,0,0,1,351,256,.55.55,0,0,1,351.23,257.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M354.15,256.16a.4.4,0,0,1-.19-.77A.4.4,0,0,1,354.15,256.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M356.8,255.34a.26.26,0,0,1-.13-.51A.26.26,0,1,1,356.8,255.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M359.25,254.62a.17.17,0,0,1-.08-.34A.17.17,0,0,1,359.25,254.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M361.56,254a.11.11,0,0,1-.06-.22C361.65,253.7,361.71,253.93,361.56,254Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M317,276.05c-3.35.92-4.71-4.37-1.33-5.19S320.37,275.24,317,276.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M324.22,273.79c-2.87.79-4-3.74-1.14-4.44S327.11,273.09,324.22,273.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.65,271.7c-2.33.63-3.27-3-.92-3.61S333,271.13,330.65,271.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336.45,269.93a1.59,1.59,0,0,1-.8-3.08A1.59,1.59,0,0,1,336.45,269.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M341.69,268.28a1.3,1.3,0,0,1-.65-2.52A1.3,1.3,0,0,1,341.69,268.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M346.31,266.74a1,1,0,0,1-.48-1.87A1,1,0,0,1,346.31,266.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M349.93,265.56a.72.72,0,0,1-.36-1.39A.72.72,0,0,1,349.93,265.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M353.16,264.56a.55.55,0,0,1-.28-1.07A.55.55,0,0,1,353.16,264.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M356.08,263.64a.39.39,0,0,1-.2-.76A.39.39,0,0,1,356.08,263.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M358.73,262.83a.27.27,0,0,1-.13-.52A.27.27,0,0,1,358.73,262.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M361.18,262.11a.18.18,0,0,1-.09-.34C361.31,261.7,361.4,262.05,361.18,262.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M363.49,261.45c-.15,0-.21-.19-.06-.22S363.63,261.42,363.49,261.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M318.91,283.54c-3.35.91-4.71-4.37-1.33-5.19S322.29,282.72,318.91,283.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.15,281.28c-2.87.78-4-3.74-1.14-4.44S329,280.58,326.15,281.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.58,279.18c-2.33.64-3.28-3-.93-3.61S334.93,278.62,332.58,279.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M338.37,277.41a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,338.37,277.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M343.61,275.76a1.3,1.3,0,0,1-.65-2.51A1.3,1.3,0,0,1,343.61,275.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.24,274.23a1,1,0,0,1-.49-1.87A1,1,0,0,1,348.24,274.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M351.85,273.05a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,351.85,273.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M355.08,272a.55.55,0,0,1-.27-1.07A.55.55,0,0,1,355.08,272Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M358,271.13a.4.4,0,0,1-.19-.77A.4.4,0,0,1,358,271.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M360.65,270.32a.27.27,0,0,1-.13-.52A.27.27,0,0,1,360.65,270.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M363.1,269.59a.18.18,0,0,1-.09-.34A.18.18,0,1,1,363.1,269.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M365.41,268.94c-.14,0-.2-.19-.06-.23A.12.12,0,0,1,365.41,268.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M320.84,291c-3.35.92-4.71-4.37-1.33-5.18S324.22,290.21,320.84,291Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.07,288.77c-2.87.78-4-3.75-1.14-4.44S331,288.07,328.07,288.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M334.5,286.67c-2.33.63-3.27-3-.92-3.61S336.85,286.1,334.5,286.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M340.3,284.9a1.59,1.59,0,0,1-.8-3.08A1.59,1.59,0,0,1,340.3,284.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M345.54,283.25a1.3,1.3,0,0,1-.65-2.51A1.3,1.3,0,0,1,345.54,283.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M350.16,281.72a1,1,0,0,1-.48-1.87A1,1,0,0,1,350.16,281.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M353.77,280.54a.72.72,0,0,1-.35-1.4A.72.72,0,0,1,353.77,280.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M357,279.53a.55.55,0,0,1-.28-1.07A.55.55,0,0,1,357,279.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M359.93,278.62a.4.4,0,0,1-.2-.77A.4.4,0,0,1,359.93,278.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M362.58,277.8c-.34.1-.47-.43-.13-.52A.27.27,0,0,1,362.58,277.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M365,277.08a.18.18,0,0,1-.09-.34A.18.18,0,0,1,365,277.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M367.34,276.42c-.15,0-.21-.19-.06-.22S367.48,276.39,367.34,276.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M322.76,298.51c-3.35.92-4.71-4.37-1.33-5.19S326.14,297.69,322.76,298.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330,296.25c-2.87.78-4-3.74-1.14-4.44S332.89,295.55,330,296.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336.43,294.16c-2.33.63-3.28-3.05-.93-3.61S338.78,293.59,336.43,294.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.22,292.38a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,342.22,292.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M347.46,290.74a1.3,1.3,0,0,1-.65-2.52A1.3,1.3,0,0,1,347.46,290.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M352.09,289.2a1,1,0,0,1-.49-1.87A1,1,0,0,1,352.09,289.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M355.7,288a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,355.7,288Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M358.93,287a.55.55,0,0,1-.27-1.07A.55.55,0,0,1,358.93,287Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M361.85,286.1a.39.39,0,0,1-.19-.76A.39.39,0,0,1,361.85,286.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M364.5,285.29a.27.27,0,0,1-.13-.52A.27.27,0,0,1,364.5,285.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M367,284.57a.18.18,0,0,1-.09-.35A.18.18,0,0,1,367,284.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M369.26,283.91c-.14,0-.2-.19-.06-.22A.11.11,0,1,1,369.26,283.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M324.69,306c-3.35.91-4.71-4.37-1.33-5.19S328.07,305.18,324.69,306Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M331.92,303.74c-2.87.78-4-3.74-1.14-4.44S334.81,303,331.92,303.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M338.35,301.64c-2.33.64-3.27-3-.92-3.61S340.7,301.07,338.35,301.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M344.15,299.87a1.59,1.59,0,0,1-.8-3.08A1.59,1.59,0,0,1,344.15,299.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M349.39,298.22a1.3,1.3,0,0,1-.65-2.51A1.3,1.3,0,0,1,349.39,298.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M354,296.69a1,1,0,0,1-.48-1.87A1,1,0,0,1,354,296.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M357.62,295.51a.72.72,0,0,1-.35-1.4A.72.72,0,0,1,357.62,295.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M360.86,294.5a.55.55,0,0,1-.28-1.07A.55.55,0,0,1,360.86,294.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M363.78,293.59a.4.4,0,0,1-.2-.77A.4.4,0,0,1,363.78,293.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M366.43,292.78a.27.27,0,0,1-.13-.52A.27.27,0,0,1,366.43,292.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M368.88,292.05a.18.18,0,0,1-.09-.34A.18.18,0,0,1,368.88,292.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M371.19,291.4a.12.12,0,0,1-.06-.23C371.27,291.13,371.33,291.36,371.19,291.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.61,313.48c-3.35.92-4.71-4.37-1.33-5.18S330,312.67,326.61,313.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M333.85,311.22c-2.87.79-4-3.74-1.14-4.43S336.74,310.53,333.85,311.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M340.28,309.13c-2.33.63-3.28-3-.93-3.61S342.63,308.56,340.28,309.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M346.07,307.36a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,346.07,307.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M351.31,305.71a1.3,1.3,0,0,1-.65-2.52A1.3,1.3,0,0,1,351.31,305.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M355.94,304.18a1,1,0,0,1-.49-1.87A1,1,0,0,1,355.94,304.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M359.55,303a.72.72,0,0,1-.36-1.39A.72.72,0,0,1,359.55,303Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M362.78,302a.55.55,0,0,1-.27-1.07A.55.55,0,0,1,362.78,302Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M365.7,301.08a.4.4,0,0,1-.19-.77A.4.4,0,0,1,365.7,301.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M368.35,300.26a.27.27,0,0,1-.13-.52A.27.27,0,0,1,368.35,300.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M370.8,299.54a.18.18,0,0,1-.09-.34A.18.18,0,0,1,370.8,299.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M373.11,298.88c-.14,0-.2-.19-.06-.22S373.26,298.85,373.11,298.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.54,321c-3.35.91-4.71-4.37-1.33-5.19S331.92,320.15,328.54,321Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M335.77,318.71c-2.87.78-4-3.74-1.14-4.44S338.66,318,335.77,318.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.2,316.61c-2.33.64-3.27-3-.92-3.6S344.55,316.05,342.2,316.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348,314.84a1.59,1.59,0,0,1-.8-3.08A1.59,1.59,0,0,1,348,314.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M353.23,313.19a1.3,1.3,0,0,1-.64-2.51A1.3,1.3,0,0,1,353.23,313.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M357.86,311.66a1,1,0,0,1-.48-1.87A1,1,0,0,1,357.86,311.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M361.47,310.48a.72.72,0,0,1-.35-1.4A.72.72,0,0,1,361.47,310.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M364.71,309.48a.55.55,0,0,1-.28-1.07A.55.55,0,0,1,364.71,309.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M367.63,308.56a.39.39,0,0,1-.2-.76A.39.39,0,0,1,367.63,308.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M370.28,307.75a.27.27,0,0,1-.13-.52A.27.27,0,0,1,370.28,307.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M372.73,307a.18.18,0,0,1-.09-.35A.18.18,0,0,1,372.73,307Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M375,306.37a.11.11,0,0,1,0-.22A.11.11,0,1,1,375,306.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.46,328.46c-3.35.91-4.71-4.38-1.33-5.19S333.84,327.64,330.46,328.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M337.7,326.2c-2.87.78-4-3.74-1.14-4.44S340.59,325.5,337.7,326.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M344.13,324.1c-2.33.64-3.28-3-.93-3.61S346.48,323.53,344.13,324.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M349.92,322.33a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,349.92,322.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M355.16,320.68a1.3,1.3,0,0,1-.65-2.51A1.3,1.3,0,0,1,355.16,320.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M359.79,319.15a1,1,0,0,1-.49-1.87A1,1,0,0,1,359.79,319.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M363.4,318a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,363.4,318Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M366.63,317a.55.55,0,0,1-.27-1.07A.55.55,0,0,1,366.63,317Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M369.55,316.05a.4.4,0,0,1-.19-.77A.4.4,0,0,1,369.55,316.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M372.2,315.24a.27.27,0,0,1-.13-.52A.27.27,0,0,1,372.2,315.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M374.65,314.51a.18.18,0,0,1-.09-.34A.18.18,0,0,1,374.65,314.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M377,313.86a.12.12,0,0,1-.06-.23C377.05,313.59,377.1,313.82,377,313.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.39,335.94c-3.35.92-4.71-4.37-1.33-5.19S335.77,335.13,332.39,335.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.62,333.68c-2.87.79-4-3.74-1.14-4.43S342.51,333,339.62,333.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M346.05,331.59c-2.33.63-3.27-3-.92-3.61S348.4,331,346.05,331.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M351.84,329.82a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,351.84,329.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M357.08,328.17a1.3,1.3,0,0,1-.64-2.52A1.3,1.3,0,0,1,357.08,328.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M361.71,326.64a1,1,0,0,1-.48-1.88A1,1,0,0,1,361.71,326.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M365.32,325.45a.72.72,0,0,1-.35-1.39A.72.72,0,0,1,365.32,325.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M368.56,324.45a.55.55,0,0,1-.28-1.07A.55.55,0,0,1,368.56,324.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M371.48,323.54a.4.4,0,0,1-.2-.77A.4.4,0,0,1,371.48,323.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M374.13,322.72a.27.27,0,0,1-.13-.52A.27.27,0,0,1,374.13,322.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M376.58,322a.18.18,0,0,1-.09-.34A.18.18,0,0,1,376.58,322Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M378.88,321.34a.11.11,0,0,1-.05-.22A.11.11,0,0,1,378.88,321.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M334.31,343.43c-3.35.91-4.71-4.37-1.33-5.19S337.69,342.61,334.31,343.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M341.55,341.17c-2.87.78-4-3.74-1.14-4.44S344.44,340.47,341.55,341.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348,339.07c-2.33.64-3.28-3-.93-3.6S350.33,338.51,348,339.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M353.77,337.3a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,353.77,337.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M359,335.65a1.3,1.3,0,0,1-.65-2.51A1.3,1.3,0,0,1,359,335.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M363.64,334.12a1,1,0,0,1-.49-1.87A1,1,0,0,1,363.64,334.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M367.25,332.94a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,367.25,332.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M370.48,331.94a.56.56,0,0,1-.27-1.08A.56.56,0,0,1,370.48,331.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M373.4,331a.39.39,0,0,1-.19-.76A.39.39,0,0,1,373.4,331Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M376.05,330.21a.27.27,0,0,1-.13-.52A.27.27,0,0,1,376.05,330.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M378.5,329.48a.18.18,0,0,1-.09-.34A.18.18,0,0,1,378.5,329.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M380.81,328.83c-.14,0-.2-.19-.06-.23A.12.12,0,0,1,380.81,328.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336.24,350.92c-3.35.91-4.71-4.38-1.33-5.19S339.62,350.1,336.24,350.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M343.47,348.66c-2.87.78-4-3.74-1.14-4.44S346.36,348,343.47,348.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M349.9,346.56c-2.33.64-3.27-3-.92-3.61S352.25,346,349.9,346.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M355.69,344.79a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,355.69,344.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M360.93,343.14a1.3,1.3,0,0,1-.64-2.51A1.3,1.3,0,0,1,360.93,343.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M365.56,341.61a1,1,0,0,1-.48-1.87A1,1,0,0,1,365.56,341.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M369.17,340.43a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,369.17,340.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M372.41,339.42a.55.55,0,0,1-.28-1.07A.55.55,0,0,1,372.41,339.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M375.33,338.51a.4.4,0,0,1-.2-.77A.4.4,0,0,1,375.33,338.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M378,337.69a.26.26,0,0,1-.14-.51A.26.26,0,0,1,378,337.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M380.43,337a.18.18,0,0,1-.09-.34A.18.18,0,0,1,380.43,337Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M382.73,336.31a.11.11,0,1,1-.05-.22A.11.11,0,0,1,382.73,336.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M338.16,358.4c-3.35.92-4.71-4.37-1.33-5.19S341.54,357.59,338.16,358.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M345.4,356.14c-2.87.79-4-3.74-1.15-4.44S348.29,355.45,345.4,356.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M351.83,354.05c-2.33.63-3.28-3-.93-3.61S354.18,353.48,351.83,354.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M357.62,352.28a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,357.62,352.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M362.86,350.63a1.3,1.3,0,0,1-.65-2.52A1.3,1.3,0,0,1,362.86,350.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M367.48,349.1a1,1,0,0,1-.48-1.88A1,1,0,0,1,367.48,349.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M371.1,347.91a.72.72,0,0,1-.36-1.39A.72.72,0,0,1,371.1,347.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M374.33,346.91a.55.55,0,0,1-.27-1.07A.55.55,0,0,1,374.33,346.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M377.25,346a.39.39,0,0,1-.2-.76A.39.39,0,0,1,377.25,346Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M379.9,345.18a.27.27,0,0,1-.13-.52A.27.27,0,0,1,379.9,345.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M382.35,344.46a.18.18,0,0,1-.09-.34A.18.18,0,0,1,382.35,344.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M384.66,343.8c-.14,0-.2-.19-.06-.22A.11.11,0,0,1,384.66,343.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M340.09,365.89c-3.35.91-4.71-4.37-1.34-5.19S343.47,365.07,340.09,365.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M347.32,363.63c-2.87.78-4-3.74-1.14-4.44S350.21,362.93,347.32,363.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M353.75,361.53c-2.33.64-3.27-3-.92-3.61S356.1,361,353.75,361.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M359.54,359.76a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,359.54,359.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M364.78,358.11a1.3,1.3,0,0,1-.64-2.51A1.3,1.3,0,0,1,364.78,358.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M369.41,356.58a1,1,0,0,1-.48-1.87A1,1,0,0,1,369.41,356.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M373,355.4a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,373,355.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M376.26,354.39a.55.55,0,0,1-.28-1.07A.55.55,0,0,1,376.26,354.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M379.18,353.48a.39.39,0,0,1-.2-.76A.39.39,0,0,1,379.18,353.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M381.83,352.67a.27.27,0,0,1-.14-.52A.27.27,0,0,1,381.83,352.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M384.28,351.94a.18.18,0,0,1-.09-.34A.18.18,0,0,1,384.28,351.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M386.58,351.29c-.14,0-.2-.19-.05-.23S386.73,351.25,386.58,351.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342,373.37c-3.35.92-4.71-4.37-1.33-5.18S345.39,372.56,342,373.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M349.25,371.12c-2.87.78-4-3.74-1.15-4.44S352.14,370.42,349.25,371.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M355.68,369c-2.33.64-3.28-3-.93-3.61S358,368.45,355.68,369Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M361.47,367.25a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,361.47,367.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M366.71,365.6a1.3,1.3,0,0,1-.65-2.51A1.3,1.3,0,0,1,366.71,365.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M371.33,364.07a1,1,0,0,1-.48-1.87A1,1,0,0,1,371.33,364.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M375,362.89a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,375,362.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M378.18,361.88a.55.55,0,0,1-.27-1.07A.55.55,0,0,1,378.18,361.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M381.1,361a.4.4,0,0,1-.2-.77A.4.4,0,0,1,381.1,361Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M383.75,360.15a.26.26,0,0,1-.13-.51A.26.26,0,0,1,383.75,360.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M386.2,359.43a.18.18,0,0,1-.09-.34A.18.18,0,0,1,386.2,359.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M388.51,358.77a.11.11,0,0,1-.06-.22A.11.11,0,0,1,388.51,358.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M343.94,380.86c-3.35.92-4.71-4.37-1.34-5.19S347.32,380.05,343.94,380.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M351.17,378.6c-2.87.79-4-3.74-1.14-4.44S354.06,377.9,351.17,378.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M357.6,376.51c-2.33.63-3.27-3-.92-3.61S360,375.94,357.6,376.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M363.39,374.74a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,363.39,374.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M368.63,373.09a1.3,1.3,0,0,1-.64-2.52A1.3,1.3,0,0,1,368.63,373.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M373.26,371.55a1,1,0,0,1-.48-1.87A1,1,0,0,1,373.26,371.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M376.87,370.37a.72.72,0,0,1-.36-1.39A.72.72,0,0,1,376.87,370.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M380.11,369.37a.55.55,0,0,1-.28-1.07A.55.55,0,0,1,380.11,369.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M383,368.45a.39.39,0,0,1-.2-.76A.39.39,0,0,1,383,368.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M385.68,367.64a.27.27,0,0,1-.14-.52A.27.27,0,0,1,385.68,367.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M388.13,366.92a.18.18,0,0,1-.09-.34C388.26,366.51,388.35,366.86,388.13,366.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M390.43,366.26a.11.11,0,0,1-.05-.22A.11.11,0,0,1,390.43,366.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M345.86,388.35c-3.35.91-4.71-4.37-1.33-5.19S349.24,387.53,345.86,388.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M353.1,386.09c-2.87.78-4-3.74-1.15-4.44S356,385.39,353.1,386.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M359.53,384c-2.33.64-3.28-3-.93-3.61S361.88,383.43,359.53,384Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M365.32,382.22a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,365.32,382.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M370.56,380.57a1.3,1.3,0,0,1-.65-2.51A1.3,1.3,0,0,1,370.56,380.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M375.18,379a1,1,0,0,1-.48-1.87A1,1,0,0,1,375.18,379Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M378.8,377.86a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,378.8,377.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M382,376.85a.55.55,0,0,1-.27-1.07A.55.55,0,0,1,382,376.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M385,375.94a.4.4,0,0,1-.2-.77A.4.4,0,0,1,385,375.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M387.6,375.13a.27.27,0,0,1-.13-.52A.27.27,0,0,1,387.6,375.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M390.05,374.4a.18.18,0,0,1-.09-.34A.18.18,0,0,1,390.05,374.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M392.36,373.75c-.15,0-.2-.19-.06-.23S392.5,373.71,392.36,373.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M347.79,395.83c-3.35.92-4.71-4.37-1.34-5.18S351.17,395,347.79,395.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M355,393.58c-2.87.78-4-3.75-1.14-4.44S357.91,392.88,355,393.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M361.45,391.48c-2.33.63-3.27-3-.93-3.61S363.8,390.91,361.45,391.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M367.24,389.71a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,367.24,389.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M372.48,388.06a1.3,1.3,0,0,1-.64-2.51A1.3,1.3,0,0,1,372.48,388.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M377.11,386.53a1,1,0,0,1-.48-1.87A1,1,0,0,1,377.11,386.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M380.72,385.35a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,380.72,385.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M384,384.34a.55.55,0,0,1-.28-1.07A.55.55,0,0,1,384,384.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M386.88,383.43a.4.4,0,0,1-.2-.77A.4.4,0,0,1,386.88,383.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M389.53,382.61a.27.27,0,0,1-.14-.52A.27.27,0,0,1,389.53,382.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M392,381.89a.18.18,0,0,1-.09-.34A.18.18,0,0,1,392,381.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M394.28,381.23a.11.11,0,0,1,0-.22A.11.11,0,0,1,394.28,381.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M349.71,403.32c-3.35.92-4.71-4.37-1.33-5.19S353.09,402.5,349.71,403.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M357,401.06c-2.87.78-4-3.74-1.15-4.44S359.84,400.36,357,401.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M363.38,399c-2.33.63-3.28-3.05-.93-3.61S365.73,398.4,363.38,399Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M369.17,397.19a1.59,1.59,0,0,1-.79-3.08A1.59,1.59,0,0,1,369.17,397.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M374.41,395.55a1.3,1.3,0,0,1-.65-2.52A1.3,1.3,0,0,1,374.41,395.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M379,394a1,1,0,0,1-.48-1.87A1,1,0,0,1,379,394Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M382.65,392.83a.72.72,0,0,1-.36-1.4A.72.72,0,0,1,382.65,392.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M385.88,391.83a.55.55,0,0,1-.27-1.07A.55.55,0,0,1,385.88,391.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M388.8,390.91a.39.39,0,0,1-.2-.76A.39.39,0,0,1,388.8,390.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M391.45,390.1a.27.27,0,0,1-.13-.52A.27.27,0,0,1,391.45,390.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M393.9,389.38a.18.18,0,0,1-.09-.35A.18.18,0,0,1,393.9,389.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M396.21,388.72a.11.11,0,0,1-.06-.22A.11.11,0,0,1,396.21,388.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M340.08,400.27c3.35-.92,4.71,4.37,1.33,5.18S336.7,401.08,340.08,400.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.85,402.53c2.87-.79,4,3.74,1.14,4.43S330,403.22,332.85,402.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.41,404.62c2.34-.63,3.28,3,.93,3.61S324.07,405.19,326.41,404.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M320.62,406.39a1.59,1.59,0,0,1,.8,3.08A1.59,1.59,0,0,1,320.62,406.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M315.38,408a1.3,1.3,0,0,1,.65,2.52A1.3,1.3,0,0,1,315.38,408Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M310.76,409.57a1,1,0,0,1,.48,1.87A1,1,0,0,1,310.76,409.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.14,410.76a.72.72,0,0,1,.36,1.39A.72.72,0,0,1,307.14,410.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.91,411.76a.55.55,0,0,1,.28,1.07A.55.55,0,0,1,303.91,411.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M301,412.67a.4.4,0,0,1,.2.77A.4.4,0,0,1,301,412.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298.34,413.49a.27.27,0,0,1,.13.52A.27.27,0,0,1,298.34,413.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M295.89,414.21a.18.18,0,0,1,.09.34A.18.18,0,0,1,295.89,414.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M293.58,414.87c.15,0,.21.19.06.22S293.44,414.9,293.58,414.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M338.15,392.78c3.36-.91,4.72,4.37,1.34,5.19S334.78,393.6,338.15,392.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.92,395c2.87-.78,4,3.74,1.14,4.44S328,395.74,330.92,395Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M324.49,397.14c2.33-.64,3.28,3,.93,3.6S322.14,397.7,324.49,397.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M318.7,398.91a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,318.7,398.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M313.46,400.56a1.3,1.3,0,0,1,.65,2.51A1.3,1.3,0,0,1,313.46,400.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M308.83,402.09a1,1,0,0,1,.48,1.87A1,1,0,0,1,308.83,402.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.22,403.27a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,305.22,403.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M302,404.27a.56.56,0,0,1,.27,1.08A.56.56,0,0,1,302,404.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.07,405.19a.39.39,0,0,1,.19.76A.39.39,0,0,1,299.07,405.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M296.41,406a.27.27,0,0,1,.14.52A.27.27,0,0,1,296.41,406Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294,406.73c.22-.07.31.28.08.34A.17.17,0,0,1,294,406.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.66,407.38c.14,0,.2.19.06.22A.11.11,0,1,1,291.66,407.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336.23,385.29c3.35-.91,4.71,4.38,1.33,5.19S332.85,386.11,336.23,385.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329,387.55c2.87-.78,4,3.74,1.14,4.44S326.11,388.25,329,387.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M322.57,389.65c2.33-.64,3.27,3,.92,3.61S320.22,390.22,322.57,389.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.77,391.42a1.59,1.59,0,0,1,.8,3.08A1.59,1.59,0,0,1,316.77,391.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311.53,393.07a1.3,1.3,0,0,1,.65,2.51A1.3,1.3,0,0,1,311.53,393.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M306.91,394.6a1,1,0,0,1,.48,1.87A1,1,0,0,1,306.91,394.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.29,395.78a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,303.29,395.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M300.06,396.79a.55.55,0,0,1,.28,1.07A.55.55,0,0,1,300.06,396.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.14,397.7a.4.4,0,0,1,.2.77A.4.4,0,0,1,297.14,397.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.49,398.51a.27.27,0,0,1,.13.52C294.29,399.13,294.15,398.6,294.49,398.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M292,399.24a.18.18,0,0,1,.09.34A.18.18,0,0,1,292,399.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M289.73,399.9a.11.11,0,1,1,.06.22C289.65,400.16,289.59,399.93,289.73,399.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M334.3,377.81c3.36-.92,4.72,4.37,1.34,5.19S330.93,378.62,334.3,377.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M327.07,380.07c2.87-.79,4,3.74,1.14,4.44S324.18,380.76,327.07,380.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M320.64,382.16c2.33-.63,3.28,3,.93,3.61S318.29,382.73,320.64,382.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M314.85,383.93a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,314.85,383.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M309.61,385.58a1.3,1.3,0,0,1,.65,2.52A1.3,1.3,0,0,1,309.61,385.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305,387.11a1,1,0,0,1,.48,1.88A1,1,0,0,1,305,387.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M301.37,388.3a.72.72,0,0,1,.36,1.39A.72.72,0,0,1,301.37,388.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298.14,389.3a.55.55,0,0,1,.27,1.07A.55.55,0,0,1,298.14,389.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M295.22,390.21a.4.4,0,0,1,.19.77A.4.4,0,0,1,295.22,390.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M292.57,391a.27.27,0,0,1,.13.52A.27.27,0,0,1,292.57,391Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M290.12,391.75a.17.17,0,0,1,.08.34A.17.17,0,1,1,290.12,391.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M287.81,392.41c.14,0,.2.19.06.22S287.66,392.44,287.81,392.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.38,370.32c3.35-.91,4.71,4.37,1.33,5.19S329,371.14,332.38,370.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M325.15,372.58c2.87-.78,4,3.74,1.14,4.44S322.26,373.28,325.15,372.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M318.72,374.68c2.33-.64,3.27,3,.92,3.6S316.37,375.24,318.72,374.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M312.92,376.45a1.59,1.59,0,0,1,.8,3.08A1.59,1.59,0,0,1,312.92,376.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.68,378.1a1.3,1.3,0,0,1,.65,2.51A1.3,1.3,0,0,1,307.68,378.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.06,379.63a1,1,0,0,1,.48,1.87A1,1,0,0,1,303.06,379.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.44,380.81a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,299.44,380.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M296.21,381.81a.56.56,0,0,1,.28,1.08A.56.56,0,0,1,296.21,381.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M293.29,382.73a.39.39,0,0,1,.2.76A.39.39,0,0,1,293.29,382.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M290.64,383.54a.27.27,0,0,1,.13.52A.27.27,0,0,1,290.64,383.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M288.19,384.27a.18.18,0,0,1,.09.34A.18.18,0,0,1,288.19,384.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M285.88,384.92a.12.12,0,0,1,.06.23A.12.12,0,0,1,285.88,384.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.46,362.83c3.35-.91,4.71,4.38,1.33,5.19S327.08,363.65,330.46,362.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M323.22,365.09c2.87-.78,4,3.74,1.14,4.44S320.33,365.79,323.22,365.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.79,367.19c2.33-.64,3.28,3,.93,3.61S314.44,367.76,316.79,367.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311,369a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,311,369Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.76,370.61a1.3,1.3,0,0,1,.65,2.51A1.3,1.3,0,0,1,305.76,370.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M301.13,372.14a1,1,0,0,1,.48,1.87A1,1,0,0,1,301.13,372.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.52,373.32a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,297.52,373.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.29,374.33a.55.55,0,0,1,.27,1.07A.55.55,0,0,1,294.29,374.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.37,375.24a.4.4,0,0,1,.19.77A.4.4,0,0,1,291.37,375.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M288.72,376.06a.26.26,0,0,1,.13.51A.26.26,0,1,1,288.72,376.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.27,376.78a.17.17,0,0,1,.08.34A.17.17,0,0,1,286.27,376.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284,377.44a.11.11,0,0,1,.06.22C283.87,377.7,283.81,377.47,284,377.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.53,355.35c3.35-.92,4.71,4.37,1.33,5.19S325.15,356.16,328.53,355.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M321.3,357.61c2.87-.79,4,3.74,1.14,4.44S318.41,358.31,321.3,357.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M314.87,359.7c2.33-.63,3.27,3,.92,3.61S312.52,360.27,314.87,359.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M309.07,361.47a1.59,1.59,0,0,1,.8,3.08A1.59,1.59,0,0,1,309.07,361.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.83,363.12a1.3,1.3,0,0,1,.65,2.52A1.3,1.3,0,0,1,303.83,363.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.21,364.65a1,1,0,0,1,.48,1.88A1,1,0,0,1,299.21,364.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M295.59,365.84a.72.72,0,0,1,.36,1.39A.72.72,0,0,1,295.59,365.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M292.36,366.84a.55.55,0,0,1,.28,1.07A.55.55,0,0,1,292.36,366.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M289.44,367.76a.39.39,0,0,1,.2.76A.39.39,0,0,1,289.44,367.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.79,368.57a.27.27,0,0,1,.13.52A.27.27,0,0,1,286.79,368.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284.34,369.29a.18.18,0,0,1,.09.34A.18.18,0,0,1,284.34,369.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282,370c.15,0,.21.19.06.22S281.89,370,282,370Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.61,347.86c3.35-.91,4.71,4.37,1.33,5.19S323.23,348.68,326.61,347.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M319.37,350.12c2.87-.78,4,3.74,1.14,4.44S316.48,350.82,319.37,350.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M312.94,352.22c2.33-.64,3.28,3,.93,3.61S310.59,352.78,312.94,352.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.15,354a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,307.15,354Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M301.91,355.64a1.3,1.3,0,0,1,.65,2.51A1.3,1.3,0,0,1,301.91,355.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.28,357.17a1,1,0,0,1,.49,1.87A1,1,0,0,1,297.28,357.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M293.67,358.35a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,293.67,358.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M290.44,359.36a.55.55,0,0,1,.27,1.07A.55.55,0,0,1,290.44,359.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M287.52,360.27a.39.39,0,0,1,.19.76A.39.39,0,0,1,287.52,360.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284.87,361.08a.27.27,0,0,1,.13.52A.27.27,0,0,1,284.87,361.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282.42,361.81a.18.18,0,0,1,.09.34A.18.18,0,1,1,282.42,361.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M280.11,362.46c.14,0,.2.19.06.23A.12.12,0,0,1,280.11,362.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M324.68,340.38c3.35-.92,4.71,4.37,1.33,5.18S321.3,341.19,324.68,340.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M317.45,342.63c2.87-.78,4,3.75,1.14,4.44S314.56,343.33,317.45,342.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311,344.73c2.33-.64,3.27,3,.92,3.61S308.67,345.3,311,344.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.22,346.5a1.59,1.59,0,0,1,.8,3.08A1.59,1.59,0,0,1,305.22,346.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M300,348.15a1.3,1.3,0,0,1,.65,2.51A1.3,1.3,0,0,1,300,348.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M295.36,349.68a1,1,0,0,1,.48,1.87A1,1,0,0,1,295.36,349.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.75,350.86a.72.72,0,0,1,.35,1.4A.72.72,0,0,1,291.75,350.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M288.51,351.87a.55.55,0,0,1,.28,1.07A.55.55,0,0,1,288.51,351.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M285.59,352.78a.4.4,0,0,1,.2.77A.4.4,0,0,1,285.59,352.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282.94,353.6a.26.26,0,1,1,.13.51A.26.26,0,0,1,282.94,353.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M280.49,354.32a.18.18,0,0,1,.09.34A.18.18,0,0,1,280.49,354.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M278.18,355a.11.11,0,1,1,.06.22C278.1,355.24,278,355,278.18,355Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M322.76,332.89c3.35-.92,4.71,4.37,1.33,5.19S319.38,333.7,322.76,332.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M315.52,335.15c2.87-.78,4,3.74,1.14,4.44S312.63,335.85,315.52,335.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M309.09,337.24c2.33-.63,3.28,3.05.93,3.61S306.74,337.81,309.09,337.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.3,339a1.59,1.59,0,0,1,.79,3.07A1.59,1.59,0,0,1,303.3,339Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298.06,340.66a1.3,1.3,0,0,1,.65,2.52A1.3,1.3,0,0,1,298.06,340.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M293.43,342.2a1,1,0,0,1,.49,1.87A1,1,0,0,1,293.43,342.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M289.82,343.38a.72.72,0,0,1,.36,1.39A.72.72,0,0,1,289.82,343.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.59,344.38a.55.55,0,0,1,.27,1.07A.55.55,0,0,1,286.59,344.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M283.67,345.3a.39.39,0,0,1,.19.76A.39.39,0,0,1,283.67,345.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M281,346.11a.27.27,0,0,1,.13.52A.27.27,0,0,1,281,346.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M278.57,346.83a.18.18,0,0,1,.09.35A.18.18,0,0,1,278.57,346.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276.26,347.49c.14,0,.2.19.06.22A.11.11,0,1,1,276.26,347.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M320.83,325.4c3.35-.91,4.71,4.37,1.33,5.19S317.45,326.22,320.83,325.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M313.6,327.66c2.87-.78,4,3.74,1.14,4.44S310.71,328.36,313.6,327.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.17,329.76c2.33-.64,3.27,3,.92,3.61S304.82,330.33,307.17,329.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M301.37,331.53a1.59,1.59,0,0,1,.8,3.08A1.59,1.59,0,0,1,301.37,331.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M296.13,333.18a1.3,1.3,0,0,1,.65,2.51A1.3,1.3,0,0,1,296.13,333.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.51,334.71a1,1,0,0,1,.48,1.87A1,1,0,0,1,291.51,334.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M287.9,335.89a.72.72,0,0,1,.35,1.4A.72.72,0,0,1,287.9,335.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284.66,336.9a.55.55,0,0,1,.28,1.07A.55.55,0,0,1,284.66,336.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M281.74,337.81a.4.4,0,0,1,.2.77A.4.4,0,0,1,281.74,337.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M279.09,338.62a.27.27,0,0,1,.13.52A.27.27,0,0,1,279.09,338.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276.64,339.35a.18.18,0,0,1,.09.34A.18.18,0,0,1,276.64,339.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M274.33,340a.12.12,0,0,1,.06.23C274.25,340.27,274.19,340,274.33,340Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M318.91,317.92c3.35-.92,4.71,4.37,1.33,5.18S315.53,318.73,318.91,317.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311.67,320.17c2.87-.78,4,3.75,1.14,4.44S308.78,320.87,311.67,320.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.24,322.27c2.33-.63,3.28,3,.93,3.61S302.89,322.84,305.24,322.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.45,324a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,299.45,324Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.21,325.69a1.3,1.3,0,0,1,.65,2.51A1.3,1.3,0,0,1,294.21,325.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M289.58,327.22a1,1,0,0,1,.49,1.87A1,1,0,0,1,289.58,327.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286,328.41a.72.72,0,0,1,.36,1.39A.72.72,0,0,1,286,328.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282.74,329.41a.55.55,0,0,1,.27,1.07A.55.55,0,0,1,282.74,329.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M279.82,330.32a.4.4,0,0,1,.19.77A.4.4,0,0,1,279.82,330.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M277.17,331.14a.27.27,0,0,1,.13.52A.27.27,0,0,1,277.17,331.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M274.72,331.86a.18.18,0,0,1,.09.34A.18.18,0,0,1,274.72,331.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M272.41,332.52c.14,0,.2.19.06.22S272.26,332.55,272.41,332.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M317,310.43c3.35-.91,4.71,4.37,1.33,5.19S313.6,311.25,317,310.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M309.75,312.69c2.87-.78,4,3.74,1.14,4.44S306.86,313.39,309.75,312.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.32,314.79c2.33-.64,3.27,3,.92,3.6S301,315.35,303.32,314.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.52,316.56a1.59,1.59,0,0,1,.8,3.08A1.59,1.59,0,0,1,297.52,316.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M292.29,318.2a1.3,1.3,0,0,1,.64,2.52A1.3,1.3,0,0,1,292.29,318.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M287.66,319.74a1,1,0,0,1,.48,1.87A1,1,0,0,1,287.66,319.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284.05,320.92a.72.72,0,0,1,.35,1.4A.72.72,0,0,1,284.05,320.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M280.81,321.92a.55.55,0,0,1,.28,1.07A.55.55,0,0,1,280.81,321.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M277.89,322.84a.39.39,0,0,1,.2.76A.39.39,0,0,1,277.89,322.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M275.24,323.65a.27.27,0,0,1,.13.52A.27.27,0,0,1,275.24,323.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M272.79,324.37a.18.18,0,0,1,.09.35A.18.18,0,0,1,272.79,324.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.49,325a.11.11,0,0,1,.05.22A.11.11,0,1,1,270.49,325Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M315.06,302.94c3.35-.91,4.71,4.38,1.33,5.19S311.68,303.76,315.06,302.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.82,305.2c2.87-.78,4,3.74,1.14,4.44S304.93,305.9,307.82,305.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M301.39,307.3c2.33-.64,3.28,3,.93,3.61S299,307.87,301.39,307.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M295.6,309.07a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,295.6,309.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M290.36,310.72a1.3,1.3,0,0,1,.65,2.51A1.3,1.3,0,0,1,290.36,310.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M285.73,312.25a1,1,0,0,1,.49,1.87A1,1,0,0,1,285.73,312.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282.12,313.43a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,282.12,313.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M278.89,314.44a.55.55,0,0,1,.27,1.07A.55.55,0,0,1,278.89,314.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276,315.35a.4.4,0,0,1,.19.77A.4.4,0,0,1,276,315.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M273.32,316.16a.27.27,0,0,1,.13.52A.27.27,0,0,1,273.32,316.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.87,316.89a.18.18,0,0,1,.09.34A.18.18,0,0,1,270.87,316.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M268.56,317.54a.12.12,0,0,1,.06.23A.12.12,0,0,1,268.56,317.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M313.13,295.46c3.35-.92,4.71,4.37,1.33,5.18S309.75,296.27,313.13,295.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.9,297.72c2.87-.79,4,3.74,1.14,4.43S303,298.41,305.9,297.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.47,299.81c2.33-.63,3.27,3,.92,3.61S297.12,300.38,299.47,299.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M293.67,301.58a1.59,1.59,0,0,1,.8,3.08A1.59,1.59,0,0,1,293.67,301.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M288.44,303.23a1.3,1.3,0,0,1,.64,2.52A1.3,1.3,0,0,1,288.44,303.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M283.81,304.76a1,1,0,0,1,.48,1.88A1,1,0,0,1,283.81,304.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M280.2,306a.72.72,0,0,1,.35,1.39A.72.72,0,0,1,280.2,306Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M277,307a.55.55,0,0,1,.28,1.07A.55.55,0,0,1,277,307Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M274,307.86a.4.4,0,0,1,.2.77A.4.4,0,0,1,274,307.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M271.39,308.68a.27.27,0,0,1,.13.52A.27.27,0,0,1,271.39,308.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M268.94,309.4a.18.18,0,0,1,.09.34A.18.18,0,0,1,268.94,309.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M266.64,310.06a.11.11,0,0,1,.05.22A.11.11,0,0,1,266.64,310.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311.21,288c3.35-.91,4.71,4.37,1.33,5.19S307.83,288.79,311.21,288Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M304,290.23c2.87-.78,4,3.74,1.14,4.44S301.08,290.93,304,290.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.54,292.33c2.33-.64,3.28,3,.93,3.6S295.19,292.89,297.54,292.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.75,294.1a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,291.75,294.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.51,295.75a1.3,1.3,0,0,1,.65,2.51A1.3,1.3,0,0,1,286.51,295.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M281.89,297.28a1,1,0,0,1,.48,1.87A1,1,0,0,1,281.89,297.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M278.27,298.46a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,278.27,298.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M275,299.46a.56.56,0,0,1,.27,1.08A.56.56,0,0,1,275,299.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M272.12,300.38a.39.39,0,0,1,.19.76A.39.39,0,0,1,272.12,300.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.47,301.19a.27.27,0,0,1,.13.52A.27.27,0,0,1,269.47,301.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M267,301.92c.22-.07.31.28.09.34A.18.18,0,0,1,267,301.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M264.71,302.57c.14,0,.2.19.06.22A.11.11,0,0,1,264.71,302.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M309.28,280.48c3.35-.91,4.71,4.38,1.33,5.19S305.9,281.3,309.28,280.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M302.05,282.74c2.87-.78,4,3.74,1.14,4.44S299.16,283.44,302.05,282.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M295.62,284.84c2.33-.64,3.27,3,.92,3.61S293.27,285.41,295.62,284.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M289.83,286.61a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,289.83,286.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284.59,288.26a1.3,1.3,0,0,1,.64,2.51A1.3,1.3,0,0,1,284.59,288.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M280,289.79a1,1,0,0,1,.48,1.87A1,1,0,0,1,280,289.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276.35,291a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,276.35,291Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M273.11,292a.55.55,0,0,1,.28,1.07A.55.55,0,0,1,273.11,292Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.19,292.89a.4.4,0,0,1,.2.77A.4.4,0,0,1,270.19,292.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M267.54,293.7a.27.27,0,0,1,.13.52C267.34,294.32,267.2,293.79,267.54,293.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M265.09,294.43a.18.18,0,0,1,.09.34A.18.18,0,0,1,265.09,294.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M262.79,295.09a.11.11,0,1,1,0,.22A.11.11,0,0,1,262.79,295.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.36,273c3.35-.92,4.71,4.37,1.33,5.19S304,273.81,307.36,273Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M300.12,275.26c2.87-.79,4,3.74,1.15,4.44S297.23,276,300.12,275.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M293.69,277.35c2.33-.63,3.28,3,.93,3.61S291.34,277.92,293.69,277.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M287.9,279.12a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,287.9,279.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282.66,280.77a1.3,1.3,0,0,1,.65,2.52A1.3,1.3,0,0,1,282.66,280.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M278,282.3a1,1,0,0,1,.48,1.88A1,1,0,0,1,278,282.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M274.42,283.49a.72.72,0,0,1,.36,1.39A.72.72,0,0,1,274.42,283.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M271.19,284.49a.55.55,0,0,1,.27,1.07A.55.55,0,0,1,271.19,284.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M268.27,285.41a.39.39,0,0,1,.2.76A.39.39,0,0,1,268.27,285.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M265.62,286.22a.27.27,0,0,1,.13.52A.27.27,0,0,1,265.62,286.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M263.17,286.94a.18.18,0,0,1,.09.34A.18.18,0,0,1,263.17,286.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M260.86,287.6c.14,0,.2.19.06.22A.11.11,0,0,1,260.86,287.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M305.43,265.51c3.35-.91,4.71,4.37,1.34,5.19S302.05,266.33,305.43,265.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298.2,267.77c2.87-.78,4,3.74,1.14,4.44S295.31,268.47,298.2,267.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.77,269.87c2.33-.64,3.27,3,.92,3.6S289.42,270.43,291.77,269.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286,271.64a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,286,271.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M280.74,273.29a1.3,1.3,0,0,1,.64,2.51A1.3,1.3,0,0,1,280.74,273.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276.11,274.82a1,1,0,0,1,.48,1.87A1,1,0,0,1,276.11,274.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M272.5,276a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,272.5,276Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.26,277a.56.56,0,0,1,.28,1.08A.56.56,0,0,1,269.26,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M266.34,277.92a.39.39,0,0,1,.2.76A.39.39,0,0,1,266.34,277.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M263.69,278.73a.27.27,0,0,1,.14.52A.27.27,0,0,1,263.69,278.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M261.24,279.46a.18.18,0,0,1,.09.34A.18.18,0,0,1,261.24,279.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M258.94,280.11c.14,0,.2.19.05.23S258.79,280.15,258.94,280.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.51,258c3.35-.91,4.71,4.38,1.33,5.19S300.13,258.84,303.51,258Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M296.27,260.28c2.87-.78,4,3.74,1.15,4.44S293.38,261,296.27,260.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M289.84,262.38c2.33-.64,3.28,3,.93,3.61S287.49,263,289.84,262.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284.05,264.15a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,284.05,264.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M278.81,265.8a1.3,1.3,0,0,1,.65,2.51A1.3,1.3,0,0,1,278.81,265.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M274.19,267.33a1,1,0,0,1,.48,1.87A1,1,0,0,1,274.19,267.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.57,268.51a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,270.57,268.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M267.34,269.52a.55.55,0,0,1,.27,1.07A.55.55,0,0,1,267.34,269.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M264.42,270.43a.4.4,0,0,1,.2.77A.4.4,0,0,1,264.42,270.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M261.77,271.25a.26.26,0,0,1,.13.51A.26.26,0,0,1,261.77,271.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.32,272a.18.18,0,0,1,.09.34A.18.18,0,0,1,259.32,272Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M257,272.63a.11.11,0,0,1,.06.22A.11.11,0,0,1,257,272.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M301.58,250.54c3.35-.92,4.71,4.37,1.34,5.19S298.2,251.35,301.58,250.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.35,252.8c2.87-.79,4,3.74,1.14,4.44S291.46,253.5,294.35,252.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M287.92,254.89c2.33-.63,3.27,3,.92,3.61S285.57,255.46,287.92,254.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282.13,256.66a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,282.13,256.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276.89,258.31a1.3,1.3,0,0,1,.64,2.52A1.3,1.3,0,0,1,276.89,258.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M272.26,259.84a1,1,0,0,1,.48,1.88A1,1,0,0,1,272.26,259.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M268.65,261a.72.72,0,0,1,.36,1.39A.72.72,0,0,1,268.65,261Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M265.41,262a.55.55,0,0,1,.28,1.07A.55.55,0,0,1,265.41,262Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M262.49,263a.39.39,0,0,1,.2.76A.39.39,0,0,1,262.49,263Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.84,263.76a.27.27,0,0,1,.14.52A.27.27,0,0,1,259.84,263.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M257.39,264.48a.18.18,0,0,1,.09.34A.18.18,0,0,1,257.39,264.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M255.09,265.14a.11.11,0,0,1,0,.22A.11.11,0,0,1,255.09,265.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.66,243.05c3.35-.91,4.71,4.37,1.33,5.19S296.28,243.87,299.66,243.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M292.42,245.31c2.87-.78,4,3.74,1.15,4.44S289.53,246,292.42,245.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286,247.41c2.33-.64,3.28,3,.93,3.61S283.64,248,286,247.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M280.2,249.18a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,280.2,249.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M275,250.83a1.3,1.3,0,0,1,.65,2.51A1.3,1.3,0,0,1,275,250.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.34,252.36a1,1,0,0,1,.48,1.87A1,1,0,0,1,270.34,252.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M266.72,253.54a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,266.72,253.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M263.49,254.55a.55.55,0,0,1,.27,1.07A.55.55,0,0,1,263.49,254.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M260.57,255.46a.4.4,0,0,1,.2.77A.4.4,0,0,1,260.57,255.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M257.92,256.27a.27.27,0,0,1,.13.52A.27.27,0,0,1,257.92,256.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M255.47,257a.18.18,0,0,1,.09.34A.18.18,0,0,1,255.47,257Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.16,257.65c.15,0,.2.19.06.23S253,257.69,253.16,257.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.73,235.57c3.35-.92,4.71,4.37,1.34,5.18S294.35,236.38,297.73,235.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M290.5,237.82c2.87-.78,4,3.75,1.14,4.44S287.61,238.52,290.5,237.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284.07,239.92c2.33-.64,3.27,3,.93,3.61S281.72,240.49,284.07,239.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M278.28,241.69a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,278.28,241.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M273,243.34a1.3,1.3,0,0,1,.64,2.51A1.3,1.3,0,0,1,273,243.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M268.41,244.87a1,1,0,0,1,.48,1.87A1,1,0,0,1,268.41,244.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M264.8,246.05a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,264.8,246.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M261.56,247.06a.55.55,0,0,1,.28,1.07A.55.55,0,0,1,261.56,247.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M258.64,248a.4.4,0,0,1,.2.77A.4.4,0,0,1,258.64,248Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256,248.79a.27.27,0,0,1,.14.52A.27.27,0,0,1,256,248.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.54,249.51a.18.18,0,0,1,.09.34A.18.18,0,0,1,253.54,249.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M251.24,250.17a.11.11,0,1,1,0,.22A.11.11,0,0,1,251.24,250.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M295.81,228.08c3.35-.92,4.71,4.37,1.33,5.19S292.43,228.89,295.81,228.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M288.57,230.34c2.87-.78,4,3.74,1.15,4.44S285.68,231,288.57,230.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282.14,232.43c2.33-.63,3.28,3,.93,3.61S279.79,233,282.14,232.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276.35,234.21a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,276.35,234.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M271.11,235.85a1.3,1.3,0,0,1,.65,2.52A1.3,1.3,0,0,1,271.11,235.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M266.49,237.39a1,1,0,0,1,.48,1.87A1,1,0,0,1,266.49,237.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M262.87,238.57a.72.72,0,0,1,.36,1.39A.72.72,0,0,1,262.87,238.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.64,239.57a.55.55,0,0,1,.27,1.07A.55.55,0,0,1,259.64,239.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256.72,240.49a.39.39,0,0,1,.2.76A.39.39,0,0,1,256.72,240.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M254.07,241.3a.27.27,0,0,1,.13.52A.27.27,0,0,1,254.07,241.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M251.62,242a.18.18,0,0,1,.09.35A.18.18,0,0,1,251.62,242Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M249.31,242.68a.11.11,0,0,1,.06.22A.11.11,0,0,1,249.31,242.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M293.88,220.59c3.35-.91,4.71,4.37,1.34,5.19S290.5,221.41,293.88,220.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.65,222.85c2.87-.78,4,3.74,1.14,4.44S283.76,223.55,286.65,222.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M280.22,225c2.33-.64,3.28,3,.93,3.61S277.87,225.52,280.22,225Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M274.43,226.72a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,274.43,226.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.19,228.37a1.3,1.3,0,0,1,.64,2.51A1.3,1.3,0,0,1,269.19,228.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M264.56,229.9a1,1,0,0,1,.48,1.87A1,1,0,0,1,264.56,229.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M261,231.08a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,261,231.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M257.71,232.09a.55.55,0,0,1,.28,1.07A.55.55,0,0,1,257.71,232.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M254.79,233a.4.4,0,0,1,.2.77A.4.4,0,0,1,254.79,233Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M252.14,233.81a.27.27,0,0,1,.14.52A.27.27,0,0,1,252.14,233.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M249.69,234.54a.18.18,0,0,1,.09.34A.18.18,0,0,1,249.69,234.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.39,235.19c.14,0,.2.19.05.23S247.24,235.23,247.39,235.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M292,213.11c3.35-.92,4.71,4.37,1.33,5.18S288.58,213.92,292,213.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284.73,215.37c2.86-.79,4,3.74,1.14,4.43S281.83,216.06,284.73,215.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M278.29,217.46c2.33-.63,3.28,3,.93,3.61S275.94,218,278.29,217.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M272.5,219.23a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,272.5,219.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M267.26,220.88a1.3,1.3,0,0,1,.65,2.52A1.3,1.3,0,0,1,267.26,220.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M262.64,222.41a1,1,0,0,1,.48,1.87A1,1,0,0,1,262.64,222.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259,223.6a.72.72,0,0,1,.36,1.39A.72.72,0,0,1,259,223.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M255.79,224.6a.55.55,0,0,1,.27,1.07A.55.55,0,0,1,255.79,224.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M252.87,225.51a.4.4,0,0,1,.2.77A.4.4,0,0,1,252.87,225.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M250.22,226.33a.27.27,0,0,1,.13.52A.27.27,0,0,1,250.22,226.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.77,227.05a.18.18,0,0,1,.09.34A.18.18,0,0,1,247.77,227.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.46,227.71a.11.11,0,0,1,.06.22A.11.11,0,0,1,245.46,227.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M290,205.62c3.36-.91,4.71,4.37,1.34,5.19S286.65,206.44,290,205.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282.8,207.88c2.87-.78,4,3.74,1.14,4.44S279.91,208.58,282.8,207.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276.37,210c2.33-.64,3.28,3,.93,3.6S274,210.54,276.37,210Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.58,211.75a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,270.58,211.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M265.34,213.39a1.3,1.3,0,0,1,.64,2.52A1.3,1.3,0,0,1,265.34,213.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M260.71,214.93a1,1,0,0,1,.48,1.87A1,1,0,0,1,260.71,214.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M257.1,216.11a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,257.1,216.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.86,217.11a.55.55,0,0,1,.28,1.07A.55.55,0,0,1,253.86,217.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M250.94,218a.39.39,0,0,1,.2.76A.39.39,0,0,1,250.94,218Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M248.29,218.84a.27.27,0,0,1,.14.52A.27.27,0,0,1,248.29,218.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.84,219.56a.18.18,0,0,1,.09.35A.18.18,0,0,1,245.84,219.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M243.54,220.22a.11.11,0,0,1,.05.22A.11.11,0,1,1,243.54,220.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M288.11,198.13c3.35-.91,4.71,4.38,1.33,5.19S284.73,199,288.11,198.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M280.88,200.39c2.86-.78,4,3.74,1.14,4.44S278,201.09,280.88,200.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M274.44,202.49c2.33-.64,3.28,3,.93,3.61S272.09,203.06,274.44,202.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M268.65,204.26a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,268.65,204.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M263.41,205.91a1.3,1.3,0,0,1,.65,2.51A1.3,1.3,0,0,1,263.41,205.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M258.79,207.44a1,1,0,0,1,.48,1.87A1,1,0,0,1,258.79,207.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M255.17,208.62a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,255.17,208.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M251.94,209.63a.55.55,0,0,1,.27,1.07A.55.55,0,0,1,251.94,209.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M249,210.54a.4.4,0,0,1,.2.77A.4.4,0,0,1,249,210.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M246.37,211.35a.27.27,0,0,1,.13.52A.27.27,0,0,1,246.37,211.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M243.92,212.08a.18.18,0,0,1,.09.34A.18.18,0,0,1,243.92,212.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M241.61,212.73a.12.12,0,0,1,.06.23C241.52,213,241.47,212.77,241.61,212.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.18,190.65c3.36-.92,4.71,4.37,1.34,5.18S282.8,191.46,286.18,190.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M279,192.91c2.87-.79,4,3.74,1.14,4.43S276.06,193.6,279,192.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M272.52,195c2.33-.63,3.28,3,.93,3.61S270.17,195.57,272.52,195Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M266.73,196.77a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,266.73,196.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M261.49,198.42a1.3,1.3,0,0,1,.64,2.52A1.3,1.3,0,0,1,261.49,198.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256.86,200a1,1,0,0,1,.48,1.88A1,1,0,0,1,256.86,200Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.25,201.14a.72.72,0,0,1,.36,1.39A.72.72,0,0,1,253.25,201.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M250,202.14a.55.55,0,0,1,.28,1.07A.55.55,0,0,1,250,202.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.09,203.05a.4.4,0,0,1,.2.77A.4.4,0,0,1,247.09,203.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M244.44,203.87a.27.27,0,0,1,.14.52A.27.27,0,0,1,244.44,203.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M242,204.59a.18.18,0,1,1,.09.34A.18.18,0,0,1,242,204.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M239.69,205.25a.11.11,0,0,1,.05.22A.11.11,0,0,1,239.69,205.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284.26,183.16c3.35-.91,4.71,4.37,1.33,5.19S280.88,184,284.26,183.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M277,185.42c2.86-.78,4,3.74,1.14,4.44S274.14,186.12,277,185.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.59,187.52c2.34-.64,3.28,3,.93,3.6S268.24,188.08,270.59,187.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M264.8,189.29a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,264.8,189.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.56,190.94a1.3,1.3,0,0,1,.65,2.51A1.3,1.3,0,0,1,259.56,190.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M254.94,192.47a1,1,0,0,1,.48,1.87A1,1,0,0,1,254.94,192.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M251.32,193.65a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,251.32,193.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M248.09,194.65a.56.56,0,0,1,.27,1.08A.56.56,0,0,1,248.09,194.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.17,195.57a.39.39,0,0,1,.2.76A.39.39,0,0,1,245.17,195.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M242.52,196.38a.27.27,0,0,1,.13.52A.27.27,0,0,1,242.52,196.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.07,197.11a.18.18,0,0,1,.09.34A.18.18,0,0,1,240.07,197.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.76,197.76a.11.11,0,0,1,.06.22A.11.11,0,0,1,237.76,197.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282.33,175.67c3.36-.91,4.71,4.38,1.34,5.19S279,176.49,282.33,175.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M275.1,177.93c2.87-.78,4,3.74,1.14,4.44S272.21,178.63,275.1,177.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M268.67,180c2.33-.64,3.28,3,.93,3.61S266.32,180.6,268.67,180Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M262.88,181.8a1.59,1.59,0,0,1,.79,3.08A1.59,1.59,0,0,1,262.88,181.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M257.64,183.45a1.3,1.3,0,0,1,.64,2.51A1.3,1.3,0,0,1,257.64,183.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253,185a1,1,0,0,1,.48,1.87A1,1,0,0,1,253,185Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M249.4,186.16a.72.72,0,0,1,.36,1.4A.72.72,0,0,1,249.4,186.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M246.16,187.17a.55.55,0,0,1,.28,1.07A.55.55,0,0,1,246.16,187.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M243.24,188.08a.4.4,0,0,1,.2.77A.4.4,0,0,1,243.24,188.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.59,188.89a.27.27,0,0,1,.14.52A.27.27,0,0,1,240.59,188.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M238.15,189.62a.17.17,0,0,1,.08.34A.17.17,0,0,1,238.15,189.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235.84,190.28a.11.11,0,1,1,0,.22A.11.11,0,0,1,235.84,190.28Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M267.19,341.57c18.8-58.19,11.4-122-21.17-173.74-13.33-21.18-28.12-45.44-47.53-42.66C169,129.4,168.88,168,144.62,193.38S79.89,229.11,72.69,282.1C61.16,367,160,424.7,219.42,404.45,243.16,396.35,258,370.13,267.19,341.57Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.73,132.66a3.57,3.57,0,1,1,3.16-3.93A3.55,3.55,0,0,1,160.73,132.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170.69,131a3,3,0,1,1,2.7-3.37A3.05,3.05,0,0,1,170.69,131Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M179.57,129.48a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,179.57,129.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M187.54,128.23a2.12,2.12,0,1,1,1.87-2.33A2.11,2.11,0,0,1,187.54,128.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M194.76,127a1.73,1.73,0,1,1,1.52-1.91A1.72,1.72,0,0,1,194.76,127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M201.14,125.89a1.29,1.29,0,1,1,1.14-1.42A1.29,1.29,0,0,1,201.14,125.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M206.13,125A1,1,0,1,1,207,124,1,1,0,0,1,206.13,125Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M210.58,124.29a.74.74,0,0,1-.81-.65.73.73,0,1,1,.81.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M214.6,123.63a.52.52,0,1,1-.11-1,.51.51,0,0,1,.58.46A.53.53,0,0,1,214.6,123.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M218.25,123.06a.36.36,0,1,1,.32-.4A.37.37,0,0,1,218.25,123.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M221.62,122.56a.23.23,0,0,1-.26-.21.23.23,0,1,1,.46,0A.22.22,0,0,1,221.62,122.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224.78,122.13a.16.16,0,0,1-.17-.14.16.16,0,0,1,.14-.17.16.16,0,1,1,0,.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.87,142.9A3.57,3.57,0,1,1,165,139,3.58,3.58,0,0,1,161.87,142.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M171.83,141.28a3.05,3.05,0,1,1,2.7-3.37A3.06,3.06,0,0,1,171.83,141.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M180.7,139.72a2.48,2.48,0,1,1,2.2-2.74A2.49,2.49,0,0,1,180.7,139.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.67,138.47a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,188.67,138.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M195.89,137.28a1.73,1.73,0,1,1,1.53-1.91A1.74,1.74,0,0,1,195.89,137.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M202.28,136.12a1.29,1.29,0,0,1-.29-2.56,1.29,1.29,0,1,1,.29,2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M207.27,135.24a1,1,0,0,1-1.07-.85,1,1,0,0,1,.85-1.06,1,1,0,0,1,.22,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M211.72,134.52a.73.73,0,1,1,.65-.81A.73.73,0,0,1,211.72,134.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M215.74,133.86a.51.51,0,0,1-.58-.46.52.52,0,0,1,1-.12A.51.51,0,0,1,215.74,133.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M219.39,133.29a.37.37,0,0,1-.4-.32.36.36,0,1,1,.4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M222.75,132.79a.23.23,0,0,1-.26-.2.24.24,0,1,1,.26.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M225.92,132.36a.15.15,0,0,1-.17-.13.14.14,0,0,1,.13-.17.15.15,0,0,1,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M163,153.13a3.57,3.57,0,1,1,3.16-3.94A3.57,3.57,0,0,1,163,153.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M173,151.51a3.05,3.05,0,1,1,2.7-3.37A3.06,3.06,0,0,1,173,151.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181.84,150a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,181.84,150Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M189.81,148.7a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,189.81,148.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M197,147.51a1.73,1.73,0,1,1,1.52-1.91A1.73,1.73,0,0,1,197,147.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M203.41,146.36a1.3,1.3,0,0,1-1.42-1.14,1.29,1.29,0,1,1,1.42,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M208.4,145.47a1,1,0,0,1-1.06-.84,1,1,0,1,1,1.91-.22A1,1,0,0,1,208.4,145.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212.85,144.76a.74.74,0,1,1,.65-.82A.74.74,0,0,1,212.85,144.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.87,144.1a.53.53,0,1,1,.47-.58A.53.53,0,0,1,216.87,144.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.52,143.52a.36.36,0,0,1-.39-.31.36.36,0,1,1,.39.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.89,143a.24.24,0,0,1-.26-.21.23.23,0,0,1,.2-.26.24.24,0,0,1,.26.21A.23.23,0,0,1,223.89,143Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M227.05,142.59a.16.16,0,0,1-.17-.13.16.16,0,0,1,.14-.17.16.16,0,0,1,.17.13A.15.15,0,0,1,227.05,142.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M164.14,163.36a3.57,3.57,0,1,1,3.15-3.93A3.56,3.56,0,0,1,164.14,163.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M174.1,161.74a3.05,3.05,0,1,1,2.7-3.37A3,3,0,0,1,174.1,161.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M183,160.18a2.48,2.48,0,1,1,2.2-2.74A2.49,2.49,0,0,1,183,160.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M190.94,158.93a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,190.94,158.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.16,157.74a1.73,1.73,0,1,1,1.53-1.91A1.73,1.73,0,0,1,198.16,157.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M204.55,156.59a1.29,1.29,0,1,1,1.13-1.42A1.28,1.28,0,0,1,204.55,156.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M209.53,155.71a1,1,0,0,1-.21-1.91,1,1,0,0,1,1.06.85A1,1,0,0,1,209.53,155.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M214,155a.74.74,0,1,1,.65-.82A.75.75,0,0,1,214,155Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M218,154.33a.53.53,0,1,1,.46-.58A.51.51,0,0,1,218,154.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M221.66,153.76a.36.36,0,0,1-.4-.32.36.36,0,0,1,.71-.08A.37.37,0,0,1,221.66,153.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M225,153.26a.24.24,0,1,1,.21-.26A.24.24,0,0,1,225,153.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M228.19,152.83a.15.15,0,0,1-.17-.14.16.16,0,0,1,.13-.17.15.15,0,0,1,.17.14A.16.16,0,0,1,228.19,152.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M165.27,173.6a3.57,3.57,0,1,1,3.16-3.94A3.58,3.58,0,0,1,165.27,173.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M175.23,172a3,3,0,1,1,2.7-3.37A3.05,3.05,0,0,1,175.23,172Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 183.83,
    cy: 167.95,
    r: 2.48,
    transform: "translate(-63.95 192.56) rotate(-48.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M192.08,169.17a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,192.08,169.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M199.3,168a1.73,1.73,0,1,1,1.52-1.9A1.72,1.72,0,0,1,199.3,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M205.68,166.82a1.29,1.29,0,1,1,1.14-1.42A1.29,1.29,0,0,1,205.68,166.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M210.67,165.94a1,1,0,1,1,.85-1.06A1,1,0,0,1,210.67,165.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M215.12,165.22a.73.73,0,1,1,.65-.81A.73.73,0,0,1,215.12,165.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M219.14,164.56a.51.51,0,0,1-.58-.46.53.53,0,0,1,.47-.58.51.51,0,0,1,.58.46A.53.53,0,0,1,219.14,164.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M222.79,164a.36.36,0,1,1,.32-.4A.36.36,0,0,1,222.79,164Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226.16,163.49a.23.23,0,0,1-.26-.21.23.23,0,0,1,.2-.25.22.22,0,0,1,.26.2A.23.23,0,0,1,226.16,163.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M229.32,163.06a.16.16,0,0,1,0-.31.16.16,0,0,1,.17.14A.16.16,0,0,1,229.32,163.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M166.41,183.83a3.57,3.57,0,1,1,3.15-3.94A3.56,3.56,0,0,1,166.41,183.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M176.37,182.21a3.05,3.05,0,1,1,2.7-3.37A3,3,0,0,1,176.37,182.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M185.24,180.65a2.48,2.48,0,1,1,2.2-2.74A2.48,2.48,0,0,1,185.24,180.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M193.21,179.4a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,193.21,179.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M200.43,178.21A1.73,1.73,0,1,1,202,176.3,1.74,1.74,0,0,1,200.43,178.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M206.82,177.05a1.28,1.28,0,1,1,1.13-1.42A1.28,1.28,0,0,1,206.82,177.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M211.8,176.17a1,1,0,0,1-1.06-.85,1,1,0,0,1,1.91-.21A1,1,0,0,1,211.8,176.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.26,175.45a.73.73,0,1,1,.65-.81A.73.73,0,0,1,216.26,175.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.28,174.8a.53.53,0,0,1-.58-.47.51.51,0,0,1,.46-.58.53.53,0,0,1,.12,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.93,174.22a.36.36,0,1,1,.31-.39A.36.36,0,0,1,223.93,174.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M227.29,173.73a.24.24,0,0,1-.26-.21.24.24,0,0,1,.47-.05A.24.24,0,0,1,227.29,173.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M230.46,173.29a.15.15,0,1,1,.13-.17A.15.15,0,0,1,230.46,173.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M167.54,194.06a3.57,3.57,0,1,1,3.15-3.94A3.56,3.56,0,0,1,167.54,194.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M177.5,192.44a3.05,3.05,0,1,1,2.7-3.37A3.05,3.05,0,0,1,177.5,192.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M186.38,190.88a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,186.38,190.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M194.35,189.63a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,194.35,189.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M201.56,188.44a1.73,1.73,0,1,1,1.53-1.91A1.72,1.72,0,0,1,201.56,188.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M208,187.29a1.29,1.29,0,1,1,1.14-1.42A1.29,1.29,0,0,1,208,187.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212.94,186.41a1,1,0,0,1-1.06-.85,1,1,0,0,1,.85-1.06,1,1,0,1,1,.21,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217.39,185.69a.74.74,0,1,1,.65-.82A.74.74,0,0,1,217.39,185.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M221.41,185a.53.53,0,0,1-.58-.47.53.53,0,0,1,.47-.58.53.53,0,1,1,.11,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M225.06,184.45a.35.35,0,0,1-.39-.31.36.36,0,1,1,.71-.08A.35.35,0,0,1,225.06,184.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M228.43,184a.24.24,0,0,1-.26-.21.23.23,0,0,1,.2-.26.24.24,0,0,1,.06.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231.59,183.53a.17.17,0,0,1-.17-.14.16.16,0,1,1,.17.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 168.28,
    cy: 200.75,
    r: 3.57,
    transform: "translate(-93.6 206.96) rotate(-51.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M178.64,202.67a3,3,0,1,1,2.69-3.37A3,3,0,0,1,178.64,202.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M187.51,201.11a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,187.51,201.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M195.48,199.86a2.11,2.11,0,1,1,1.87-2.33A2.11,2.11,0,0,1,195.48,199.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M202.7,198.67a1.73,1.73,0,1,1,1.53-1.91A1.73,1.73,0,0,1,202.7,198.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M209.09,197.52a1.29,1.29,0,1,1,1.13-1.42A1.28,1.28,0,0,1,209.09,197.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M214.07,196.64a1,1,0,1,1,.85-1.06A1,1,0,0,1,214.07,196.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M218.53,195.92a.75.75,0,0,1-.82-.65.74.74,0,0,1,1.47-.16A.74.74,0,0,1,218.53,195.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M222.55,195.26a.52.52,0,0,1-.58-.46.52.52,0,0,1,1-.12A.52.52,0,0,1,222.55,195.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226.2,194.69a.36.36,0,0,1-.4-.32.36.36,0,1,1,.4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M229.56,194.19a.24.24,0,0,1-.26-.21.24.24,0,1,1,.47,0A.24.24,0,0,1,229.56,194.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M232.73,193.76a.15.15,0,0,1-.17-.14.16.16,0,0,1,.13-.17.15.15,0,0,1,.17.14A.16.16,0,0,1,232.73,193.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M169.81,214.53a3.57,3.57,0,1,1,3.15-3.94A3.57,3.57,0,0,1,169.81,214.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 179.44,
    cy: 209.87,
    r: 3.05,
    transform: "translate(-53.87 62.18) rotate(-17.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.65,211.35a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,188.65,211.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M196.62,210.1a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,196.62,210.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M203.83,208.91a1.73,1.73,0,1,1,1.53-1.91A1.73,1.73,0,0,1,203.83,208.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M210.22,207.75a1.29,1.29,0,1,1-.28-2.56,1.3,1.3,0,0,1,1.42,1.14A1.28,1.28,0,0,1,210.22,207.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M215.21,206.87a1,1,0,1,1,.85-1.06A1,1,0,0,1,215.21,206.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M219.66,206.15a.73.73,0,1,1,.65-.81A.73.73,0,0,1,219.66,206.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.68,205.5a.53.53,0,0,1-.11-1.05.53.53,0,0,1,.58.46A.54.54,0,0,1,223.68,205.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M227.33,204.92a.36.36,0,0,1-.08-.71.37.37,0,0,1,.4.32A.36.36,0,0,1,227.33,204.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M230.7,204.42a.23.23,0,0,1-.06-.46.23.23,0,0,1,.06.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M233.86,204a.16.16,0,0,1-.17-.13.15.15,0,0,1,.14-.17.16.16,0,0,1,.17.13A.15.15,0,0,1,233.86,204Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M171,224.76a3.57,3.57,0,1,1,3.15-3.94A3.56,3.56,0,0,1,171,224.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M180.91,223.14a3.05,3.05,0,1,1,2.69-3.37A3,3,0,0,1,180.91,223.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M189.78,221.58a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,189.78,221.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M197.75,220.33a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,197.75,220.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M205,219.14a1.73,1.73,0,1,1,1.53-1.91A1.74,1.74,0,0,1,205,219.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M211.36,218a1.29,1.29,0,1,1,1.13-1.42A1.28,1.28,0,0,1,211.36,218Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.34,217.1a1,1,0,0,1-1.06-.84,1,1,0,1,1,1.06.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.8,216.39a.74.74,0,1,1,.65-.82A.75.75,0,0,1,220.8,216.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224.82,215.73a.53.53,0,0,1-.58-.47.51.51,0,0,1,.46-.58.53.53,0,0,1,.58.47A.52.52,0,0,1,224.82,215.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M228.47,215.15a.36.36,0,0,1-.4-.31.37.37,0,0,1,.32-.4.36.36,0,0,1,.08.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231.83,214.66a.24.24,0,1,1-.05-.47.24.24,0,1,1,.05.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235,214.22a.15.15,0,1,1,.13-.17A.15.15,0,0,1,235,214.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M172.08,235a3.57,3.57,0,1,1,3.15-3.93A3.56,3.56,0,0,1,172.08,235Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M182,233.37a3.05,3.05,0,1,1,2.7-3.37A3.05,3.05,0,0,1,182,233.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M190.92,231.81a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,190.92,231.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.89,230.56a2.12,2.12,0,1,1,1.87-2.33A2.12,2.12,0,0,1,198.89,230.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M206.1,229.37a1.73,1.73,0,1,1,1.53-1.91A1.72,1.72,0,0,1,206.1,229.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212.49,228.22a1.29,1.29,0,1,1,1.14-1.42A1.28,1.28,0,0,1,212.49,228.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217.48,227.34a1,1,0,1,1,.85-1.06A1,1,0,0,1,217.48,227.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M221.93,226.62a.74.74,0,1,1,.65-.81A.74.74,0,0,1,221.93,226.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226,226a.53.53,0,0,1-.58-.46.53.53,0,1,1,1-.12A.53.53,0,0,1,226,226Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M229.6,225.39a.35.35,0,0,1-.39-.32.34.34,0,0,1,.31-.39.36.36,0,0,1,.4.31A.37.37,0,0,1,229.6,225.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M233,224.89a.23.23,0,0,1-.25-.21.23.23,0,0,1,.2-.26.24.24,0,0,1,.26.21A.23.23,0,0,1,233,224.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.13,224.46a.16.16,0,1,1,.14-.17A.16.16,0,0,1,236.13,224.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M173.22,245.23a3.57,3.57,0,1,1,3.15-3.94A3.57,3.57,0,0,1,173.22,245.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M183.18,243.6a3,3,0,1,1,2.69-3.37A3,3,0,0,1,183.18,243.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M192.05,242.05a2.49,2.49,0,1,1,2.19-2.74A2.48,2.48,0,0,1,192.05,242.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M200,240.8a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,200,240.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M207.24,239.6a1.73,1.73,0,1,1,1.53-1.9A1.72,1.72,0,0,1,207.24,239.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M213.63,238.45a1.29,1.29,0,1,1,1.13-1.42A1.29,1.29,0,0,1,213.63,238.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M218.61,237.57a1,1,0,1,1,.85-1.06A1,1,0,0,1,218.61,237.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.06,236.85a.73.73,0,1,1,.66-.81A.74.74,0,0,1,223.06,236.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M227.09,236.19a.52.52,0,0,1-.12-1,.52.52,0,1,1,.12,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M230.74,235.62a.36.36,0,0,1-.4-.32.36.36,0,1,1,.4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.1,235.12a.23.23,0,0,1-.26-.2.24.24,0,0,1,.21-.26.23.23,0,0,1,.26.2A.24.24,0,0,1,234.1,235.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.27,234.69a.15.15,0,0,1-.17-.14.14.14,0,0,1,.13-.16.15.15,0,0,1,.17.13A.16.16,0,0,1,237.27,234.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M174.35,255.46a3.57,3.57,0,1,1,3.15-3.94A3.56,3.56,0,0,1,174.35,255.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M184.31,253.84a3.05,3.05,0,1,1,2.7-3.37A3.06,3.06,0,0,1,184.31,253.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M193.19,252.28a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,193.19,252.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M201.16,251a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,201.16,251Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M208.37,249.84a1.73,1.73,0,1,1,1.53-1.91A1.72,1.72,0,0,1,208.37,249.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M214.76,248.69a1.3,1.3,0,0,1-1.42-1.14,1.29,1.29,0,1,1,1.42,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M219.75,247.8a1,1,0,1,1-.21-1.91,1,1,0,0,1,1.06.85A1,1,0,0,1,219.75,247.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224.2,247.08a.73.73,0,0,1-.16-1.46.74.74,0,0,1,.81.65A.73.73,0,0,1,224.2,247.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M228.22,246.43a.53.53,0,0,1-.12-1.05.54.54,0,0,1,.59.47A.53.53,0,0,1,228.22,246.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231.87,245.85a.36.36,0,0,1-.08-.71.37.37,0,0,1,.4.32A.36.36,0,0,1,231.87,245.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235.23,245.36a.25.25,0,0,1-.26-.21.24.24,0,0,1,.21-.26.23.23,0,0,1,.26.21A.24.24,0,0,1,235.23,245.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M238.4,244.92a.16.16,0,0,1-.17-.13.15.15,0,0,1,.14-.17.16.16,0,0,1,.17.13A.16.16,0,0,1,238.4,244.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M175.49,265.69a3.57,3.57,0,1,1,3.15-3.94A3.56,3.56,0,0,1,175.49,265.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M185.45,264.07a3.05,3.05,0,1,1,2.69-3.37A3,3,0,0,1,185.45,264.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M194.32,262.51a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,194.32,262.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M202.29,261.26a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,202.29,261.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M209.51,260.07a1.73,1.73,0,1,1,1.53-1.91A1.73,1.73,0,0,1,209.51,260.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M215.9,258.92A1.29,1.29,0,1,1,217,257.5,1.29,1.29,0,0,1,215.9,258.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.88,258a1,1,0,0,1-1.06-.85,1,1,0,1,1,1.06.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M225.33,257.32a.74.74,0,0,1-.16-1.47.74.74,0,0,1,.16,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M229.36,256.66a.53.53,0,1,1-.12-1.05.53.53,0,0,1,.12,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M233,256.08a.34.34,0,0,1-.39-.31.35.35,0,0,1,.32-.39.34.34,0,0,1,.39.31A.35.35,0,0,1,233,256.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.37,255.59a.24.24,0,0,1-.26-.21.24.24,0,1,1,.26.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M239.54,255.16a.16.16,0,0,1-.17-.14.16.16,0,0,1,.13-.17.15.15,0,0,1,.17.14A.16.16,0,0,1,239.54,255.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M176.62,275.93a3.57,3.57,0,1,1,3.15-3.94A3.58,3.58,0,0,1,176.62,275.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M186.58,274.3a3,3,0,1,1,2.7-3.37A3.05,3.05,0,0,1,186.58,274.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M195.46,272.74a2.48,2.48,0,1,1,2.19-2.73A2.47,2.47,0,0,1,195.46,272.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M203.42,271.5a2.12,2.12,0,1,1,1.88-2.34A2.12,2.12,0,0,1,203.42,271.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M210.64,270.3a1.73,1.73,0,1,1,1.53-1.91A1.73,1.73,0,0,1,210.64,270.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217,269.15a1.29,1.29,0,1,1,1.14-1.42A1.28,1.28,0,0,1,217,269.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M222,268.27a1,1,0,1,1,.85-1.06A1,1,0,0,1,222,268.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226.47,267.55a.73.73,0,1,1,.65-.81A.74.74,0,0,1,226.47,267.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M230.49,266.89a.51.51,0,0,1-.58-.46.53.53,0,1,1,.58.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.14,266.32a.35.35,0,0,1-.39-.32.34.34,0,0,1,.31-.39.35.35,0,0,1,.39.31A.35.35,0,0,1,234.14,266.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.5,265.82a.24.24,0,0,1-.26-.21.25.25,0,0,1,.21-.26.24.24,0,0,1,.26.21A.23.23,0,0,1,237.5,265.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.67,265.39a.16.16,0,1,1,0-.31.16.16,0,0,1,.17.14A.17.17,0,0,1,240.67,265.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M177.76,286.16a3.57,3.57,0,1,1,3.15-3.94A3.57,3.57,0,0,1,177.76,286.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M187.72,284.54a3.05,3.05,0,1,1,2.69-3.37A3.06,3.06,0,0,1,187.72,284.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M196.59,283a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,196.59,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M204.56,281.73a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,204.56,281.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M211.78,280.54a1.73,1.73,0,1,1,1.53-1.91A1.73,1.73,0,0,1,211.78,280.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M218.16,279.38A1.28,1.28,0,1,1,219.3,278,1.29,1.29,0,0,1,218.16,279.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.15,278.5a1,1,0,1,1,.85-1.06A1,1,0,0,1,223.15,278.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M227.6,277.78a.73.73,0,0,1-.81-.65.74.74,0,0,1,.65-.81.73.73,0,1,1,.16,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231.63,277.13a.54.54,0,0,1-.59-.47.53.53,0,0,1,1.05-.12A.54.54,0,0,1,231.63,277.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235.27,276.55a.36.36,0,0,1-.39-.31.36.36,0,0,1,.32-.4.36.36,0,0,1,.07.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M238.64,276.05a.22.22,0,0,1-.26-.2.23.23,0,0,1,.21-.26.23.23,0,1,1,0,.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M241.8,275.62a.14.14,0,0,1-.16-.13.15.15,0,1,1,.16.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M178.89,296.39a3.57,3.57,0,1,1,3.15-3.94A3.56,3.56,0,0,1,178.89,296.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.85,294.77a3.05,3.05,0,1,1,2.7-3.37A3,3,0,0,1,188.85,294.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M197.73,293.21a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,197.73,293.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M205.69,292a2.12,2.12,0,1,1,1.88-2.34A2.11,2.11,0,0,1,205.69,292Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212.91,290.77a1.73,1.73,0,1,1,1.53-1.91A1.74,1.74,0,0,1,212.91,290.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M219.3,289.62a1.29,1.29,0,1,1,1.14-1.42A1.28,1.28,0,0,1,219.3,289.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224.29,288.74a1,1,0,0,1-1.06-.85,1,1,0,0,1,.84-1.06,1,1,0,0,1,1.07.84A1,1,0,0,1,224.29,288.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M228.74,288a.74.74,0,0,1-.16-1.47.74.74,0,0,1,.16,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M232.76,287.36a.53.53,0,0,1-.58-.47.52.52,0,0,1,.46-.58.54.54,0,0,1,.59.47A.53.53,0,0,1,232.76,287.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.41,286.78a.34.34,0,0,1-.39-.31.35.35,0,1,1,.7-.08A.34.34,0,0,1,236.41,286.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M239.77,286.29a.24.24,0,0,1-.05-.47.24.24,0,0,1,.26.21A.24.24,0,0,1,239.77,286.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M242.94,285.85a.16.16,0,0,1-.17-.13.15.15,0,0,1,.14-.17.15.15,0,1,1,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M180,306.63a3.57,3.57,0,1,1,3.16-3.94A3.57,3.57,0,0,1,180,306.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M190,305a3,3,0,1,1,2.7-3.37A3.05,3.05,0,0,1,190,305Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.86,303.44a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,198.86,303.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M206.83,302.19a2.12,2.12,0,1,1,1.87-2.33A2.11,2.11,0,0,1,206.83,302.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M214.05,301a1.73,1.73,0,1,1,1.52-1.91A1.72,1.72,0,0,1,214.05,301Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.43,299.85a1.29,1.29,0,1,1,1.14-1.42A1.29,1.29,0,0,1,220.43,299.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M225.42,299a1,1,0,1,1,.85-1.06A1,1,0,0,1,225.42,299Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M229.87,298.25a.73.73,0,1,1-.16-1.46.73.73,0,0,1,.16,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M233.89,297.59a.52.52,0,1,1-.11-1,.51.51,0,0,1,.58.46A.53.53,0,0,1,233.89,297.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.54,297a.36.36,0,1,1,.32-.4A.37.37,0,0,1,237.54,297Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.91,296.52a.23.23,0,0,1-.26-.21.24.24,0,0,1,.21-.26.25.25,0,0,1,.26.21A.24.24,0,0,1,240.91,296.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M244.07,296.09a.16.16,0,0,1-.17-.14.17.17,0,0,1,.14-.17.16.16,0,1,1,0,.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181.16,316.86a3.57,3.57,0,1,1,3.15-3.94A3.57,3.57,0,0,1,181.16,316.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M191.12,315.24a3.05,3.05,0,1,1,2.7-3.37A3.06,3.06,0,0,1,191.12,315.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M200,313.68a2.48,2.48,0,1,1,2.2-2.74A2.47,2.47,0,0,1,200,313.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M208,312.43a2.12,2.12,0,1,1,1.88-2.34A2.13,2.13,0,0,1,208,312.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M215.18,311.24a1.73,1.73,0,1,1,1.53-1.91A1.74,1.74,0,0,1,215.18,311.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M221.57,310.08a1.29,1.29,0,1,1-.28-2.56,1.3,1.3,0,0,1,1.42,1.14A1.29,1.29,0,0,1,221.57,310.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226.56,309.2a1,1,0,0,1-1.06-.85,1,1,0,1,1,1.06.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231,308.48a.73.73,0,1,1,.65-.81A.73.73,0,0,1,231,308.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235,307.82a.51.51,0,0,1-.58-.46.52.52,0,0,1,1-.12A.51.51,0,0,1,235,307.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M238.68,307.25a.37.37,0,0,1-.4-.32.36.36,0,0,1,.32-.39.36.36,0,0,1,.08.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M242,306.75a.23.23,0,0,1-.26-.2.24.24,0,0,1,.21-.26.23.23,0,0,1,.26.2A.24.24,0,0,1,242,306.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.21,306.32a.15.15,0,0,1-.17-.14.14.14,0,0,1,.14-.16.14.14,0,0,1,.16.13A.15.15,0,0,1,245.21,306.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M182.29,327.09a3.57,3.57,0,1,1,3.16-3.94A3.55,3.55,0,0,1,182.29,327.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M192.25,325.47a3.05,3.05,0,1,1,2.7-3.37A3.06,3.06,0,0,1,192.25,325.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M201.13,323.91a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,201.13,323.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M209.1,322.66a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,209.1,322.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216.32,321.47a1.73,1.73,0,1,1,1.52-1.91A1.73,1.73,0,0,1,216.32,321.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M222.7,320.32a1.3,1.3,0,0,1-1.42-1.14,1.29,1.29,0,1,1,1.42,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M227.69,319.43a1,1,0,0,1-1.06-.84,1,1,0,1,1,1.91-.22A1,1,0,0,1,227.69,319.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M232.14,318.72a.74.74,0,1,1,.65-.82A.74.74,0,0,1,232.14,318.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.16,318.06a.54.54,0,0,1-.58-.47.53.53,0,1,1,.58.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M239.81,317.48a.36.36,0,0,1-.39-.31.36.36,0,1,1,.39.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M243.18,317a.24.24,0,0,1-.26-.21.23.23,0,0,1,.21-.26.23.23,0,0,1,.25.21A.23.23,0,0,1,243.18,317Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M246.34,316.55a.16.16,0,0,1-.17-.13.16.16,0,0,1,.14-.17.16.16,0,0,1,.17.13A.15.15,0,0,1,246.34,316.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M183.43,337.32a3.57,3.57,0,1,1,3.15-3.93A3.56,3.56,0,0,1,183.43,337.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M193.39,335.7a3.05,3.05,0,1,1,2.7-3.37A3,3,0,0,1,193.39,335.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M202.26,334.14a2.48,2.48,0,1,1,2.2-2.74A2.49,2.49,0,0,1,202.26,334.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M210.23,332.89a2.12,2.12,0,1,1,1.87-2.34A2.11,2.11,0,0,1,210.23,332.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217.45,331.7a1.73,1.73,0,1,1,1.53-1.91A1.73,1.73,0,0,1,217.45,331.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.84,330.55a1.29,1.29,0,1,1,1.14-1.42A1.3,1.3,0,0,1,223.84,330.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M228.83,329.67a1,1,0,1,1,.84-1.06A1,1,0,0,1,228.83,329.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M233.28,329a.74.74,0,1,1,.65-.82A.75.75,0,0,1,233.28,329Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.3,328.29a.53.53,0,0,1-.58-.46.54.54,0,0,1,.46-.59.53.53,0,0,1,.58.47A.51.51,0,0,1,237.3,328.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M241,327.72a.37.37,0,0,1-.4-.32.35.35,0,0,1,.32-.39.34.34,0,0,1,.39.31A.37.37,0,0,1,241,327.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M244.31,327.22a.24.24,0,0,1-.05-.47.24.24,0,1,1,.05.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.48,326.79a.15.15,0,0,1-.17-.14.16.16,0,0,1,.13-.17.15.15,0,0,1,.17.14A.16.16,0,0,1,247.48,326.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M184.56,347.56a3.57,3.57,0,1,1,3.16-3.94A3.58,3.58,0,0,1,184.56,347.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M194.52,345.93a3,3,0,1,1,2.7-3.37A3.05,3.05,0,0,1,194.52,345.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M203.4,344.38a2.49,2.49,0,1,1,2.19-2.74A2.49,2.49,0,0,1,203.4,344.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M211.37,343.13a2.12,2.12,0,1,1,1.87-2.34A2.13,2.13,0,0,1,211.37,343.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M218.59,341.93a1.73,1.73,0,1,1,1.52-1.9A1.72,1.72,0,0,1,218.59,341.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M225,340.78a1.29,1.29,0,1,1,1.14-1.42A1.29,1.29,0,0,1,225,340.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M230,339.9a1,1,0,1,1,.85-1.06A1,1,0,0,1,230,339.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.41,339.18a.73.73,0,1,1,.65-.81A.73.73,0,0,1,234.41,339.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M238.43,338.52a.51.51,0,0,1-.58-.46.53.53,0,0,1,.47-.58.51.51,0,0,1,.58.46A.53.53,0,0,1,238.43,338.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M242.08,338a.36.36,0,1,1,.32-.4A.36.36,0,0,1,242.08,338Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.45,337.45a.23.23,0,1,1,0-.46.22.22,0,0,1,.25.2A.22.22,0,0,1,245.45,337.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M248.61,337a.16.16,0,0,1-.17-.14.16.16,0,0,1,.14-.17.17.17,0,0,1,.17.14A.16.16,0,0,1,248.61,337Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M185.7,357.79a3.57,3.57,0,1,1,3.15-3.94A3.56,3.56,0,0,1,185.7,357.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M195.66,356.17a3.05,3.05,0,1,1,2.7-3.37A3,3,0,0,1,195.66,356.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M204.53,354.61a2.48,2.48,0,1,1,2.2-2.74A2.49,2.49,0,0,1,204.53,354.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212.5,353.36a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,212.5,353.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M219.72,352.17a1.73,1.73,0,1,1,1.53-1.91A1.74,1.74,0,0,1,219.72,352.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226.11,351a1.28,1.28,0,1,1,1.14-1.42A1.28,1.28,0,0,1,226.11,351Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231.1,350.13a1,1,0,0,1-1.07-.85,1,1,0,0,1,.85-1.06,1,1,0,0,1,.22,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235.55,349.41a.73.73,0,1,1-.17-1.46.75.75,0,0,1,.82.65A.74.74,0,0,1,235.55,349.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M239.57,348.76a.53.53,0,0,1-.58-.47.52.52,0,0,1,.46-.58.53.53,0,0,1,.12,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M243.22,348.18a.37.37,0,0,1-.4-.31.36.36,0,0,1,.32-.4.36.36,0,0,1,.08.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M246.58,347.69a.24.24,0,0,1-.26-.21.24.24,0,0,1,.47-.05A.24.24,0,0,1,246.58,347.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M249.75,347.25a.15.15,0,1,1,.13-.17A.15.15,0,0,1,249.75,347.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M186.83,368a3.57,3.57,0,1,1,3.16-3.94A3.56,3.56,0,0,1,186.83,368Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M196.79,366.4a3.05,3.05,0,1,1,2.7-3.37A3.05,3.05,0,0,1,196.79,366.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M205.67,364.84a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,205.67,364.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M213.64,363.59a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,213.64,363.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.86,362.4a1.73,1.73,0,1,1,1.52-1.91A1.72,1.72,0,0,1,220.86,362.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M227.24,361.25a1.29,1.29,0,1,1,1.14-1.42A1.29,1.29,0,0,1,227.24,361.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M232.23,360.37a1,1,0,0,1-1.06-.85,1,1,0,1,1,1.91-.21A1,1,0,0,1,232.23,360.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.68,359.65a.74.74,0,1,1,.65-.82A.74.74,0,0,1,236.68,359.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.7,359a.53.53,0,0,1-.58-.47.54.54,0,0,1,.47-.58.53.53,0,1,1,.11,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M244.35,358.41a.35.35,0,0,1-.39-.31.37.37,0,0,1,.31-.4.36.36,0,0,1,.4.32A.35.35,0,0,1,244.35,358.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.72,357.92a.24.24,0,1,1,.2-.26A.23.23,0,0,1,247.72,357.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M250.88,357.49a.17.17,0,0,1-.17-.14.16.16,0,1,1,.17.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188,378.26a3.57,3.57,0,1,1,3.15-3.94A3.58,3.58,0,0,1,188,378.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M197.93,376.63a3,3,0,1,1,2.7-3.37A3,3,0,0,1,197.93,376.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M206.8,375.07a2.48,2.48,0,1,1,2.2-2.74A2.48,2.48,0,0,1,206.8,375.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M214.77,373.82a2.11,2.11,0,1,1,1.87-2.33A2.11,2.11,0,0,1,214.77,373.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M222,372.63a1.73,1.73,0,1,1,1.53-1.91A1.73,1.73,0,0,1,222,372.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M228.38,371.48a1.29,1.29,0,1,1,1.13-1.42A1.28,1.28,0,0,1,228.38,371.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M233.36,370.6a1,1,0,1,1-.21-1.91,1,1,0,0,1,.21,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.82,369.88a.75.75,0,0,1-.82-.65.74.74,0,0,1,1.47-.16A.74.74,0,0,1,237.82,369.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M241.84,369.22a.52.52,0,0,1-.58-.46.52.52,0,1,1,.58.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.49,368.65a.36.36,0,0,1-.4-.32.36.36,0,1,1,.4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M248.85,368.15a.24.24,0,0,1-.26-.21.24.24,0,0,1,.47-.05A.24.24,0,0,1,248.85,368.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M252,367.72a.15.15,0,0,1-.17-.14.16.16,0,0,1,.13-.17.15.15,0,0,1,.17.14A.16.16,0,0,1,252,367.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 188.71,
    cy: 384.94,
    r: 3.57,
    transform: "translate(-229.87 292.27) rotate(-51.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M199.06,386.87a3.05,3.05,0,1,1,2.7-3.37A3.07,3.07,0,0,1,199.06,386.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M207.94,385.31a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,207.94,385.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M215.91,384.06a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,215.91,384.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.13,382.87a1.73,1.73,0,1,1,1.52-1.91A1.73,1.73,0,0,1,223.13,382.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M229.51,381.71a1.28,1.28,0,1,1,1.14-1.42A1.29,1.29,0,0,1,229.51,381.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.5,380.83a1,1,0,1,1,.85-1.06A1,1,0,0,1,234.5,380.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M239,380.11a.73.73,0,1,1,.65-.81A.73.73,0,0,1,239,380.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M243,379.46a.53.53,0,0,1-.11-1,.52.52,0,0,1,.58.46A.54.54,0,0,1,243,379.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M246.62,378.88a.36.36,0,0,1-.08-.71.36.36,0,0,1,.4.32A.36.36,0,0,1,246.62,378.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M250,378.38a.22.22,0,0,1-.26-.2.23.23,0,1,1,.46-.05A.23.23,0,0,1,250,378.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.15,378a.16.16,0,0,1-.17-.13.15.15,0,0,1,.14-.17.16.16,0,0,1,.17.13A.15.15,0,0,1,253.15,378Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M190.24,398.72a3.57,3.57,0,1,1,3.15-3.94A3.56,3.56,0,0,1,190.24,398.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M200.2,397.1a3.05,3.05,0,1,1,2.7-3.37A3,3,0,0,1,200.2,397.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M209.07,395.54a2.48,2.48,0,1,1,2.2-2.74A2.48,2.48,0,0,1,209.07,395.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217,394.29a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,217,394.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224.26,393.1a1.73,1.73,0,1,1,1.53-1.91A1.74,1.74,0,0,1,224.26,393.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M230.65,392a1.29,1.29,0,1,1,1.13-1.42A1.28,1.28,0,0,1,230.65,392Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235.63,391.06a1,1,0,1,1,.85-1.06A1,1,0,0,1,235.63,391.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.09,390.35a.74.74,0,1,1,.65-.82A.75.75,0,0,1,240.09,390.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M244.11,389.69a.53.53,0,0,1-.58-.47.51.51,0,0,1,.46-.58.53.53,0,0,1,.58.47A.52.52,0,0,1,244.11,389.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.76,389.11a.36.36,0,0,1-.4-.31.37.37,0,0,1,.32-.4.36.36,0,0,1,.08.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M251.12,388.62a.24.24,0,0,1-.26-.21.24.24,0,0,1,.21-.26.24.24,0,1,1,.05.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M254.29,388.18a.15.15,0,1,1,.13-.17A.15.15,0,0,1,254.29,388.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M191.37,409a3.57,3.57,0,1,1,3.15-3.93A3.56,3.56,0,0,1,191.37,409Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M201.33,407.33A3.05,3.05,0,1,1,204,404,3.05,3.05,0,0,1,201.33,407.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M210.21,405.77A2.48,2.48,0,1,1,212.4,403,2.48,2.48,0,0,1,210.21,405.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M218.18,404.52a2.12,2.12,0,1,1,1.87-2.33A2.12,2.12,0,0,1,218.18,404.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M225.39,403.33a1.73,1.73,0,1,1,1.53-1.91A1.72,1.72,0,0,1,225.39,403.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231.78,402.18a1.29,1.29,0,1,1,1.14-1.42A1.29,1.29,0,0,1,231.78,402.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.77,401.3a1,1,0,1,1,.85-1.06A1,1,0,0,1,236.77,401.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M241.22,400.58a.74.74,0,1,1,.65-.81A.74.74,0,0,1,241.22,400.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.24,399.92a.52.52,0,0,1-.58-.46.54.54,0,0,1,.47-.59.53.53,0,1,1,.11,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M248.89,399.35a.36.36,0,0,1-.39-.32.35.35,0,0,1,.31-.39.36.36,0,0,1,.4.31A.37.37,0,0,1,248.89,399.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M252.26,398.85a.24.24,0,0,1-.26-.21.23.23,0,0,1,.2-.26.24.24,0,0,1,.26.21A.23.23,0,0,1,252.26,398.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M255.42,398.42a.16.16,0,1,1,.14-.17A.16.16,0,0,1,255.42,398.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M192.51,419.19a3.57,3.57,0,1,1,3.15-3.94A3.58,3.58,0,0,1,192.51,419.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M202.47,417.56a3,3,0,1,1,2.69-3.37A3,3,0,0,1,202.47,417.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M211.34,416a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,211.34,416Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M219.31,414.76a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,219.31,414.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226.53,413.56a1.73,1.73,0,1,1,1.53-1.9A1.72,1.72,0,0,1,226.53,413.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M232.92,412.41a1.29,1.29,0,1,1,1.13-1.42A1.28,1.28,0,0,1,232.92,412.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.9,411.53a1,1,0,1,1,.85-1.06A1,1,0,0,1,237.9,411.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M242.36,410.81A.73.73,0,1,1,243,410,.73.73,0,0,1,242.36,410.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M246.38,410.15a.52.52,0,0,1-.12-1,.52.52,0,0,1,.12,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M250,409.58a.36.36,0,0,1-.4-.32.36.36,0,1,1,.4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.39,409.08a.23.23,0,1,1,0-.46.23.23,0,0,1,.26.2A.24.24,0,0,1,253.39,409.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256.56,408.65a.15.15,0,0,1-.17-.14.14.14,0,0,1,.13-.16.15.15,0,0,1,.17.13A.16.16,0,0,1,256.56,408.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M193.64,429.42a3.57,3.57,0,1,1,3.15-3.94A3.56,3.56,0,0,1,193.64,429.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M203.6,427.8a3.05,3.05,0,1,1,2.7-3.37A3.06,3.06,0,0,1,203.6,427.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212.48,426.24a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,212.48,426.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.45,425a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,220.45,425Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M227.66,423.8a1.73,1.73,0,1,1,1.53-1.91A1.73,1.73,0,0,1,227.66,423.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.05,422.65a1.3,1.3,0,0,1-1.42-1.14,1.29,1.29,0,1,1,1.42,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M239,421.76a1,1,0,0,1-.21-1.91,1,1,0,0,1,1.06.85A1,1,0,0,1,239,421.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M243.49,421a.73.73,0,1,1-.16-1.46.74.74,0,0,1,.81.65A.73.73,0,0,1,243.49,421Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.51,420.39a.53.53,0,1,1-.11-1.05.53.53,0,1,1,.11,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M251.16,419.81a.36.36,0,0,1-.08-.71.37.37,0,0,1,.4.32A.36.36,0,0,1,251.16,419.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M254.52,419.32a.23.23,0,0,1-.25-.21.22.22,0,0,1,.2-.26.23.23,0,0,1,.26.21A.24.24,0,0,1,254.52,419.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M257.69,418.88a.16.16,0,0,1-.17-.13.15.15,0,0,1,.14-.17.16.16,0,0,1,.17.13A.15.15,0,0,1,257.69,418.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M194.78,439.65a3.57,3.57,0,1,1,3.15-3.94A3.56,3.56,0,0,1,194.78,439.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M204.74,438a3.05,3.05,0,1,1,2.69-3.37A3,3,0,0,1,204.74,438Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M213.61,436.47a2.48,2.48,0,1,1,2.19-2.74A2.48,2.48,0,0,1,213.61,436.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M221.58,435.22a2.12,2.12,0,1,1,1.87-2.34A2.12,2.12,0,0,1,221.58,435.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M228.8,434a1.73,1.73,0,1,1,1.53-1.91A1.73,1.73,0,0,1,228.8,434Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235.19,432.88a1.29,1.29,0,1,1,1.13-1.42A1.29,1.29,0,0,1,235.19,432.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.17,432a1,1,0,0,1-1.06-.85,1,1,0,1,1,1.06.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M244.62,431.28a.74.74,0,1,1,.66-.82A.74.74,0,0,1,244.62,431.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M248.65,430.62a.53.53,0,1,1,.46-.58A.52.52,0,0,1,248.65,430.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M252.3,430a.35.35,0,0,1-.4-.31.35.35,0,0,1,.32-.39.34.34,0,0,1,.39.31A.35.35,0,0,1,252.3,430Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M255.66,429.55a.24.24,0,0,1-.26-.21.24.24,0,1,1,.26.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M258.83,429.12a.16.16,0,0,1-.17-.14.16.16,0,0,1,.13-.17.15.15,0,0,1,.17.14A.16.16,0,0,1,258.83,429.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M182.65,433.82a3.57,3.57,0,1,1-3.16,3.94A3.55,3.55,0,0,1,182.65,433.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M172.69,435.44a3.05,3.05,0,1,1-2.7,3.37A3.06,3.06,0,0,1,172.69,435.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M163.81,437a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,163.81,437Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.84,438.25a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,155.84,438.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M148.62,439.44a1.73,1.73,0,1,1-1.52,1.91A1.73,1.73,0,0,1,148.62,439.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M142.24,440.6A1.28,1.28,0,1,1,141.1,442,1.29,1.29,0,0,1,142.24,440.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M137.25,441.48a1,1,0,1,1,.21,1.91,1,1,0,0,1-1.06-.85A1,1,0,0,1,137.25,441.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M132.8,442.2a.73.73,0,1,1-.65.81A.73.73,0,0,1,132.8,442.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M128.78,442.85a.54.54,0,0,1,.58.47.53.53,0,0,1-1.05.11A.54.54,0,0,1,128.78,442.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.13,443.43a.36.36,0,0,1,.39.31.36.36,0,1,1-.39-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121.76,443.92a.24.24,0,0,1,.26.21.23.23,0,0,1-.21.26.24.24,0,0,1-.26-.21A.25.25,0,0,1,121.76,443.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.6,444.36a.16.16,0,0,1,.17.13.16.16,0,0,1-.14.17.16.16,0,0,1-.17-.13A.15.15,0,0,1,118.6,444.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181.51,423.59a3.57,3.57,0,1,1-3.15,3.94A3.56,3.56,0,0,1,181.51,423.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M171.55,425.21a3.05,3.05,0,1,1-2.7,3.37A3,3,0,0,1,171.55,425.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M162.68,426.77a2.48,2.48,0,1,1-2.2,2.74A2.47,2.47,0,0,1,162.68,426.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154.71,428a2.12,2.12,0,1,1-1.88,2.34A2.11,2.11,0,0,1,154.71,428Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M147.49,429.21a1.73,1.73,0,1,1-1.53,1.91A1.73,1.73,0,0,1,147.49,429.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M141.1,430.36a1.29,1.29,0,1,1-1.14,1.42A1.28,1.28,0,0,1,141.1,430.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M136.11,431.24a1,1,0,0,1,1.06.85,1,1,0,1,1-1.9.21A1,1,0,0,1,136.11,431.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M131.66,432a.74.74,0,1,1-.65.82A.75.75,0,0,1,131.66,432Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M127.64,432.62a.53.53,0,1,1-.46.58A.51.51,0,0,1,127.64,432.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124,433.2a.36.36,0,0,1,.4.31.37.37,0,0,1-.32.4.35.35,0,0,1-.39-.32A.34.34,0,0,1,124,433.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.63,433.69a.24.24,0,0,1,.05.47.24.24,0,0,1-.26-.21A.24.24,0,0,1,120.63,433.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.46,434.12a.16.16,0,0,1,.17.14.16.16,0,0,1-.14.17.14.14,0,0,1-.16-.14A.16.16,0,0,1,117.46,434.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M180.38,413.35a3.57,3.57,0,1,1-3.16,3.94A3.57,3.57,0,0,1,180.38,413.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170.42,415a3,3,0,1,1-2.7,3.37A3.05,3.05,0,0,1,170.42,415Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.54,416.54a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,161.54,416.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M153.57,417.79a2.11,2.11,0,1,1-1.87,2.33A2.11,2.11,0,0,1,153.57,417.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M146.35,419a1.73,1.73,0,1,1-1.52,1.91A1.72,1.72,0,0,1,146.35,419Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M140,420.13a1.29,1.29,0,1,1-1.14,1.42A1.29,1.29,0,0,1,140,420.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135,421a1,1,0,1,1-.85,1.06A1,1,0,0,1,135,421Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130.53,421.73a.74.74,0,0,1,.81.65.73.73,0,1,1-.81-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126.51,422.39a.52.52,0,1,1,.11,1A.51.51,0,0,1,126,423,.53.53,0,0,1,126.51,422.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.86,423a.36.36,0,1,1-.32.4A.36.36,0,0,1,122.86,423Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.49,423.46a.23.23,0,0,1,.26.21.23.23,0,1,1-.46.05A.22.22,0,0,1,119.49,423.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.33,423.89a.16.16,0,0,1,.17.14.16.16,0,0,1-.14.17.16.16,0,1,1,0-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M179.24,403.12a3.57,3.57,0,1,1-3.15,3.94A3.57,3.57,0,0,1,179.24,403.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M169.28,404.74a3.05,3.05,0,1,1-2.7,3.37A3.06,3.06,0,0,1,169.28,404.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.41,406.3a2.48,2.48,0,1,1-2.2,2.74A2.49,2.49,0,0,1,160.41,406.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M152.44,407.55a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,152.44,407.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145.22,408.74a1.73,1.73,0,1,1-1.53,1.91A1.74,1.74,0,0,1,145.22,408.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.83,409.9a1.28,1.28,0,1,1-1.14,1.42A1.3,1.3,0,0,1,138.83,409.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M133.84,410.78a1,1,0,0,1,1.06.85,1,1,0,0,1-.84,1.06,1,1,0,0,1-.22-1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.39,411.5a.73.73,0,1,1-.65.81A.73.73,0,0,1,129.39,411.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.37,412.15a.53.53,0,0,1,.58.47.52.52,0,0,1-.46.58.53.53,0,0,1-.12-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121.72,412.73a.37.37,0,0,1,.4.32.36.36,0,0,1-.32.39.35.35,0,0,1-.39-.32A.36.36,0,0,1,121.72,412.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.36,413.23a.23.23,0,0,1,.26.2.24.24,0,0,1-.21.26.23.23,0,0,1-.26-.2A.24.24,0,0,1,118.36,413.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.19,413.66a.15.15,0,1,1-.13.17A.15.15,0,0,1,115.19,413.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M178.11,392.89a3.57,3.57,0,1,1-3.16,3.94A3.57,3.57,0,0,1,178.11,392.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M168.15,394.51a3.05,3.05,0,1,1-2.7,3.37A3.06,3.06,0,0,1,168.15,394.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.27,396.07a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,159.27,396.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M151.3,397.32a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,151.3,397.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M144.08,398.51a1.73,1.73,0,1,1-1.52,1.91A1.73,1.73,0,0,1,144.08,398.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M137.7,399.66a1.29,1.29,0,1,1-1.14,1.42A1.3,1.3,0,0,1,137.7,399.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M132.71,400.55a1,1,0,1,1-.85,1.06A1,1,0,0,1,132.71,400.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M128.26,401.26a.74.74,0,1,1-.65.82A.74.74,0,0,1,128.26,401.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.24,401.92a.53.53,0,1,1-.47.58A.53.53,0,0,1,124.24,401.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.59,402.5a.36.36,0,0,1,.39.31.37.37,0,0,1-.31.4.36.36,0,0,1-.4-.32A.36.36,0,0,1,120.59,402.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.22,403a.24.24,0,0,1,.26.21.23.23,0,0,1-.2.26.24.24,0,0,1-.26-.21A.23.23,0,0,1,117.22,403Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.06,403.43a.16.16,0,0,1,.17.13.16.16,0,0,1-.14.17.16.16,0,0,1-.17-.13A.15.15,0,0,1,114.06,403.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M177,382.66a3.57,3.57,0,1,1-3.15,3.93A3.56,3.56,0,0,1,177,382.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M167,384.28a3.05,3.05,0,1,1-2.7,3.37A3,3,0,0,1,167,384.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M158.14,385.84a2.48,2.48,0,1,1-2.2,2.74A2.49,2.49,0,0,1,158.14,385.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.17,387.09a2.12,2.12,0,1,1-1.87,2.33A2.12,2.12,0,0,1,150.17,387.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M143,388.28a1.73,1.73,0,1,1-1.53,1.91A1.73,1.73,0,0,1,143,388.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M136.56,389.43a1.29,1.29,0,1,1-1.13,1.42A1.28,1.28,0,0,1,136.56,389.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M131.57,390.31a1,1,0,1,1,.22,1.91,1,1,0,0,1-1.06-.85A1,1,0,0,1,131.57,390.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M127.12,391a.74.74,0,1,1-.65.81A.75.75,0,0,1,127.12,391Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123.1,391.69a.52.52,0,0,1,.58.46.54.54,0,0,1-.46.59.53.53,0,0,1-.58-.47A.51.51,0,0,1,123.1,391.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.45,392.26a.37.37,0,0,1,.4.32.36.36,0,0,1-.71.08A.37.37,0,0,1,119.45,392.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.09,392.76a.24.24,0,1,1-.21.26A.24.24,0,0,1,116.09,392.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.92,393.19a.15.15,0,0,1,.17.14.16.16,0,0,1-.13.17.15.15,0,0,1-.17-.14A.16.16,0,0,1,112.92,393.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M175.84,372.42a3.57,3.57,0,1,1-3.16,3.94A3.58,3.58,0,0,1,175.84,372.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M165.88,374.05a3,3,0,1,1-2.7,3.37A3.05,3.05,0,0,1,165.88,374.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M157,375.6a2.49,2.49,0,1,1-2.19,2.74A2.48,2.48,0,0,1,157,375.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M149,376.85a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,149,376.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M141.81,378.05a1.73,1.73,0,1,1-1.52,1.9A1.72,1.72,0,0,1,141.81,378.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135.43,379.2a1.29,1.29,0,1,1-1.14,1.42A1.29,1.29,0,0,1,135.43,379.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130.44,380.08a1,1,0,1,1-.85,1.06A1,1,0,0,1,130.44,380.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126,380.8a.73.73,0,1,1-.65.81A.73.73,0,0,1,126,380.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122,381.46a.51.51,0,0,1,.58.46.53.53,0,0,1-.47.58.52.52,0,0,1-.58-.46A.53.53,0,0,1,122,381.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.32,382a.36.36,0,1,1-.32.4A.36.36,0,0,1,118.32,382Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115,382.53a.23.23,0,1,1,.06.46.23.23,0,0,1-.06-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.79,383a.16.16,0,0,1,.17.14.14.14,0,0,1-.14.16.15.15,0,1,1,0-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M174.7,362.19a3.57,3.57,0,1,1-3.15,3.94A3.56,3.56,0,0,1,174.7,362.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M164.74,363.81a3.05,3.05,0,1,1-2.7,3.37A3,3,0,0,1,164.74,363.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.87,365.37a2.48,2.48,0,1,1-2.2,2.74A2.48,2.48,0,0,1,155.87,365.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M147.9,366.62A2.12,2.12,0,1,1,146,369,2.12,2.12,0,0,1,147.9,366.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M140.68,367.81a1.73,1.73,0,1,1-1.53,1.91A1.74,1.74,0,0,1,140.68,367.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M134.29,369a1.28,1.28,0,1,1-1.13,1.42A1.28,1.28,0,0,1,134.29,369Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.31,369.85a1,1,0,0,1,1.06.85,1,1,0,1,1-1.91.21A1,1,0,0,1,129.31,369.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.85,370.57a.73.73,0,0,1,.82.65.74.74,0,0,1-1.47.16A.73.73,0,0,1,124.85,370.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.83,371.22a.53.53,0,0,1,.58.47.51.51,0,0,1-.46.58.53.53,0,0,1-.58-.47A.52.52,0,0,1,120.83,371.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.18,371.8a.36.36,0,1,1-.31.39A.36.36,0,0,1,117.18,371.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.82,372.29a.24.24,0,0,1,.26.21.24.24,0,0,1-.47.05A.24.24,0,0,1,113.82,372.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.65,372.73a.15.15,0,1,1-.13.17A.15.15,0,0,1,110.65,372.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M173.57,352a3.57,3.57,0,1,1-3.15,3.94A3.56,3.56,0,0,1,173.57,352Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M163.61,353.58a3.05,3.05,0,1,1-2.7,3.37A3.05,3.05,0,0,1,163.61,353.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154.73,355.14a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,154.73,355.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M146.76,356.39a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,146.76,356.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M139.54,357.58a1.73,1.73,0,1,1-1.52,1.91A1.72,1.72,0,0,1,139.54,357.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M133.16,358.73a1.29,1.29,0,1,1-1.14,1.42A1.29,1.29,0,0,1,133.16,358.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M128.17,359.61a1,1,0,0,1,1.06.85,1,1,0,1,1-1.06-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123.72,360.33a.74.74,0,1,1-.65.82A.74.74,0,0,1,123.72,360.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.7,361a.53.53,0,0,1,.58.47.54.54,0,0,1-.47.58.53.53,0,0,1-.11-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.05,361.57a.34.34,0,0,1,.39.31.35.35,0,0,1-.31.39.35.35,0,0,1-.4-.31A.35.35,0,0,1,116.05,361.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.68,362.06a.24.24,0,1,1-.2.26A.24.24,0,0,1,112.68,362.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.52,362.49a.16.16,0,0,1,.17.14.16.16,0,1,1-.17-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M172.43,341.72a3.57,3.57,0,1,1-3.15,3.94A3.58,3.58,0,0,1,172.43,341.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M162.47,343.35a3,3,0,1,1-2.69,3.37A3,3,0,0,1,162.47,343.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M153.6,344.91a2.48,2.48,0,1,1-2.2,2.73A2.48,2.48,0,0,1,153.6,344.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145.63,346.15A2.13,2.13,0,0,1,148,348a2.12,2.12,0,1,1-2.34-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.41,347.35a1.73,1.73,0,1,1-1.53,1.91A1.73,1.73,0,0,1,138.41,347.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M132,348.5a1.29,1.29,0,1,1-1.13,1.42A1.28,1.28,0,0,1,132,348.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M127,349.38a1,1,0,1,1-.85,1.06A1,1,0,0,1,127,349.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.58,350.1a.73.73,0,1,1-.65.81A.74.74,0,0,1,122.58,350.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.56,350.76a.52.52,0,1,1-.46.58A.52.52,0,0,1,118.56,350.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.91,351.33a.36.36,0,0,1,.4.32.36.36,0,1,1-.4-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.55,351.83a.24.24,0,0,1,.26.21.25.25,0,0,1-.21.26.24.24,0,0,1-.26-.21A.24.24,0,0,1,111.55,351.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.38,352.26a.15.15,0,0,1,.17.14.16.16,0,0,1-.13.17.16.16,0,0,1-.17-.14A.16.16,0,0,1,108.38,352.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M171.3,331.49a3.57,3.57,0,1,1-3.15,3.94A3.57,3.57,0,0,1,171.3,331.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.34,333.11a3.05,3.05,0,1,1-2.7,3.37A3.07,3.07,0,0,1,161.34,333.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M152.46,334.67a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,152.46,334.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M144.49,335.92a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,144.49,335.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M137.28,337.11a1.73,1.73,0,1,1-1.53,1.91A1.73,1.73,0,0,1,137.28,337.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130.89,338.27a1.28,1.28,0,1,1-1.14,1.42A1.28,1.28,0,0,1,130.89,338.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.9,339.15a1,1,0,1,1-.85,1.06A1,1,0,0,1,125.9,339.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121.45,339.87a.73.73,0,1,1-.65.81A.73.73,0,0,1,121.45,339.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.43,340.52a.53.53,0,1,1-.47.59A.54.54,0,0,1,117.43,340.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.78,341.1a.36.36,0,0,1,.39.31.36.36,0,0,1-.31.4.37.37,0,0,1-.4-.32A.36.36,0,0,1,113.78,341.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.41,341.6a.23.23,0,0,1,.06.46.23.23,0,0,1-.26-.21A.23.23,0,0,1,110.41,341.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M107.25,342a.16.16,0,0,1,.17.13.15.15,0,0,1-.14.17.16.16,0,0,1-.17-.13A.15.15,0,0,1,107.25,342Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170.16,321.26A3.57,3.57,0,1,1,167,325.2,3.56,3.56,0,0,1,170.16,321.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.2,322.88a3.05,3.05,0,1,1-2.69,3.37A3,3,0,0,1,160.2,322.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M151.33,324.44a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,151.33,324.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M143.36,325.69a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,143.36,325.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M136.14,326.88a1.73,1.73,0,1,1-1.53,1.91A1.74,1.74,0,0,1,136.14,326.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.75,328a1.29,1.29,0,1,1-1.13,1.42A1.28,1.28,0,0,1,129.75,328Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.77,328.91a1,1,0,0,1,1.06.85,1,1,0,0,1-1.91.22A1,1,0,0,1,124.77,328.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.31,329.63a.74.74,0,1,1-.65.82A.75.75,0,0,1,120.31,329.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.29,330.29a.53.53,0,0,1,.58.47.51.51,0,0,1-.46.58.53.53,0,0,1-.58-.47A.52.52,0,0,1,116.29,330.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.64,330.87a.35.35,0,0,1,.4.31.37.37,0,0,1-.32.4.36.36,0,0,1-.39-.32A.35.35,0,0,1,112.64,330.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.28,331.36a.24.24,0,1,1-.21.26A.24.24,0,0,1,109.28,331.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.11,331.8a.15.15,0,1,1-.13.16A.14.14,0,0,1,106.11,331.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M169,311a3.57,3.57,0,1,1-3.15,3.94A3.58,3.58,0,0,1,169,311Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.07,312.65a3,3,0,1,1-2.7,3.37A3.05,3.05,0,0,1,159.07,312.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.19,314.21A2.48,2.48,0,1,1,148,317,2.48,2.48,0,0,1,150.19,314.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M142.22,315.46a2.12,2.12,0,1,1-1.87,2.33A2.11,2.11,0,0,1,142.22,315.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135,316.65a1.73,1.73,0,1,1-1.53,1.91A1.72,1.72,0,0,1,135,316.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M128.62,317.8a1.29,1.29,0,1,1-1.14,1.42A1.28,1.28,0,0,1,128.62,317.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123.63,318.68a1,1,0,1,1-.85,1.06A1,1,0,0,1,123.63,318.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.18,319.4a.74.74,0,0,1,.81.65.73.73,0,0,1-1.46.16A.74.74,0,0,1,119.18,319.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.16,320.06a.52.52,0,0,1,.58.46.53.53,0,0,1-.47.58.52.52,0,0,1-.58-.46A.53.53,0,0,1,115.16,320.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.51,320.63a.36.36,0,0,1,.08.71.36.36,0,1,1-.08-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.15,321.13a.24.24,0,0,1,0,.47.24.24,0,0,1-.26-.21A.23.23,0,0,1,108.15,321.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105,321.56a.16.16,0,1,1-.14.17A.16.16,0,0,1,105,321.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M167.89,300.79a3.57,3.57,0,1,1-3.15,3.94A3.57,3.57,0,0,1,167.89,300.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M157.93,302.41a3.05,3.05,0,1,1-2.69,3.37A3.06,3.06,0,0,1,157.93,302.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M149.06,304a2.49,2.49,0,1,1-2.19,2.74A2.48,2.48,0,0,1,149.06,304Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M141.09,305.22a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,141.09,305.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M133.87,306.41a1.73,1.73,0,1,1-1.53,1.91A1.74,1.74,0,0,1,133.87,306.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M127.48,307.57a1.29,1.29,0,0,1,1.43,1.13,1.29,1.29,0,1,1-2.56.29A1.28,1.28,0,0,1,127.48,307.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.5,308.45a1,1,0,1,1-.85,1.06A1,1,0,0,1,122.5,308.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.05,309.17a.73.73,0,0,1,.81.65.74.74,0,1,1-.81-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114,309.83a.52.52,0,1,1,.12,1,.52.52,0,0,1-.12-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.37,310.4a.36.36,0,0,1,.4.32.36.36,0,1,1-.4-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M107,310.9a.22.22,0,0,1,.26.2.24.24,0,1,1-.26-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.84,311.33a.15.15,0,0,1,.17.13.14.14,0,0,1-.13.17.15.15,0,1,1,0-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M166.76,290.56a3.57,3.57,0,1,1-3.15,3.94A3.56,3.56,0,0,1,166.76,290.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M156.8,292.18a3.05,3.05,0,1,1-2.7,3.37A3.06,3.06,0,0,1,156.8,292.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M147.92,293.74a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,147.92,293.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M140,295a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,140,295Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M132.74,296.18a1.73,1.73,0,1,1-1.53,1.91A1.72,1.72,0,0,1,132.74,296.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126.35,297.33a1.3,1.3,0,0,1,1.42,1.14,1.29,1.29,0,1,1-1.42-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121.36,298.22a1,1,0,0,1,1.06.84,1,1,0,0,1-.85,1.07,1,1,0,0,1-1.06-.85A1,1,0,0,1,121.36,298.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.91,298.93a.74.74,0,0,1,.81.66.73.73,0,0,1-.65.81.74.74,0,0,1-.16-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.89,299.59a.53.53,0,1,1,.11,1.05.54.54,0,0,1-.58-.47A.53.53,0,0,1,112.89,299.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.24,300.17a.36.36,0,0,1,.08.71.37.37,0,0,1-.4-.32A.36.36,0,0,1,109.24,300.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.88,300.66a.25.25,0,0,1,.26.21.24.24,0,1,1-.26-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.71,301.1a.16.16,0,0,1,.17.13.15.15,0,0,1-.14.17.16.16,0,0,1-.17-.13A.16.16,0,0,1,102.71,301.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M165.62,280.33a3.57,3.57,0,1,1-3.15,3.93A3.56,3.56,0,0,1,165.62,280.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.66,282a3.05,3.05,0,1,1-2.69,3.37A3,3,0,0,1,155.66,282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M146.79,283.51a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,146.79,283.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.82,284.76A2.12,2.12,0,1,1,137,287.1,2.12,2.12,0,0,1,138.82,284.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M131.6,286a1.73,1.73,0,1,1-1.53,1.91A1.73,1.73,0,0,1,131.6,286Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.21,287.1a1.29,1.29,0,1,1-1.13,1.42A1.29,1.29,0,0,1,125.21,287.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.23,288a1,1,0,1,1-.85,1.06A1,1,0,0,1,120.23,288Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.78,288.7a.74.74,0,1,1-.66.82A.74.74,0,0,1,115.78,288.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.75,289.36a.53.53,0,1,1,.12,1.05.53.53,0,0,1-.58-.47A.52.52,0,0,1,111.75,289.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.11,289.93a.36.36,0,0,1,.39.32.36.36,0,0,1-.71.08A.37.37,0,0,1,108.11,289.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.74,290.43a.24.24,0,0,1,.26.21.24.24,0,0,1-.47.05A.24.24,0,0,1,104.74,290.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.57,290.86a.15.15,0,0,1,.17.14.16.16,0,0,1-.13.17.15.15,0,0,1-.17-.14A.16.16,0,0,1,101.57,290.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M164.49,270.09a3.57,3.57,0,1,1-3.15,3.94A3.58,3.58,0,0,1,164.49,270.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154.53,271.72a3,3,0,1,1-2.7,3.37A3.05,3.05,0,0,1,154.53,271.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145.65,273.27a2.49,2.49,0,1,1-2.19,2.74A2.48,2.48,0,0,1,145.65,273.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M137.69,274.52a2.12,2.12,0,1,1-1.88,2.34A2.12,2.12,0,0,1,137.69,274.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130.47,275.72a1.73,1.73,0,1,1-1.53,1.9A1.72,1.72,0,0,1,130.47,275.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.08,276.87a1.29,1.29,0,1,1-1.14,1.42A1.28,1.28,0,0,1,124.08,276.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.09,277.75a1,1,0,1,1-.85,1.06A1,1,0,0,1,119.09,277.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.64,278.47a.73.73,0,1,1-.65.81A.74.74,0,0,1,114.64,278.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.62,279.13a.51.51,0,0,1,.58.46.53.53,0,1,1-.58-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M107,279.7a.36.36,0,1,1-.31.4A.35.35,0,0,1,107,279.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.61,280.2a.23.23,0,1,1,0,.46.22.22,0,0,1-.26-.2A.23.23,0,0,1,103.61,280.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.44,280.63a.16.16,0,0,1,0,.31.17.17,0,0,1-.17-.14A.16.16,0,0,1,100.44,280.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M163.35,259.86a3.57,3.57,0,1,1-3.15,3.94A3.56,3.56,0,0,1,163.35,259.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M153.39,261.48a3.05,3.05,0,1,1-2.69,3.37A3,3,0,0,1,153.39,261.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M144.52,263a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,144.52,263Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M136.55,264.29a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,136.55,264.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.33,265.48a1.73,1.73,0,1,1-1.53,1.91A1.73,1.73,0,0,1,129.33,265.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123,266.64a1.28,1.28,0,1,1-1.14,1.42A1.29,1.29,0,0,1,123,266.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118,267.52a1,1,0,1,1-.85,1.06A1,1,0,0,1,118,267.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.51,268.24a.73.73,0,0,1,.81.65.74.74,0,0,1-.65.81.73.73,0,1,1-.16-1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.48,268.89a.54.54,0,0,1,.59.47.53.53,0,0,1-1,.11A.54.54,0,0,1,109.48,268.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.84,269.47a.36.36,0,0,1,.39.31.36.36,0,0,1-.32.4.36.36,0,0,1-.07-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.47,270a.24.24,0,0,1,.26.21.23.23,0,0,1-.21.26.24.24,0,0,1-.26-.21A.24.24,0,0,1,102.47,270Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.31,270.4a.14.14,0,0,1,.16.13.15.15,0,1,1-.16-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M162.22,249.63a3.57,3.57,0,1,1-3.15,3.94A3.56,3.56,0,0,1,162.22,249.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M152.26,251.25a3.05,3.05,0,1,1-2.7,3.37A3,3,0,0,1,152.26,251.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M143.38,252.81a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,143.38,252.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135.42,254.06a2.12,2.12,0,1,1-1.88,2.34A2.11,2.11,0,0,1,135.42,254.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M128.2,255.25a1.73,1.73,0,1,1-1.53,1.91A1.73,1.73,0,0,1,128.2,255.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121.81,256.4a1.29,1.29,0,1,1-1.14,1.42A1.28,1.28,0,0,1,121.81,256.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.82,257.28a1,1,0,0,1,1.06.85,1,1,0,0,1-.85,1.06,1,1,0,0,1-1.06-.85A1,1,0,0,1,116.82,257.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.37,258a.74.74,0,0,1,.16,1.47.74.74,0,0,1-.16-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.35,258.66a.53.53,0,0,1,.58.47.53.53,0,0,1-.46.58.54.54,0,0,1-.59-.47A.53.53,0,0,1,108.35,258.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.7,259.24a.34.34,0,0,1,.39.31.35.35,0,1,1-.7.08A.34.34,0,0,1,104.7,259.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.34,259.73a.24.24,0,1,1,0,.47.24.24,0,1,1,0-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98.17,260.16a.17.17,0,0,1,.17.14.16.16,0,1,1-.31,0A.17.17,0,0,1,98.17,260.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.09,239.39a3.57,3.57,0,1,1-3.16,3.94A3.57,3.57,0,0,1,161.09,239.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M151.12,241a3,3,0,1,1-2.69,3.37A3,3,0,0,1,151.12,241Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M142.25,242.58a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,142.25,242.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M134.28,243.83a2.11,2.11,0,1,1-1.87,2.33A2.11,2.11,0,0,1,134.28,243.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M127.06,245a1.73,1.73,0,1,1-1.53,1.91A1.72,1.72,0,0,1,127.06,245Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.68,246.17a1.29,1.29,0,1,1-1.14,1.42A1.29,1.29,0,0,1,120.68,246.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.69,247.05a1,1,0,1,1-.85,1.06A1,1,0,0,1,115.69,247.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.24,247.77a.73.73,0,0,1,.16,1.46.72.72,0,0,1-.81-.65A.73.73,0,0,1,111.24,247.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M107.21,248.43a.54.54,0,0,1,.59.46.53.53,0,0,1-.47.58.51.51,0,0,1-.58-.46A.53.53,0,0,1,107.21,248.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.57,249a.36.36,0,1,1-.32.4A.36.36,0,0,1,103.57,249Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.2,249.5a.23.23,0,0,1,.26.21.24.24,0,0,1-.21.26.24.24,0,0,1-.26-.21A.24.24,0,0,1,100.2,249.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97,249.93a.14.14,0,0,1,.16.14.15.15,0,1,1-.16-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160,229.16a3.57,3.57,0,1,1-3.15,3.94A3.57,3.57,0,0,1,160,229.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150,230.78a3.05,3.05,0,1,1-2.7,3.37A3.06,3.06,0,0,1,150,230.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M141.12,232.34a2.48,2.48,0,1,1-2.2,2.74A2.47,2.47,0,0,1,141.12,232.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M133.15,233.59a2.12,2.12,0,1,1-1.88,2.34A2.13,2.13,0,0,1,133.15,233.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.93,234.78a1.73,1.73,0,1,1-1.53,1.91A1.74,1.74,0,0,1,125.93,234.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.54,235.94a1.28,1.28,0,1,1-1.14,1.42A1.28,1.28,0,0,1,119.54,235.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.55,236.82a1,1,0,0,1,1.06.85,1,1,0,1,1-1.06-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.1,237.54a.73.73,0,1,1-.65.81A.73.73,0,0,1,110.1,237.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.08,238.19a.53.53,0,0,1,.58.47.52.52,0,0,1-.46.58.53.53,0,1,1-.12-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.43,238.77a.37.37,0,0,1,.4.32.36.36,0,0,1-.32.39.36.36,0,0,1-.08-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.07,239.27a.23.23,0,0,1,.26.2.24.24,0,0,1-.21.26.23.23,0,0,1-.26-.21A.23.23,0,0,1,99.07,239.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.9,239.7a.16.16,0,0,1,.17.13.15.15,0,0,1-.14.17.14.14,0,0,1-.16-.13A.15.15,0,0,1,95.9,239.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M158.82,218.93a3.57,3.57,0,1,1-3.16,3.94A3.55,3.55,0,0,1,158.82,218.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M148.86,220.55a3.05,3.05,0,1,1-2.7,3.37A3.06,3.06,0,0,1,148.86,220.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M140,222.11a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,140,222.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M132,223.36a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,132,223.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.79,224.55a1.73,1.73,0,1,1-1.52,1.91A1.73,1.73,0,0,1,124.79,224.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.41,225.7a1.29,1.29,0,1,1-1.14,1.42A1.3,1.3,0,0,1,118.41,225.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.42,226.59a1,1,0,1,1-.85,1.06A1,1,0,0,1,113.42,226.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109,227.3a.74.74,0,1,1-.65.82A.74.74,0,0,1,109,227.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105,228a.54.54,0,0,1,.58.47A.53.53,0,1,1,105,228Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.3,228.54a.36.36,0,0,1,.39.31.37.37,0,0,1-.31.4.36.36,0,0,1-.4-.32A.36.36,0,0,1,101.3,228.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.93,229a.24.24,0,0,1,.26.21.23.23,0,0,1-.21.26.23.23,0,0,1-.25-.21A.23.23,0,0,1,97.93,229Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.77,229.47a.16.16,0,0,1,.17.13.16.16,0,0,1-.14.17.16.16,0,0,1-.17-.13A.15.15,0,0,1,94.77,229.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M157.68,208.7a3.57,3.57,0,1,1-3.15,3.93A3.56,3.56,0,0,1,157.68,208.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M147.72,210.32a3.05,3.05,0,1,1-2.7,3.37A3,3,0,0,1,147.72,210.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.85,211.88a2.48,2.48,0,1,1-2.2,2.74A2.49,2.49,0,0,1,138.85,211.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130.88,213.13a2.12,2.12,0,1,1-1.87,2.33A2.11,2.11,0,0,1,130.88,213.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123.66,214.32a1.73,1.73,0,1,1-1.53,1.91A1.73,1.73,0,0,1,123.66,214.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.27,215.47a1.29,1.29,0,1,1-1.14,1.42A1.28,1.28,0,0,1,117.27,215.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.28,216.35a1,1,0,1,1-.84,1.06A1,1,0,0,1,112.28,216.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M107.83,217.07a.74.74,0,1,1-.65.81A.75.75,0,0,1,107.83,217.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.81,217.73a.52.52,0,0,1,.58.46.54.54,0,0,1-.46.59.53.53,0,0,1-.58-.47A.51.51,0,0,1,103.81,217.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.16,218.3a.37.37,0,0,1,.4.32.36.36,0,0,1-.71.08A.36.36,0,0,1,100.16,218.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.8,218.8a.24.24,0,0,1,0,.47.24.24,0,0,1,0-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.63,219.23a.15.15,0,0,1,.17.14.16.16,0,0,1-.13.17.15.15,0,0,1-.17-.14A.16.16,0,0,1,93.63,219.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M156.55,198.46a3.57,3.57,0,1,1-3.16,3.94A3.57,3.57,0,0,1,156.55,198.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M146.59,200.09a3,3,0,1,1-2.7,3.37A3.05,3.05,0,0,1,146.59,200.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M137.71,201.64a2.49,2.49,0,1,1-2.19,2.74A2.48,2.48,0,0,1,137.71,201.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.74,202.89a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,129.74,202.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.52,204.09A1.73,1.73,0,1,1,121,206,1.72,1.72,0,0,1,122.52,204.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.14,205.24a1.29,1.29,0,1,1-1.14,1.42A1.29,1.29,0,0,1,116.14,205.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.15,206.12a1,1,0,1,1-.85,1.06A1,1,0,0,1,111.15,206.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.7,206.84a.73.73,0,1,1-.65.81A.73.73,0,0,1,106.7,206.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.68,207.5a.51.51,0,0,1,.58.46.53.53,0,0,1-.47.58.52.52,0,0,1-.58-.46A.53.53,0,0,1,102.68,207.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99,208.07a.36.36,0,1,1-.32.4A.36.36,0,0,1,99,208.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.66,208.57a.23.23,0,1,1,0,.46.22.22,0,0,1-.25-.2A.22.22,0,0,1,95.66,208.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.5,209a.16.16,0,0,1,.17.14.15.15,0,0,1-.14.16.15.15,0,1,1,0-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.41,188.23a3.57,3.57,0,1,1-3.15,3.94A3.56,3.56,0,0,1,155.41,188.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145.45,189.85a3.05,3.05,0,1,1-2.7,3.37A3,3,0,0,1,145.45,189.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M136.58,191.41a2.48,2.48,0,1,1-2.2,2.74A2.49,2.49,0,0,1,136.58,191.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M128.61,192.66a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,128.61,192.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121.39,193.85a1.73,1.73,0,1,1-1.53,1.91A1.74,1.74,0,0,1,121.39,193.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115,195a1.28,1.28,0,1,1-1.14,1.42A1.28,1.28,0,0,1,115,195Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110,195.89a1,1,0,0,1,1.07.85,1,1,0,0,1-.85,1.06,1,1,0,0,1-1.06-.85A1,1,0,0,1,110,195.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.56,196.61a.73.73,0,0,1,.82.65.74.74,0,0,1-1.47.16A.73.73,0,0,1,105.56,196.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.54,197.26a.53.53,0,0,1,.58.47.52.52,0,0,1-.46.58.53.53,0,0,1-.58-.47A.52.52,0,0,1,101.54,197.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.89,197.84a.37.37,0,0,1,.4.31.36.36,0,0,1-.32.4.36.36,0,0,1-.08-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.53,198.33a.24.24,0,0,1,.26.21.24.24,0,0,1-.47.05A.24.24,0,0,1,94.53,198.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.36,198.77a.15.15,0,1,1-.13.17A.15.15,0,0,1,91.36,198.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154.28,178a3.57,3.57,0,1,1-3.16,3.94A3.57,3.57,0,0,1,154.28,178Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M144.32,179.62a3.05,3.05,0,1,1-2.7,3.37A3.05,3.05,0,0,1,144.32,179.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135.44,181.18a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,135.44,181.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M127.47,182.43a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,127.47,182.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.25,183.62a1.73,1.73,0,1,1-1.52,1.91A1.72,1.72,0,0,1,120.25,183.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.87,184.77a1.29,1.29,0,1,1-1.14,1.42A1.29,1.29,0,0,1,113.87,184.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.88,185.65a1,1,0,0,1,1.06.85,1,1,0,1,1-1.06-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.43,186.37a.74.74,0,1,1-.65.82A.74.74,0,0,1,104.43,186.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.41,187a.53.53,0,0,1,.58.47.54.54,0,0,1-.47.58.53.53,0,1,1-.11-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.76,187.61a.34.34,0,0,1,.39.31.35.35,0,0,1-.31.39.35.35,0,0,1-.4-.31A.35.35,0,0,1,96.76,187.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.39,188.1a.24.24,0,1,1-.2.26A.23.23,0,0,1,93.39,188.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90.23,188.53a.16.16,0,0,1,.17.14.16.16,0,1,1-.17-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M153.14,167.76A3.57,3.57,0,1,1,150,171.7,3.58,3.58,0,0,1,153.14,167.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M143.18,169.39a3,3,0,1,1-2.7,3.37A3,3,0,0,1,143.18,169.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M134.31,171a2.48,2.48,0,1,1-2.2,2.73A2.48,2.48,0,0,1,134.31,171Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126.34,172.19a2.12,2.12,0,1,1,.46,4.21,2.12,2.12,0,0,1-.46-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.12,173.39a1.73,1.73,0,1,1-1.53,1.91A1.73,1.73,0,0,1,119.12,173.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.73,174.54A1.29,1.29,0,1,1,111.6,176,1.28,1.28,0,0,1,112.73,174.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M107.74,175.42a1,1,0,1,1,.22,1.91,1,1,0,0,1-.22-1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.29,176.14a.73.73,0,1,1-.65.81A.74.74,0,0,1,103.29,176.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.27,176.8a.52.52,0,1,1-.46.58A.51.51,0,0,1,99.27,176.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.62,177.37a.36.36,0,0,1,.4.32.36.36,0,1,1-.4-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.26,177.87a.23.23,0,1,1,0,.46.23.23,0,0,1-.26-.2A.24.24,0,0,1,92.26,177.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M89.09,178.3a.15.15,0,0,1,.17.14.16.16,0,0,1-.13.17.16.16,0,0,1-.17-.14A.16.16,0,0,1,89.09,178.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M152,157.53a3.57,3.57,0,1,1-3.16,3.94A3.57,3.57,0,0,1,152,157.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M142.05,159.15a3.05,3.05,0,1,1-2.7,3.37A3.07,3.07,0,0,1,142.05,159.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M133.17,160.71a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,133.17,160.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.2,162a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,125.2,162Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118,163.15a1.73,1.73,0,1,1-1.52,1.91A1.73,1.73,0,0,1,118,163.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.6,164.31a1.28,1.28,0,1,1-1.14,1.42A1.29,1.29,0,0,1,111.6,164.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.61,165.19a1,1,0,1,1-.85,1.06A1,1,0,0,1,106.61,165.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.16,165.91a.73.73,0,1,1-.65.81A.73.73,0,0,1,102.16,165.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98.14,166.56a.53.53,0,1,1-.47.59A.54.54,0,0,1,98.14,166.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.49,167.14a.36.36,0,0,1,.39.31.36.36,0,1,1-.39-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.12,167.64a.22.22,0,0,1,.26.2.23.23,0,1,1-.46,0A.23.23,0,0,1,91.12,167.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M88,168.07a.16.16,0,0,1,.17.13.15.15,0,0,1-.14.17.16.16,0,0,1-.17-.13A.15.15,0,0,1,88,168.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.87,147.3a3.57,3.57,0,1,1-3.15,3.94A3.56,3.56,0,0,1,150.87,147.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M140.91,148.92a3.05,3.05,0,1,1-2.7,3.37A3,3,0,0,1,140.91,148.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M132,150.48a2.48,2.48,0,1,1-2.2,2.74A2.48,2.48,0,0,1,132,150.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.07,151.73a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,124.07,151.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.85,152.92a1.73,1.73,0,1,1-1.53,1.91A1.74,1.74,0,0,1,116.85,152.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.46,154.07a1.29,1.29,0,1,1-1.13,1.42A1.28,1.28,0,0,1,110.46,154.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.48,155a1,1,0,0,1,1.06.85,1,1,0,1,1-1.06-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101,155.67a.74.74,0,1,1-.65.82A.75.75,0,0,1,101,155.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97,156.33a.53.53,0,0,1,.58.47.51.51,0,0,1-.46.58.53.53,0,0,1-.58-.47A.51.51,0,0,1,97,156.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.35,156.91a.35.35,0,0,1,.4.31.37.37,0,0,1-.32.4.36.36,0,0,1-.39-.32A.35.35,0,0,1,93.35,156.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90,157.4a.24.24,0,1,1-.21.26A.24.24,0,0,1,90,157.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.82,157.84a.15.15,0,1,1-.13.16A.14.14,0,0,1,86.82,157.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M149.74,137.06a3.57,3.57,0,1,1-3.15,3.94A3.58,3.58,0,0,1,149.74,137.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M139.78,138.69a3,3,0,1,1-2.7,3.37A3.05,3.05,0,0,1,139.78,138.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130.9,140.25a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,130.9,140.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.93,141.5a2.12,2.12,0,1,1-1.87,2.33A2.11,2.11,0,0,1,122.93,141.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.71,142.69a1.73,1.73,0,1,1-1.52,1.91A1.72,1.72,0,0,1,115.71,142.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.33,143.84a1.29,1.29,0,1,1-1.14,1.42A1.29,1.29,0,0,1,109.33,143.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.34,144.72a1,1,0,1,1-.85,1.06A1,1,0,0,1,104.34,144.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.89,145.44a.74.74,0,0,1,.81.65.73.73,0,0,1-1.46.16A.73.73,0,0,1,99.89,145.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.87,146.1a.52.52,0,0,1,.58.46.53.53,0,0,1-.47.58.51.51,0,0,1-.58-.46A.53.53,0,0,1,95.87,146.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.22,146.67a.36.36,0,0,1,.08.71.36.36,0,1,1-.08-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M88.85,147.17a.24.24,0,0,1,.06.47.24.24,0,0,1-.26-.21A.23.23,0,0,1,88.85,147.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.69,147.6a.16.16,0,1,1-.14.17A.16.16,0,0,1,85.69,147.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M148.6,126.83a3.57,3.57,0,1,1-3.15,3.94A3.57,3.57,0,0,1,148.6,126.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.64,128.45a3.05,3.05,0,1,1-2.69,3.37A3.06,3.06,0,0,1,138.64,128.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.77,130a2.48,2.48,0,1,1-2.19,2.74A2.48,2.48,0,0,1,129.77,130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121.8,131.26a2.12,2.12,0,1,1-1.87,2.34A2.12,2.12,0,0,1,121.8,131.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.58,132.45a1.73,1.73,0,1,1-1.53,1.91A1.74,1.74,0,0,1,114.58,132.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.19,133.61a1.28,1.28,0,0,1,1.42,1.13,1.28,1.28,0,1,1-1.42-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.21,134.49a1,1,0,1,1-.85,1.06A1,1,0,0,1,103.21,134.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98.75,135.21a.73.73,0,1,1-.65.81A.73.73,0,0,1,98.75,135.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.73,135.87a.52.52,0,0,1,.12,1,.52.52,0,1,1-.12-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.08,136.44a.36.36,0,0,1,.4.32.36.36,0,1,1-.4-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M87.72,136.94a.23.23,0,0,1,.26.2.24.24,0,1,1-.26-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.55,137.37a.15.15,0,1,1-.13.17A.15.15,0,0,1,84.55,137.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M375.83,296.57l-6.6-2.1a7,7,0,0,1-4.88-7.8,7.34,7.34,0,0,1,.28-1.12q2.08-6.6,4.19-13.21a7,7,0,0,1,9-4.64L391,271.88a6.93,6.93,0,0,1,4.66,8.85q-2.08,6.7-4.25,13.4a6.93,6.93,0,0,1-8.91,4.54Zm15.81-9.74c.71-2.22,1.43-4.45,2.12-6.68a5,5,0,0,0-3.26-6.34q-6.72-2.16-13.45-4.27a5,5,0,0,0-6.32,3.31c-1.42,4.45-2.82,8.9-4.24,13.36a4.94,4.94,0,0,0-.12,2.72,4.88,4.88,0,0,0,3.38,3.63l13.44,4.26a5,5,0,0,0,6.33-3.31C390.24,291.29,390.94,289.06,391.64,286.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377.87,290.29a7.46,7.46,0,1,1,9.37-4.87A7.44,7.44,0,0,1,377.87,290.29ZM381.78,278a5.48,5.48,0,1,0,3.57,6.87A5.49,5.49,0,0,0,381.78,278Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M389.6,279.63a1.71,1.71,0,1,1,1.06-3.25,1.71,1.71,0,0,1-1.06,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M401.9,344.54c1.11-5.19,2.2-10.35,3.3-15.56l-3.23-.69c.38-1.78.74-3.49,1.12-5.28l3.24.68c.21-1,.39-1.9.6-2.82a18.85,18.85,0,0,1,.71-2.85,4.89,4.89,0,0,1,4.6-3.36c2.51-.14,4.84.76,7.3,1.15-.39,1.84-.77,3.6-1.15,5.43l-2.48-.52a10.38,10.38,0,0,0-1.24-.22c-.74-.08-1.12.14-1.29.85-.29,1.19-.52,2.39-.79,3.64l4.8,1-1.57,5.11-4.35-.92c-1.11,5.25-2.21,10.44-3.32,15.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M347.55,349.71a11.71,11.71,0,0,0,7.87-3.94,5.84,5.84,0,0,1-6-2.94,6.07,6.07,0,0,0,1.29-.15,5.37,5.37,0,0,0,1.22-.43,5.75,5.75,0,0,1-3.63-1.39,5.67,5.67,0,0,1-1.95-3.38,5.87,5.87,0,0,0,2.7.22,5.68,5.68,0,0,1-3-3,5.75,5.75,0,0,1-.17-4.22,16.49,16.49,0,0,0,12.81,3.71c-.09-.23-.17-.43-.23-.64a5.78,5.78,0,0,1,3.46-7.09,5.64,5.64,0,0,1,5.37.67.14.14,0,0,0,.16,0,11.46,11.46,0,0,0,3.2-2l.06-.05a5.75,5.75,0,0,1-.62,2,6.08,6.08,0,0,1-1.24,1.61,10,10,0,0,0,1.57-.62,11,11,0,0,0,1.47-.86c-.11.27-.22.5-.34.73a11.56,11.56,0,0,1-1.87,2.67.14.14,0,0,0,0,.15,13.9,13.9,0,0,1,.34,2.13,15.93,15.93,0,0,1-.06,3.52,16.93,16.93,0,0,1-2.23,6.63,15.38,15.38,0,0,1-6.8,6.19A16.92,16.92,0,0,1,356,350.7a16.3,16.3,0,0,1-8.38-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M337.59,296.87a2.86,2.86,0,0,1,1.5.4,2.93,2.93,0,0,1,1.21,1.54,6.2,6.2,0,0,1,.18,3.9,4.2,4.2,0,0,1-2.37,2.67,6.73,6.73,0,0,1-2.61.6l-8.31.33H327c-.23-5.53-.45-11.05-.67-16.59h.08c2.95-.12,5.91-.25,8.86-.34a4.58,4.58,0,0,1,2.88.83,3.87,3.87,0,0,1,1.59,2.62,4.2,4.2,0,0,1-.15,2.33,2.73,2.73,0,0,1-1.84,1.63A.22.22,0,0,0,337.59,296.87Zm-6.91,6.35.67,0,3.88-.15a1.79,1.79,0,0,0,1.9-1.61,3.44,3.44,0,0,0,0-1.24,1.81,1.81,0,0,0-2-1.59l-4.3.17a.51.51,0,0,0-.24,0C330.56,300.26,330.62,301.72,330.68,303.22Zm-.42-10.71c.05,1.25.1,2.48.15,3.7,1.59-.07,3.16-.12,4.73-.2a1.06,1.06,0,0,0,1-.78,3.36,3.36,0,0,0,.05-1.86,1.26,1.26,0,0,0-1.42-1c-.47,0-.94,0-1.41.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M350.53,301.32l2.91-.12a4,4,0,0,1-.85,2.79,4.85,4.85,0,0,1-2.68,1.57,9,9,0,0,1-4.28.07,5.24,5.24,0,0,1-4-3.69,7.4,7.4,0,0,1,.08-4.85,5.47,5.47,0,0,1,3.06-3.42,7.5,7.5,0,0,1,3.5-.55,5.51,5.51,0,0,1,2.6.77,4.91,4.91,0,0,1,2,2.4,8.45,8.45,0,0,1,.61,3.69.56.56,0,0,0,0,.1l-8.57.34a3,3,0,0,0,.36,1.48,2.56,2.56,0,0,0,2.27,1.3,4.23,4.23,0,0,0,1.62-.21A1.78,1.78,0,0,0,350.53,301.32ZM350.2,298a2.55,2.55,0,0,0-1.09-2.09,2.68,2.68,0,0,0-1.9-.32,2.85,2.85,0,0,0-2.41,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M343.82,292c0-.67-.06-1.34-.08-2l6.83-.28c0,.68.05,1.34.08,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M357.3,263.21l-4.54-13.92a.47.47,0,0,0-.26-.29,3.16,3.16,0,0,0-2.91.19l-3.36,1.93-1.86,1.08-.14-.35c-.19-.48-.36-.9-.51-1.32a7.54,7.54,0,0,0-1.71-2.89,7.75,7.75,0,0,0-1.78-1.35,3.82,3.82,0,0,0-4.77,1c-.34.44-.28.66-.16.83l2.11,3.07a2.62,2.62,0,0,1,.52,1.54c0,1.41.06,2.72.1,4.06l.06,1.82-.3.17-1,.57h0l-.34.19-.13.08h0l-.25.15-3.11,1.8-2,1.16a1.48,1.48,0,0,0-.67.88,1.46,1.46,0,0,0,.14,1.1l6.19,10.72a1.49,1.49,0,0,0,.88.71,1.54,1.54,0,0,0,.94-.09l.18-.09,5.53-3.19.11-.07.49-.29a.81.81,0,0,0,.39-.89l0-.23,8.17-4.71c1-.56,2-1.12,2.91-1.7a2.65,2.65,0,0,0,1.18-1.47Zm-15.44,9.22c-1.23.71-2.47,1.42-3.73,2.16l-.28.16-.16-.28c-1.44-2.42-2.85-4.86-4.25-7.3l-1.8-3.1.27-.17c1.19-.74,2.42-1.44,3.61-2.13l1.24-.7.39-.25.83,1.36,5.41,9.37Zm13.58-8.77-.12.1-2.38,1.33-6.12,3.55-.28.15-2.26,1.3-1.39-2.4c-1.22-2.14-2.43-4.23-3.65-6.32l-.75-1.31.95-.55a.34.34,0,0,0,.14-.31c-.08-2.05-.16-4.17-.18-6.26a4.62,4.62,0,0,0-.89-2.7c-.36-.49-.7-1-1-1.49l-.66-1,.18-.19a1.68,1.68,0,0,1,1.77-.33,5.46,5.46,0,0,1,3.45,3.42c.3.8.62,1.6.93,2.4l.34.87a.34.34,0,0,0,.22.2.41.41,0,0,0,.35-.08c2-1.18,4.08-2.35,6.1-3.53a2.71,2.71,0,0,1,.8-.32l.28-.05,3.33,10.34c0,.07,0,.1,0,.12l.07.12.87,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.43,313.75l5-15.27a.51.51,0,0,0-.05-.42,3.42,3.42,0,0,0-2.7-1.72l-4.23-.45-2.34-.25.1-.4c.14-.55.26-1,.4-1.49a8.36,8.36,0,0,0,.35-3.68,8.26,8.26,0,0,0-.71-2.34,4.19,4.19,0,0,0-4.9-2.16c-.59.18-.67.41-.68.63l-.1,4.09A3,3,0,0,1,136,292c-.89,1.27-1.7,2.45-2.53,3.67l-1.13,1.65-.37-.05c-.36,0-.86-.11-1.29-.15h0l-.43-.05-.17,0h0l-.31,0-3.92-.41-2.55-.27a1.58,1.58,0,0,0-1.16.35,1.53,1.53,0,0,0-.58,1.06l-1.43,13.51a1.62,1.62,0,0,0,.32,1.19,1.68,1.68,0,0,0,.89.53l.22,0,7,.74h.15l.61.06a.92.92,0,0,0,.93-.53l.1-.23,10.29,1.09c1.23.13,2.45.27,3.68.37a2.88,2.88,0,0,0,2-.54ZM126.8,312l-4.7-.5-.36,0,0-.36c.29-3.07.61-6.14.94-9.21l.41-3.91.35,0c1.53.11,3.08.28,4.58.44l1.54.17.52,0-.15,1.74-1.25,11.79Zm17.7,1-.17,0c-1-.13-2-.24-3-.35l-7.71-.81-.35-.05-2.84-.3.32-3c.3-2.7.57-5.32.85-8l.17-1.65,1.2.13a.34.34,0,0,0,.32-.19c1.25-1.86,2.55-3.79,3.88-5.66a5,5,0,0,0,.95-3c0-.66,0-1.33,0-2l0-1.29.29,0a1.85,1.85,0,0,1,1.79.85,6,6,0,0,1,.85,5.26c-.26.9-.49,1.82-.73,2.73l-.26,1a.39.39,0,0,0,.06.31.42.42,0,0,0,.36.15l7.7.81a2.78,2.78,0,0,1,.91.24l.28.13-3.72,11.31a.24.24,0,0,0-.05.14v.15l-1,2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M359.28,232.22c-2.88.6-5.57,1.12-8.28,1.52a23.42,23.42,0,0,1-3.23.33,4.21,4.21,0,0,1-4.26-2.93,34.86,34.86,0,0,1-1.35-4.69,58.33,58.33,0,0,1-1.09-6,15.81,15.81,0,0,1-.17-2.75,4,4,0,0,1,2.68-3.65,27.47,27.47,0,0,1,4.2-1.26c2.12-.53,4.26-1,6.4-1.43,3-.63,6.07-1.2,9.13-1.65a24.57,24.57,0,0,1,2.85-.3,3.92,3.92,0,0,1,4.18,2.71,37.36,37.36,0,0,1,1.67,5.68,46.37,46.37,0,0,1,1,6.08,11.41,11.41,0,0,1,.06,1.94,4,4,0,0,1-2.66,3.59,27,27,0,0,1-4.14,1.24C363.88,231.26,361.49,231.78,359.28,232.22ZM355.05,227l6.63-6.22-8.54-3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M316.86,210c.27-.29.5-.55.76-.81A7,7,0,0,1,323.8,207a7.4,7.4,0,0,1,6.26,6,7,7,0,0,1-1.86,6.15c-2.42,2.65-4.92,5.24-7.39,7.85L317.09,231c-.07.07-.13.15-.19.22a.61.61,0,0,1-.27-.22l-10.85-11.49a7.51,7.51,0,0,1-2.2-5.82,7.06,7.06,0,0,1,5.9-6.56,7.49,7.49,0,0,1,5.72,1.29,5.82,5.82,0,0,1,.86.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M104.32,255.5c.17-.39.32-.76.48-1.11a7.77,7.77,0,0,1,5.54-4.59,8.14,8.14,0,0,1,8.71,3.81,7.68,7.68,0,0,1,.41,7c-1.5,3.65-3.09,7.25-4.64,10.88L112.47,277c0,.1-.07.21-.11.3a.62.62,0,0,1-.36-.12l-15.51-7.73A8.25,8.25,0,0,1,92,264.27a7.74,7.74,0,0,1,3.61-9,8.13,8.13,0,0,1,6.38-.84,7.12,7.12,0,0,1,1.18.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M133.24,336.05l-15.87,9.39a5.79,5.79,0,0,0-2,7.93l4.4,7.43a5.8,5.8,0,0,0,7.93,2l8.68-5.14,6,.94a1.85,1.85,0,0,0,1.88-2.77L143,353.76l.52-.31a5.8,5.8,0,0,0,2-7.93l-4.4-7.43A5.79,5.79,0,0,0,133.24,336.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.57,350.7a1.48,1.48,0,1,1-1.06,1.8A1.48,1.48,0,0,1,125.57,350.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.08,348a1.48,1.48,0,0,1,1.8,1.07,1.48,1.48,0,0,1-2.86.73A1.48,1.48,0,0,1,130.08,348Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.59,345.33a1.48,1.48,0,1,1,.74,2.86,1.48,1.48,0,1,1-.74-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M138.56,167.49l5.18-1.22,119.73-7.56s8-1.17,12.16,6l1.72,4.83L351.24,403.7s1.37,2.29.62,6.6-3.84,8.68-10.66,10L210.58,432.52s-18.89-.6-23.34-17.15L126,189.07s-2.18-8.33,2.71-14.31C128.74,174.76,132.55,168.77,138.56,167.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M350.72,402,277.35,169.52l-1.72-4.83c-4.14-7.15-12.16-6-12.16-6l-108.76,6.87,111.81-2.72s5-1,8.67,9.94S350.72,402,350.72,402Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M334,349.13h0s14.77,51.51,11.95,57c-2.7,5.26-95.69,13.76-95.69,13.76s81.88-5.86,101.27-8.2a11.37,11.37,0,0,0,.33-1.4c.75-4.31-.62-6.6-.62-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M154.71,165.58l-11,.69-5.18,1.22c-6,1.28-9.82,7.27-9.82,7.27a12.38,12.38,0,0,0-1.09,1.58c-.18,3.56,18.76,56.34,18.76,56.34s-11.53-50.25-9-58.21S154.67,165.58,154.71,165.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M152,176.21l105.22-6.8s8.51-1.16,12.54,6l1.94,4.64,67.21,211.83s1.84,7.36-5.31,10.47l-4.22.66-109,10.12a15.66,15.66,0,0,1-15.1-10.77L184,328.9,164,260.37l-21-72.37s-1.79-5,1.68-8.89S152,176.21,152,176.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M140.29,166.91s-6.85,2.39-8.09,9.43l-.16,5.2,1.37,5.11,62.73,222.2s.7,8.64,11.13,13c0,0,1.51,1.62,9.27,1.75l131.83-11.64s2.93-.24,3.49-1.63a10.79,10.79,0,0,1-8.77,9.55l-3.45.32-129.39,12a27.44,27.44,0,0,1-22.72-15.73l-26.77-99.11-14.44-52.95-20.65-77.55s-2.11-7.9,5.83-15.52C131.5,171.35,135.79,167.61,140.29,166.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M204.76,421.64l-.41-1.3c-7.62-4.55-8.21-11.49-8.21-11.49L156.22,267.44l-.33-1.06s36,140.6,39.4,147.87S204.76,421.64,204.76,421.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M271.73,180l-1.94-4.64c-4-7.14-12.54-6-12.54-6L152,176.21s-3.83-1-7.29,2.9-1.68,8.89-1.68,8.89l.32,1.11,128.39-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M343.09,419.85a10.79,10.79,0,0,0,8.77-9.55c-.56,1.39-3.49,1.63-3.49,1.63L216.54,423.57c-7.76-.13-9.27-1.75-9.27-1.75a22,22,0,0,1-3.66-1.93c1.53,2.14,3,4.74,3,6.85a8.12,8.12,0,0,1-1.76,4.48,23.78,23.78,0,0,0,5.44,1l129.39-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M352.27,404.3l-75.3-238a12.09,12.09,0,0,0-11.33-8.46h-.15c-.28,0-.57,0-.86,0l-37.57,2.42-82.66,5.24a13.2,13.2,0,0,0-1.66.2A19.37,19.37,0,0,0,125.53,190l60.59,224a25.67,25.67,0,0,0,27.18,18.86l128-12a12.79,12.79,0,0,0,11-16.59ZM275.55,166.69l75.3,238.06a12.46,12.46,0,0,1,.45,2.15h0a5.79,5.79,0,0,1-.48,2.45,3.15,3.15,0,0,1-2.61,1.78L216.88,422.88A18.77,18.77,0,0,1,197,409.43L133.16,182.35A11.91,11.91,0,0,1,135,172.17a12.47,12.47,0,0,1,7.88-5l.26,0,104.11-6.7,17.8-1.13a11.27,11.27,0,0,1,2.4.16A10.62,10.62,0,0,1,275.55,166.69Zm65.58,252.72-128,12a24.13,24.13,0,0,1-25.6-17.77L127,189.65a17.87,17.87,0,0,1,8.44-20.23,13.14,13.14,0,0,0-1.66,1.9,13.41,13.41,0,0,0-2,11.43l63.83,227.07a20.08,20.08,0,0,0,15.72,14.25,20.93,20.93,0,0,0,5.72.28l131.31-11.76a4.75,4.75,0,0,0,2.51-1,11.83,11.83,0,0,1-1.33,2.81A11.26,11.26,0,0,1,341.13,419.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M216.91,413.6a16,16,0,0,1-12.45-11.17L142.09,187.36a9.14,9.14,0,0,1,1.31-7.85,9.53,9.53,0,0,1,7.24-4l107.87-7a12.77,12.77,0,0,1,13.08,8.78l67.89,213.94a9.26,9.26,0,0,1-1.12,8,9.63,9.63,0,0,1-7.19,4.27L221.51,413.81A16.38,16.38,0,0,1,216.91,413.6Zm44.61-243.38a11.72,11.72,0,0,0-2.91-.18l-107.87,7a8,8,0,0,0-6.09,3.38,7.65,7.65,0,0,0-1.09,6.54L205.93,402a14.58,14.58,0,0,0,15.43,10.29L331,402a8.16,8.16,0,0,0,6.07-3.6,7.72,7.72,0,0,0,.93-6.65L270.13,177.77A11.15,11.15,0,0,0,261.52,170.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M169.14,232.92l35.51,120.9a4.19,4.19,0,0,0,4.52,3L308,348.25a4.2,4.2,0,0,0,3.54-5.42L274.81,224.3a4.2,4.2,0,0,0-4.23-3L173,227.53A4.22,4.22,0,0,0,169.14,232.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M183.34,213.52c-.38,4.84-5,8.43-10.25,8s-9.26-4.66-8.88-9.49,5-8.42,10.24-8S183.71,208.69,183.34,213.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M189,208.9l1.7,5.62a2.65,2.65,0,0,0,2.69,1.88l60.87-3.23a2.65,2.65,0,0,0,2.37-3.5l-2-5.82A2.65,2.65,0,0,0,252,202l-60.6,3.43A2.67,2.67,0,0,0,189,208.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "208.62 363.04 274.99 357.23 276.22 361.44 209.7 367.11 208.62 363.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "211.15 371.33 260.66 366.73 261.89 370.93 212.23 375.39 211.15 371.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M311,360.92a3.66,3.66,0,0,0,1.08-2.2,4,4,0,0,0-3.61-4.26,4,4,0,0,0-4.14,2.24,4.19,4.19,0,0,0-2.79-1.51,3.94,3.94,0,0,0-4.45,3.36,3.84,3.84,0,0,0,2.17,3.84l5.71,3.64a1.8,1.8,0,0,0,2.41-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M269.15,421.57l19.22-1.75a1.44,1.44,0,0,1,1.55,1.7l0,.07a1.43,1.43,0,0,1-1.29,1.17l-19.2,1.67a1.43,1.43,0,0,1-1.54-1.7h0A1.43,1.43,0,0,1,269.15,421.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M217.62,427.59c.08,1.18,1.59,2,3.36,1.9s3.14-1.18,3.06-2.35-1.59-2-3.36-1.9S217.53,426.42,217.62,427.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M144.63,235.45l7.94,28h0a3.65,3.65,0,0,1-4.5-2.55l-5.71-21.2a3.63,3.63,0,0,1,2.09-4.3h0A.14.14,0,0,1,144.63,235.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M143.9,232l-7.57-26.6a.11.11,0,0,0-.17-.08,3.63,3.63,0,0,0-2.1,4.29l5.72,21.2a3.55,3.55,0,0,0,.92,1.6,1.83,1.83,0,0,0,2.28.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M143.9,232l-7.57-26.6a.11.11,0,0,0-.17-.08l-.17.08a4,4,0,0,0-.82,3.23c.43,2,6.14,22.14,6.14,22.14A2.19,2.19,0,0,0,143.9,232Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M152.24,261.81l-7.57-26.6a.12.12,0,0,0-.17-.09,3.63,3.63,0,0,0-2.1,4.29l5.72,21.2a3.55,3.55,0,0,0,.92,1.6,1.8,1.8,0,0,0,2.28.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M152.24,261.81l-7.57-26.6a.12.12,0,0,0-.17-.09l-.17.09a4,4,0,0,0-.82,3.23c.43,2.05,6.14,22.14,6.14,22.14A2.19,2.19,0,0,0,152.24,261.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M174.45,204a10,10,0,0,0-4.43.63,11.49,11.49,0,0,1,9.69,3.61c3,3.13,1.83,8.6-.51,11.81a8.52,8.52,0,0,0,4.14-6.56C183.71,208.69,179.74,204.44,174.45,204Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M193.76,213.57c-1.94-1.24-3.2-4.25-4.55-6.67a2.64,2.64,0,0,0-.21,2l1.7,5.62a2.67,2.67,0,0,0,2.69,1.89l60.87-3.24a2.62,2.62,0,0,0,2.38-1.88C235.62,212.17,195.72,214.81,193.76,213.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M153.91,171.68a3.22,3.22,0,1,1-2.61-3.46A3.06,3.06,0,0,1,153.91,171.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M217.8,169.23l-28.49,1.4a1.8,1.8,0,0,1-1.89-1.71h0a1.8,1.8,0,0,1,1.71-1.89l28.5-1.4a1.79,1.79,0,0,1,1.88,1.71h0A1.8,1.8,0,0,1,217.8,169.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M257.56,301.28c-4.2-9.26-6.73-11.71-7.21-15.61-.21-1.71-2.92-9.18-4.08-10.4a41.3,41.3,0,0,1-4.34-5.19,7.3,7.3,0,0,0-7-3.17c-5,.37-5.24,5.19-8.3,17-2.61,10.08,4.12,20.37,9.94,24.42,5,3.52,8.27,3.07,15,7.83S261.76,310.55,257.56,301.28Zm-21.14,1.92a18.41,18.41,0,0,1-5.92-14.44.73.73,0,0,1,1.42-.17,57.52,57.52,0,0,0,5.6,13.69A.72.72,0,0,1,236.42,303.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M276.91,205.73s-12,6.81-13.17,6.79-4.15-2-4.15-2-3.81,3.68-7.78,2.78-5.41-2.37-5.41-2.37-3,1.82-5.79.26-6.64-6.34-10.15-13.26-4.17-11.67-3.58-13.3a13.9,13.9,0,0,1,2.2-3.45s-1.08-4.65.4-7.07,5.38-5.18,5.38-5.18-.47-3.92,1.09-5.78l51.88-29.05s3.1-2.58,5.62-2.13,4.79,3.8,4.79,3.8l4.35-2.07s-2.65-4.92-.62-9,15-18.26,20.31-25.19L326.69,93l.28-1.49s-2.64-14.12,4.14-15.26c0,0,4.89-.33,15.32,11.49S368.86,123,368.86,123s9.92,20.51,13.33,33.83,5.25,23.89-.69,25.67c0,0-4.3,1.28-13.53-8.71l-1.33.39-10.76-.29L344.46,175l-7,1.12-8.56,2.35-2.17-.32-4-3.27-3.51,2.24s2.82,2.28,1.9,5.29-12.86,9.26-12.86,9.26L307,193.09l1.5,10.36,10.46,39s3.57,9.4,2.3,11.74-11.48,8.17-13.5,8.08S298,245.37,298,245.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M308.53,203.45,307,193.09l.09-.11.05-2.33,4-4.46-.83-.73-5.45-4.26-1.77.58-29.43,17,1.21,2.61c.3-.32,25.58-15,25.58-15s-1.63,1.91.25,10.83,15.54,54.22,15.69,55.88-10.1,7.57-10.1,7.57,0,.13,0,.33c.6.8,1.11,1.3,1.45,1.31,2,.09,12.23-5.73,13.5-8.08s-2.3-11.74-2.3-11.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M259.38,210.67l-.77-1.17a73.57,73.57,0,0,1-15.53-18,63.34,63.34,0,0,1-8.3-22.14s.78,12.5,2.34,17.22,12.14,17.1,12.14,17.1-1.73,2.69-3.14,1.88-14-14.58-14-14.58,5.61,11.9,4.31,12.64c-1,.59-4.38-3.52-5.81-5.36,3.46,6.74,7.21,11.39,10,12.92s5.78-.26,5.78-.26,1.45,1.47,5.41,2.37C255.23,214,258.54,211.4,259.38,210.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M302,124.68s-.77,1.06-.75,4,8.47,27.52,18.76,41.71c0,0,5.68,7.79,6.77,7.77a20.86,20.86,0,0,0,2.78-.32s12.27-3,18.49-3.17,14.53-.61,14.53-.61l5.11.1-12.44-16.79-8.56-14.73-6.53-12.74-5.27-12.8-4.3-12.23-1.93-7.59-1.81-4.69-11.93,16.31-6.57,7.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M346.66,142.6l-6.53-12.74-5.27-12.8-4.3-12.23-1.93-7.59-1.81-4.69L323.6,97c.23,8.54,1,24.69,6.74,36.57,9.72,20.3,16.93,28.09,16.93,28.09s-16.21,3.07-19.11,3.25c-2.43.15-18.46-19.09-23.68-25.43,3.39,9.16,9.09,22.06,15.5,30.91,0,0,5.68,7.79,6.77,7.77a20.86,20.86,0,0,0,2.78-.32s12.27-3,18.49-3.17,14.53-.61,14.53-.61l5.11.1-12.44-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M298.24,135.73s-2.89,1.25-3.24,2.34.86,13.45,8.47,25.57,12.83,14.63,12.83,14.63l2.93-1.18s2,1.81,2.07,3.81-1.31,3.5-2.17,4.62-11.26,6-11.26,6-1.41-1.28.66-2.69a8,8,0,0,0,2.67-2.68l-2.6-2.29-3.34-2.58-2.11.46-23.91,13.4-5.52,3.62,3.19,6.93s-10.67,7.61-13.58,6.82-12-9.1-16.6-15S236.43,176,236.43,176l-1.8-9.22a6.93,6.93,0,0,1,3.31-4.94c2.88-1.48,25.09-13.9,25.09-13.9l20.64-11.41s6.87-5.36,9.78-4.58S298.24,135.73,298.24,135.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M319.23,177.09l-2.93,1.18s-5.23-2.5-12.83-14.63A58.25,58.25,0,0,1,295,140.13c-5.63,4.1,8.27,30.48,8.11,33.44S268,193.3,262.72,193.49c-4.12.15-19.22-11.16-25.83-16.28,1.45,3.8,6,15.43,9.84,20.33,4.58,5.91,13.68,14.21,16.6,15s13.58-6.82,13.58-6.82l-3.19-6.93,5.52-3.62,23.91-13.4,2.11-.46,3.34,2.58,2.6,2.29a8,8,0,0,1-2.67,2.68c-2.07,1.41-.66,2.69-.66,2.69s10.39-4.91,11.26-6,2.22-2.61,2.17-4.62S319.23,177.09,319.23,177.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M333.39,82s4.1-.91,13.43,12.37S363,121,370,135.73s10.92,31.84,10.86,32.36.54,7.08-1.89,7-12.48-7.14-23.34-28S339,113.05,339,113.05,327,85.52,333.39,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M344.78,125.44s2.85-.83,4.54.43,6.78,10.95,7,12.82-2.81,4.27-2.81,4.27l-5.42-10.11S344.41,125.84,344.78,125.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M250.82,309.53l18.34-24.09s1.48-2.1,2.91-2.45a8.77,8.77,0,0,0,4.33-3.12c.87-1.33,1.16-2.84,2.42-4.23S293.58,261,293.58,261l7.56-8.64s5.7-6.54,6.95-8,11.92-4.62,12.55-6.94a11.42,11.42,0,0,0-.6-6.77A22.62,22.62,0,0,0,318.4,228l-1.81-.34-3.79,1.87-4.29,1.23,2.43-2.6,3.61-2.26,1.08,2.85s3.65-2.14,3.69-5.32a23,23,0,0,0-1.42-7l-1.07-2a18.68,18.68,0,0,0,.06-4.3,5.57,5.57,0,0,0-3.45-3.89c-1.13-.28-4,.55-4,.55l-18.38,7-1.09-.15,9.23-7.87s6.59-4.5,7.68-4.67a3.85,3.85,0,0,1,1.45-.06l.23,2.31s3.32-2.36,3.79-4.08-1.25-5.61-2.8-6.34a21.48,21.48,0,0,0-3.09-1.15s-2.61-.19-7.47,1.84-16.5,11-16.5,11-5.6,3.87-8.39,8.09-6.64,11.35-6.64,11.35l-6.53,14.76-6.14,15-2.38,6-11.95,8.73s-6.71,4.54-7.26,7.68,2.36,13.31,2.36,13.31l6.24,13.23s3.49,5.21,5.6,6.42S250.82,309.53,250.82,309.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M236.94,271.55s17.35-8.36,18.7-10,19.17-45.38,23.43-50.14,22.31-17.36,25.78-17.63a32.79,32.79,0,0,1,6,.06,11.32,11.32,0,0,0-9.23-1c-5.31,1.64-24.37,15.27-27.52,20.05s-18.69,39.59-18.69,39.59l-3,7.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M285.56,217.09s9.49-1.1,11-1.61,15.41-6.73,17-6.51a11.46,11.46,0,0,1,3.34,1.24s-1.76-4-3.75-3.94-6.54,1.89-6.54,1.89l-16.89,6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M318.11,218.08s-5.46,1.17-6.26,1.44-14,4.92-14,4.92l2.89-3.09s10.42-6.23,13.42-6.29S318,214.92,318.11,218.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M316.77,215.07a8.72,8.72,0,0,0-2.64,0c-1.42.23-3,.66-3,.66l-10.4,5.63-1.89,2.52-3.1,1.78-1.71,2-.37,1.43s-.82-4.56.54-6.26a24.85,24.85,0,0,1,3.86-3.52s8.92-6.26,16.7-8.27C320.24,209.64,316.77,215.07,316.77,215.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M285.13,217.27s2.14-7.68,2.94-8.61,15.06-11.32,17.54-11.55,6.16.46,6.33.87a8,8,0,0,1,.15,1.83l-1.26,2.08-2.3,1.56-.65-2.18-2.38.56-4,2-6.47,4.83-4.14,3.78-1.78,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M320,230.56c-.11-.22-.24-.44-.37-.65l.88,4.27s-.63-1.48-1.7-1.69-17.09,3.1-17.09,3.1l3.47-2.89s3.25-1.48,6.34-2.78l-3.06.88,2.43-2.6,3.61-2.26.88,2.33-1,.48a15.84,15.84,0,0,1,2.25-.74,2.65,2.65,0,0,1,2.49,1.16c-.44-.64-.8-1.13-.8-1.13l-1.42-.26a6.16,6.16,0,0,0,2.34-4.31,15.39,15.39,0,0,0-.36-3.24c-5.2.16-13.49,5.68-18,9a9.39,9.39,0,0,0-3.74,6.17,49.47,49.47,0,0,1-1.58,7.3c-1,3.14-12.54,19.49-16.71,25.37a8.57,8.57,0,0,1-3.82,3,18.6,18.6,0,0,0-4.32,2.17,13.69,13.69,0,0,0-1.95,3.87,16.93,16.93,0,0,1-4.42,6.46c-5.39,4.9-15.95,14.08-18.12,12.83-2.36-1.36-9.34-16.15-12.09-22.11a5.27,5.27,0,0,0-1,2c-.55,3.14,2.36,13.31,2.36,13.31l6.24,13.23s3.49,5.21,5.6,6.42,3.45.24,3.45.24l18.34-24.09s1.48-2.1,2.91-2.45a8.77,8.77,0,0,0,4.33-3.12c.87-1.33,1.16-2.84,2.42-4.23S293.58,261,293.58,261l7.56-8.64s5.7-6.54,6.95-8,11.92-4.62,12.55-6.94A11.42,11.42,0,0,0,320,230.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M334.23,76.25s-.07.13-.06.14a2.14,2.14,0,0,0,.38.23,23.92,23.92,0,0,1,5.09,3.4,64.21,64.21,0,0,1,7.65,7.82,134.79,134.79,0,0,1,9.42,12.75,217.17,217.17,0,0,1,14.44,25.69,200.18,200.18,0,0,1,9.66,23.56,114,114,0,0,1,4.07,15.31,48.48,48.48,0,0,1,.92,8.75,12.7,12.7,0,0,1-.33,3.36c0,.14-.08.28,0,.41l-.5,1.9c-.24.09-.23.33-.3.51a4.21,4.21,0,0,1-5,2.89,11.32,11.32,0,0,1-3.8-1.48,29.5,29.5,0,0,1-5-3.81c-.81-.74-1.6-1.51-2.37-2.28a1.14,1.14,0,0,0-.93-.41,24,24,0,0,1-2.93-.16,79.9,79.9,0,0,0-12.08.3c-6.15.56-12.24,1.52-18.3,2.69-1.54.29-3.1.54-4.65.8a10.75,10.75,0,0,1-2.12.15,2.54,2.54,0,0,1-1.26-.38,14.87,14.87,0,0,1-2.87-2.24l-.45-.46-2.67,1.46c0,.27.25.35.39.47a5,5,0,0,1-.48,7.77c-.63.43-1.27.87-1.94,1.26-1.87,1.1-3.74,2.19-5.63,3.26-1,.55-2,1.05-3,1.58a2.11,2.11,0,0,0-.67.39c0,.24.16.22.28.29a1.91,1.91,0,0,0,.32.16,4.22,4.22,0,0,1,2.41,2.58,15.63,15.63,0,0,1,.95,3.61,3.78,3.78,0,0,1-1.67,3.86,8.52,8.52,0,0,1-1.45.86,1.46,1.46,0,0,0-.65.38c.14.79.29,1.6.43,2.38.25.15.44,0,.63,0a17.31,17.31,0,0,1,2-.37,4.47,4.47,0,0,1,4.47,2.16,4.86,4.86,0,0,1,.57,1.11,9.26,9.26,0,0,1,.33,5.51,1.06,1.06,0,0,0,0,.23,7.9,7.9,0,0,1,1.61,3.48,19.25,19.25,0,0,1,.82,5.17,4.12,4.12,0,0,1-.47,2,7.91,7.91,0,0,1-1.49,2.2c.34.21.69.36,1,.59a3.8,3.8,0,0,1,1,1.21,10.87,10.87,0,0,1,1.52,7.08,9.59,9.59,0,0,1-.2,1,2.73,2.73,0,0,1-1.53,1.86,3.4,3.4,0,0,0-.95.55c.19.64.37,1.3.58,1.95.94,3,1.75,6,2.54,9.09.14.55.24,1.1.34,1.66a3,3,0,0,1-.75,2.64,7.84,7.84,0,0,1-.8.83c-.63.55-1.25,1.1-1.93,1.59a47.5,47.5,0,0,1-9.24,5.15,4.08,4.08,0,0,1-1.46.37,1.92,1.92,0,0,1-1.52-.56,13.15,13.15,0,0,1-2.25-2.85c-1.05-1.73-2-3.51-3-5.29-.12-.23-.25-.45-.41-.73-.4.25-.56.65-.86.92a8.17,8.17,0,0,0-.85.91,120.6,120.6,0,0,1-12.85,13.79l-4.9,4.54c-.8.75-1.58,1.53-2.38,2.29a6.07,6.07,0,0,0-1.52,2.37,17.8,17.8,0,0,1-.95,2.31,5.13,5.13,0,0,1-1.82,1.91,21.12,21.12,0,0,1-3.92,1.89,1.82,1.82,0,0,0-.86.6c-.62.79-1.27,1.57-1.86,2.38-2.9,3.95-5.77,7.91-8.67,11.85-2.26,3.06-4.56,6.08-6.84,9.12a11.64,11.64,0,0,1-1.22,1.41,2.17,2.17,0,0,1-1.75.71,1.64,1.64,0,0,0-.95.1l-1.55-.41a.15.15,0,0,0-.08-.21,12.57,12.57,0,0,1-4-3.65,36.2,36.2,0,0,1-4.09-6.88c-2.74-6-5.57-12.42-6.42-18.94-.12-.91-.19-1.83-.25-2.75a3.81,3.81,0,0,1,.25-1.83.61.61,0,0,0,.07-.17,4.93,4.93,0,0,1,1.64-2.68c2.94-3.12,7.19-5.7,10.49-8.42,2.09-1.72,4.24-3.35,6.4-5a3.33,3.33,0,0,0,1.11-1.55c.88-2.43,1.81-4.84,2.74-7.25.65-1.66,1.3-3.32,2-5q1.11-2.77,2.26-5.53,1.29-3,2.63-6c1.42-3.23,2.91-6.44,4.48-9.6.94-1.92,1.84-3.86,2.91-5.71s2.18-3.95,3.5-5.79a27.49,27.49,0,0,1,4.26-5,2.26,2.26,0,0,0,.19-.25,8.42,8.42,0,0,0-.7-1.19c-.24,0-.39.13-.56.23-1.59,1-3.23,1.88-4.88,2.76-1.21.65-2.39,1.33-3.6,2-.91.48-1.83,1-2.79,1.39a3,3,0,0,1-2.72-.34c-.6-.34-1.15-.74-1.73-1.1-.15-.09-.31-.17-.49-.26L256.4,213c-.49.21-1,.4-1.49.58a6.68,6.68,0,0,1-4.95-.18,18.35,18.35,0,0,1-3.23-1.74,12.39,12.39,0,0,1-2.14.53,6.62,6.62,0,0,1-6-1.81,30,30,0,0,1-3-3.28,56.13,56.13,0,0,1-6.52-10.3,26.69,26.69,0,0,1-1.85-4.81c-.38-1.38-.8-2.74-1.08-4.14a8.7,8.7,0,0,1-.13-2.74,5.63,5.63,0,0,1,1.15-2.86c.37-.49.78-1,1.18-1.45a1.9,1.9,0,0,0-.11-.78,16.45,16.45,0,0,1-.37-3.35,5.13,5.13,0,0,1,.9-2.94,14.85,14.85,0,0,1,1.79-2.09,37.52,37.52,0,0,1,3.46-3.16c0-.47,0-1,0-1.47,0-.24,0-.48,0-.71a5.57,5.57,0,0,1,1.59-3.5,7.45,7.45,0,0,1,1.93-1.54q12.11-6.73,24.2-13.51L289.79,132a9.82,9.82,0,0,1,2.26-1,1.91,1.91,0,0,1,.79,0,6.6,6.6,0,0,1,3.12,1.42,12.35,12.35,0,0,1,1.5,1.39,2.58,2.58,0,0,1,.81,1.29l3.33-1.54a1,1,0,0,0-.07-.63,48.93,48.93,0,0,1-.89-5.26,5.15,5.15,0,0,1,.59-3,15.7,15.7,0,0,1,1.27-2c1.39-1.93,2.89-3.77,4.43-5.57,2.72-3.19,5.47-6.34,8.12-9.57a150.22,150.22,0,0,0,10.44-14.3c.34-.52.7-1,1.06-1.54-.13-1.11-.27-2.23-.38-3.35a28.53,28.53,0,0,1,0-6.4,10.63,10.63,0,0,1,1.06-3.66,4.23,4.23,0,0,1,3.93-2.47c.15,0,.43.16.46-.18ZM301.76,235.59a.61.61,0,0,1,.16-.42,6,6,0,0,1,1-1.11c1.21-1.09,2.42-2.18,3.67-3.24a32.56,32.56,0,0,1,3.22-2.53,62.61,62.61,0,0,1,6.51-3.86c.14-.07.27-.22.47-.13a21.63,21.63,0,0,1-1.79,1.64c.22.57.45,1.15.69,1.72,0,0,.08.06.16.12.26-.34.51-.7.79-1s.62-.65.94-1a3,3,0,0,0,.86-2.08,5.77,5.77,0,0,0,0-.72,23.57,23.57,0,0,0-1.24-6,4.75,4.75,0,0,0-.47-1,1.3,1.3,0,0,0-1-.62,3.45,3.45,0,0,0-1.32.15,17,17,0,0,0-3.5,1.31c-1.34.65-2.64,1.36-3.93,2.1a5,5,0,0,1-.87.43c-1.68.59-3.35,1.22-5,1.92-.11,0-.25.19-.41,0,.21-.17.41-.35.62-.5a73.24,73.24,0,0,1,9.54-5.56,15.07,15.07,0,0,1,2.83-1.06,6.37,6.37,0,0,1,1.93-.3.46.46,0,0,0,.43-.11.08.08,0,0,0,.05,0,1.83,1.83,0,0,0,.08-.25,9,9,0,0,0-.34-4,4.42,4.42,0,0,0-.57-1.1,2.83,2.83,0,0,0-2.66-1.32,7.5,7.5,0,0,0-1.41.21c-.92.21-1.84.44-2.75.7a91.17,91.17,0,0,0-11.59,4.34,53.53,53.53,0,0,1-5.26,2.19,28.09,28.09,0,0,0-3.45,1.42,12,12,0,0,0-1.16.66,12.2,12.2,0,0,0-2.69,2.58c-.1.12-.16.33-.41.26a10.11,10.11,0,0,1,1.05-2.65,4.55,4.55,0,0,1,1.76-1.72,6,6,0,0,1,.88-.43,2,2,0,0,0,.8-.54,59.26,59.26,0,0,1,5.87-5.2,100.88,100.88,0,0,1,9.31-6.72,12.63,12.63,0,0,1,5.06-1.85,2.37,2.37,0,0,1,2.05.41,2.18,2.18,0,0,0,.7-2.05,16.62,16.62,0,0,0-.65-2.77,3.6,3.6,0,0,0-2.42-2.5,9.69,9.69,0,0,0-7.94.4c-.55.28-1.09.59-1.63.9-3.92,2.25-7.64,4.81-11.32,7.44-3.22,2.29-6.37,4.68-9.36,7.27a18,18,0,0,0-2.44,2.57c-.72.92-1.32,1.91-1.94,2.88a122.86,122.86,0,0,0-7,13.11c-1.11,2.31-2.18,4.62-3.2,7s-2.08,4.74-3.09,7.11q-1.66,3.84-3.27,7.71-1,2.38-1.91,4.8c-.66,1.72-1.26,3.46-2.09,5.11a2.05,2.05,0,0,1-.55.69c-.66.5-1.3,1-2,1.53-3.82,2.89-8.5,5.75-12.05,9-1,.94-2,1.9-3,2.88A4.88,4.88,0,0,0,234,278c.07.59.1,1.18.17,1.77a68.27,68.27,0,0,0,2.62,10.87c1.17,4,3.17,7.47,5.16,11.14a27,27,0,0,0,3.41,5,10.08,10.08,0,0,0,2.38,2,2.82,2.82,0,0,0,.82.35,2,2,0,0,0,2.23-.66c.33-.46.71-.88,1-1.33,3.66-4.82,7.25-9.69,10.83-14.57,2.1-2.88,4.25-5.71,6.59-8.41a4.91,4.91,0,0,1,1.9-1.42c.93-.39,1.83-.83,2.73-1.3a3.9,3.9,0,0,0,1.66-1.68,7.15,7.15,0,0,0,.43-1.08,9.4,9.4,0,0,1,2.35-4c.26-.25.49-.52.75-.76,1.58-1.49,3.15-3,4.75-4.45a146.37,146.37,0,0,0,11.07-11.21c2-2.25,3.89-4.56,5.82-6.85,1.44-1.7,2.88-3.39,4.29-5.12a12.41,12.41,0,0,1,4.35-3.46c1.72-.82,3.4-1.7,5.12-2.52a32.48,32.48,0,0,1,3.41-1.52,4.64,4.64,0,0,0,1.43-.89,2.27,2.27,0,0,0,.86-1.69,11.17,11.17,0,0,0-1.07-5.8,5.15,5.15,0,0,0-.6-1,1.26,1.26,0,0,0-1.34-.5c-.46.11-.93.22-1.38.37a77.23,77.23,0,0,0-8.14,3.14c-.43.2-.86.41-1.3.57a4.75,4.75,0,0,0-1.17.64q-1.12.79-2.28,1.56A2.22,2.22,0,0,1,301.76,235.59Zm-4.51-100.08c-.59-.54-1.18-1.08-1.78-1.61a7.68,7.68,0,0,0-1.6-1.12,2.1,2.1,0,0,0-2.35.06c-.37.26-.77.45-1.16.67l-28.47,15.91-17.81,10-6.38,3.56a4.86,4.86,0,0,0-1.86,1.74,2.84,2.84,0,0,0-.41,1.35,14.72,14.72,0,0,0,.16,3.11c.19,1,.38,2,.61,3.05a66.59,66.59,0,0,0,3.22,9.81,82.24,82.24,0,0,0,5.65,11.5,48.92,48.92,0,0,0,10.2,12.27c2.22,1.88,4.51,3.67,6.9,5.32.24.17.49.34.74.49a2,2,0,0,0,1.54.21,5.82,5.82,0,0,0,1.48-.6l5.65-3.23,3.81-2.14c.17-.1.38-.16.49-.37a2,2,0,0,0-.32-.72c-.73-1.49-1.48-3-2.21-4.47a7,7,0,0,1-.37-1,.77.77,0,0,1,.34-.93c.37-.24.7-.54,1.08-.78,2.24-1.45,4.48-2.92,6.74-4.34,4.93-3.1,10.05-5.88,15.15-8.68q2.9-1.58,5.87-3c.54-.25,1.09-.48,1.64-.7a2.4,2.4,0,0,1,2.3.25l.3.18a39.15,39.15,0,0,1,4.53,3.58,4.1,4.1,0,0,1,.59.66,1.25,1.25,0,0,1,.09,1.43,3.92,3.92,0,0,1-.71.91l-1.59,1.43a6.11,6.11,0,0,0-1.15,1.23c-.06.1-.13.2,0,.3a.44.44,0,0,0,.33-.08c.57-.31,1.15-.61,1.72-.94l8.35-4.78a2,2,0,0,0,.57-.42c.24-.3.5-.59.74-.89a3.79,3.79,0,0,0,.61-3.7,26.08,26.08,0,0,0-1.05-2.42c-.83.48-1.71.78-2.52,1.19a1,1,0,0,1-.85.07,5.38,5.38,0,0,1-.64-.31,12.25,12.25,0,0,1-2.54-1.93A53.88,53.88,0,0,1,304,165.72a101,101,0,0,1-5.41-10.24,51.86,51.86,0,0,1-3-7.72,32.72,32.72,0,0,1-1.35-8.95,2.43,2.43,0,0,1,0-.27,2.08,2.08,0,0,1,1.21-2c.49-.22.94-.51,1.41-.78C297,135.69,297.18,135.65,297.25,135.51Zm69.16,37.83a.74.74,0,0,0-.29-.53,119.1,119.1,0,0,1-8.44-10.8,196.87,196.87,0,0,1-11.95-19.53,222,222,0,0,1-12.07-26.11A133.53,133.53,0,0,1,327,94.21c0-.12,0-.3-.2-.33-.63,1-1.23,2-1.88,3a122.82,122.82,0,0,1-9.07,12c-2.36,2.79-4.77,5.53-7.16,8.29a84.18,84.18,0,0,0-5.55,7.07,8.82,8.82,0,0,0-1,1.69,2,2,0,0,0-.16,1c.09.65.17,1.3.27,1.94a55.38,55.38,0,0,0,2.36,9c1.81,5.42,4.17,10.61,6.44,15.84.55,1.25,1.09,2.51,1.64,3.76,0,.08.08.15,0,.27a3.77,3.77,0,0,1-.91-1c-.79-1.29-1.57-2.59-2.37-3.88a38.89,38.89,0,0,1-2.31-4.32,102.24,102.24,0,0,1-4.89-13,2.25,2.25,0,0,0-.34-.88c-2.17.94-4.24,2.08-6.33,3.16,0,.69,0,1.31,0,1.93s.15,1.48.26,2.21a45,45,0,0,0,3,10.59,95.3,95.3,0,0,0,4.56,9.37,57.26,57.26,0,0,0,6.11,9.08,45.84,45.84,0,0,0,4.62,4.93,11.85,11.85,0,0,0,2.18,1.64A53.81,53.81,0,0,0,322,174.7a2,2,0,0,0-.51-.7,36.17,36.17,0,0,1-4-5.88,8.85,8.85,0,0,1-.8-2c0-.13-.15-.28.07-.38a9.7,9.7,0,0,1,1.56,1.7l2.33,3.15c1,1.33,2,2.63,3.15,3.87a14.32,14.32,0,0,0,1.88,1.77c1.61,1.19,1.22,1.14,3.24.89,1.56-.19,3.11-.48,4.64-.8,5.5-1.15,11-2,16.6-2.65a84.22,84.22,0,0,1,12-.64C363.53,173.09,365,173.19,366.41,173.34ZM384,178.19c0-.13.09-.42.14-.71a22.79,22.79,0,0,0,.25-5.15,57.65,57.65,0,0,0-1.36-9.42,126.41,126.41,0,0,0-4.95-16.73,222.33,222.33,0,0,0-20.61-41.9,139.45,139.45,0,0,0-10.4-14.56,69.49,69.49,0,0,0-7.63-8.09A25.3,25.3,0,0,0,334.41,78a7.56,7.56,0,0,0-3-1,2.87,2.87,0,0,0-2.76,1.44,7,7,0,0,0-.93,2.49,20,20,0,0,0-.34,3.45,44.11,44.11,0,0,0,.62,7.35c.25,1.64.59,3.27,1,4.89a132.65,132.65,0,0,0,5.49,17.87,223.87,223.87,0,0,0,19.15,38.77c6.47,9.48,7.06,10.78,11.16,15.77a68.91,68.91,0,0,0,7.71,8.13,24.09,24.09,0,0,0,5,3.53,7.29,7.29,0,0,0,3,.93,2.79,2.79,0,0,0,2.59-1.25A6.83,6.83,0,0,0,384,178.19Zm-149.75-7.62a.78.78,0,0,0-.48.28c-.79.76-1.59,1.52-2.36,2.3-.43.44-.83.93-1.22,1.41a3.22,3.22,0,0,0-.72,2.15,14.73,14.73,0,0,0,.27,2.56c.29,1.54.64,3.08,1.06,4.59a63.38,63.38,0,0,0,5.46,13.8,37.08,37.08,0,0,0,10,11.79,19.67,19.67,0,0,0,3.69,2.31,6,6,0,0,0,4.66.37c1.2-.43,2.37-.93,3.55-1.44a.91.91,0,0,0,.23-.2c-.48-.36-1-.7-1.4-1.07-1.47-1.2-2.88-2.47-4.25-3.79a53.58,53.58,0,0,1-8.88-11,82.24,82.24,0,0,1-5.45-10.81,63,63,0,0,1-4-12.88A2.62,2.62,0,0,0,234.29,170.57Zm75.94,15.65a44.53,44.53,0,0,0-4.42-3.6c-.95-.66-1.05-.69-2.12-.19-1.35.62-2.69,1.26-4,1.95-8.49,4.48-16.82,9.25-24.85,14.53l-.26.2a1.91,1.91,0,0,0,.31.76c.13.25.17.57.45.7.46-.33.87-.67,1.32-1,1.69-1.1,3.37-2.23,5.09-3.28,5-3,10.15-5.84,15.22-8.77a17.2,17.2,0,0,1,2.83-1.29c.38-.14.69-.09.71.09s-.2.41-.38.55a28.15,28.15,0,0,1-2.67,1.78l-5.4,3.12c-3.79,2.18-7.58,4.35-11.29,6.65l-4.93,3s0,.1-.07.16c.81,1.68,1.7,3.33,2.63,5,.07.12.11.28.33.28.64-.53,1.3-1.09,2-1.62,3.54-2.8,7.23-5.41,11-7.94,2.41-1.64,4.9-3.15,7.43-4.58a11.22,11.22,0,0,1,6.51-1.44,1.3,1.3,0,0,0,.64-.05,4.21,4.21,0,0,1,1.06-2.1c.3-.33.62-.63.95-.93.5-.46,1-.9,1.53-1.36A1,1,0,0,0,310.23,186.22Zm-8.12,66.05c0,.08.09.22.16.35,1.1,2.1,2.24,4.18,3.46,6.22.35.59.75,1.14,1.14,1.7a7.44,7.44,0,0,0,.58.68.87.87,0,0,0,.88.27,5.82,5.82,0,0,0,1.17-.42,47.3,47.3,0,0,0,8-4.36,17.5,17.5,0,0,0,2.56-2.06c1.07-1,1.2-1.34.88-2.75s-.72-2.94-1.1-4.41c-.61-2.41-1.36-4.78-2.07-7.15a.77.77,0,0,0-.52.16c-2.49,1.25-5,2.51-7.48,3.75a9.87,9.87,0,0,0-3.39,2.69l-.62.75-3.31,4.08A.91.91,0,0,0,302.11,252.27Zm-57-41.6a1.22,1.22,0,0,0-.53-.58,37.43,37.43,0,0,1-8.48-9.65,57.59,57.59,0,0,1-5.31-11.36c-.64-1.86-1.24-3.72-1.76-5.61-.06-.22,0-.49-.28-.63a4.52,4.52,0,0,0-1.12,2.37,6.36,6.36,0,0,0,.15,2.57c.35,1.44.74,2.87,1.11,4.31a21.1,21.1,0,0,0,1.53,4,54.64,54.64,0,0,0,7,10.75c.6.73,1.27,1.42,1.92,2.11a9.58,9.58,0,0,0,1.41,1.21,3.92,3.92,0,0,0,1.64.66A7.57,7.57,0,0,0,245.15,210.67Zm46.62,2.44,2.61-1.22a90.6,90.6,0,0,1,13.68-5.34c.19-.05.42-.05.54-.26a14.73,14.73,0,0,0-1-4.33c-.3.09-.62.15-.93.26a9.85,9.85,0,0,0-1.06.44c-.56.29-1.1.6-1.63.93a93.8,93.8,0,0,0-12.07,9.11C291.83,212.77,291.7,212.82,291.77,213.11Zm22.47,13.53a32.16,32.16,0,0,0-3.85,3.06,35.39,35.39,0,0,0,4.39-1.59A11.27,11.27,0,0,0,314.24,226.64Zm-4.4-25.21-1,.32c0,.26.07.47.12.73A2.09,2.09,0,0,0,309.84,201.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M299.12,224.09a21.83,21.83,0,0,0-3.12,2.17,8.57,8.57,0,0,0-2.36,2.85.57.57,0,0,1-.16-.58,4.86,4.86,0,0,1,2.44-3.71,15.72,15.72,0,0,1,2.17-1C298.56,223.65,298.58,223.68,299.12,224.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M334.44,81.29a7,7,0,0,1,2.08,1,21.2,21.2,0,0,1,3.15,2.61,63.83,63.83,0,0,1,6.05,7,153.71,153.71,0,0,1,9.54,14.2,261.8,261.8,0,0,1,19.91,40.59,131.05,131.05,0,0,1,4.61,14,52,52,0,0,1,1.56,8,16.63,16.63,0,0,1,0,4.17,4.77,4.77,0,0,1-.47,1.53,2.14,2.14,0,0,1-2.4,1.28,5.46,5.46,0,0,1-1.9-.74,15.26,15.26,0,0,1-2.64-1.95,40.75,40.75,0,0,1-3.74-3.81,107,107,0,0,1-8.23-11,230.16,230.16,0,0,1-13.28-22.79,251.4,251.4,0,0,1-11.91-26.67,127.91,127.91,0,0,1-4.16-13,49.94,49.94,0,0,1-1.5-8,16.5,16.5,0,0,1,0-3.65,5.44,5.44,0,0,1,.5-1.7,2.16,2.16,0,0,1,2.57-1.24Zm19.82,61.8c.09.17.17.33.26.48,1.4,2.52,2.86,5,4.36,7.46a149.16,149.16,0,0,0,9.76,14.27,54.77,54.77,0,0,0,5.77,6.41,16.7,16.7,0,0,0,2.45,1.92,5,5,0,0,0,1.61.73c.68.16,1,0,1.26-.65a5.41,5.41,0,0,0,.36-1.64,18.13,18.13,0,0,0-.08-3.21,49,49,0,0,0-1.29-6.9,125.38,125.38,0,0,0-4.36-13.66A261.43,261.43,0,0,0,351,101.71a123.28,123.28,0,0,0-8.21-11.43,46.53,46.53,0,0,0-5.18-5.51,12.68,12.68,0,0,0-2.3-1.68,6.7,6.7,0,0,0-1.13-.5c-.78-.25-1.17,0-1.44.73a6.52,6.52,0,0,0-.33,1.75,23.6,23.6,0,0,0,.41,5.31,78.74,78.74,0,0,0,2.72,10.7,201.67,201.67,0,0,0,9.29,23.43,1.08,1.08,0,0,0,.36.54l.83-.18a8.87,8.87,0,0,1,1.85-.19,3.11,3.11,0,0,1,2,.67,8.83,8.83,0,0,1,.87.75,13.63,13.63,0,0,1,1.53,1.86,35.24,35.24,0,0,1,3.62,6.84c.3.7.55,1.44.8,2.17a5.87,5.87,0,0,1,.34,1.56,3.14,3.14,0,0,1-.48,2A8.66,8.66,0,0,1,354.26,143.09Zm-.62-1.34a12.68,12.68,0,0,0,1.38-1.68,2,2,0,0,0,.35-1.76c-.14-.48-.26-1-.43-1.45a47.8,47.8,0,0,0-2.26-5.13,24.8,24.8,0,0,0-1.94-3.3,10.06,10.06,0,0,0-1.44-1.69,2.06,2.06,0,0,0-1.23-.67,5.54,5.54,0,0,0-2.35.29c.48,1.42,4.62,9.65,7.46,14.8C353.29,141.36,353.35,141.61,353.64,141.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "369.17 97.16 382.57 39.92 401.52 48.82 369.17 97.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "381.4 119.62 410.67 83.61 428.23 111.13 381.4 119.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "394.88 142.45 426.93 143.11 424.96 153.52 394.88 142.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M228.2,386.24l-.82-1a4.18,4.18,0,0,0,.26-1.45c0-2.63-2.47-4.77-5.51-4.77s-5.52,2.14-5.52,4.77,2.47,4.76,5.52,4.76a6,6,0,0,0,3.91-1.4l1.41.3A.75.75,0,0,0,228.2,386.24Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarketing);
export default __webpack_public_path__ + "static/media/digitalMarketing.99591cc324d7bed5f5568edb2124e6e1.svg";
export { ForwardRef as ReactComponent };